/// <reference path="MapOptionsInterface.ts" />
/// <reference path="../../../index.d.ts" />
/// <reference types="@types/googlemaps" />

import {MapSVG} from "../Core/globals.js"
import {DefaultOptions} from "./default-options.js"
import {tinycolor} from "../Vendor/tinycolor.js"
import {MapsRepository} from "./MapsRepository"
import {MapsV2Repository} from "./MapsV2Repository"
// import {Handlebars} from "../../handlebars.js"
// @ts-ignore
import Handlebars from "Handlebars";
import {} from 'googlemaps';
import {ResizeSensor} from '../Core/ResizeSensor'
import {
    GroupOptionsInterface,
    LayersControlOptionsInterface,
    MapOptionsInterface,
    ViewBox,
    GeoViewBox
} from "./MapOptionsInterface";

import {
    Location,
    GeoPoint,
    ScreenPoint,
    LocationOptionsInterface,
    SVGPoint
} from "../Location/Location"
import {Marker} from "../Marker/Marker"
import {MarkerCluster} from "../MarkerCluster/MarkerCluster"
import {Region} from "../Region/Region";
import {Query} from "../Infrastructure/Server/Query";
import {CustomObject} from "../Object/CustomObject";
import {Schema} from "../Infrastructure/Server/Schema";
import {SchemaField} from "../Infrastructure/Server/SchemaField";
import {SchemaRepository} from "../Infrastructure/Server/SchemaRepository";
import {DirectoryController} from "../Directory/Directory";
import {Events} from "../Core/Events";
import {Repository} from "../Core/Repository";
import {CustomObjectsRepository} from "../Object/CustomObjectsRepository";
import {FiltersController} from "../Filters/Filters";
import { MapObject } from "../MapObject/MapObject";
import {DetailsController} from "../Details/Details";
import {PopoverController} from "../Popover/Popover";
import {FormBuilder} from "../FormBuilder/FormBuilder";
import {ArrayIndexed} from "../Core/ArrayIndexed";
import {Server} from "../Infrastructure/Server/Server"
import htmlString = JQuery.htmlString;

const $ = jQuery;

/**
 * MapSVG.Map class. Creates a new map inside of the given HTML container, which is typically a DIV element.
 * @constructor
 *
 * @param {string} id - ID of the map container
 * @param {MapOptionsInterface} options - map settings
 *
 * @example
 * // Create the map in <div id="my-container-id"></div>:
 * var mapsvg = new MapSVG.Map("my-container-id", {
 *   source: "/path/to/map.svg",
 *   zoom: {on: true},
 *   scroll: {on: true}
 * });
 *
 * // Get map instance by container ID
 * var mapsvg = MapSVG.getById("my-container-id");
 *
 * // Get map instance by index number
 * var mapsvg_1 = MapSVG.get(0); // first map on the page
 * var mapsvg_2 = MapSVG.get(1); // second map.
 *
 */
class MapSVGMap {

    //static MapSVG = MapSVG;

    id: number|string;
    containerId: string;
    markerOptions: object = {'src': MapSVG.urls.root+'markers/pin1_red.png'};

    dirtyFields: string[];

    regions: ArrayIndexed<Region>;
    objects: ArrayIndexed<CustomObject>;

    regionsRepository: Repository;
    objectsRepository: Repository;
    filtersRepository: Repository;
    schemaRepository: SchemaRepository;

    events: Events;

    resizeSensor: ResizeSensor;

    liveCss: HTMLStyleElement;

    defaults: MapOptionsInterface;
    options: MapOptionsInterface;
    optionsDelta: {[key:string]: any};

    mapIsGeo: boolean;
    geoCoordinates: boolean;
    editMode: boolean;
    highlightedRegions: Array<Region>;
    editRegions: {on: boolean};
    editMarkers: {on: boolean};
    clickAddsMarker: boolean;
    editData: {on: boolean};
    disableLinks: boolean;
    markerEditHandler: Function;
    regionEditHandler: Function;
    region_clicked: Region;
    highlighted_marker: Marker;

    googleMaps?: {
        loaded: boolean,
        map: any,
        zoomLimit?: boolean,
        overlay?: any;
        initialized: boolean;
    };

    groups: Array<GroupOptionsInterface>;

    svgDefault: {
        viewBox?: ViewBox,
        geoViewBox?: GeoViewBox,
        width?: number,
        height?: number
    }

    viewBox: ViewBox;
    _viewBox: ViewBox;
    viewBoxFull: ViewBox;
    viewBoxFake: ViewBox;
    whRatioFull: number;
    geoViewBox?: GeoViewBox;

    mapLonDelta: number;
    mapLatBottomDegree: number;


    zoomLevel: number;
    _zoomLevel: number;
    zoomLevels: ArrayIndexed<{
            zoomLevel: number,
            viewBox: ViewBox,
            _scale: number
        }>;
    isZooming: boolean;
    touchZoomStart: boolean;
    scaleDistStart: number;
    scrollStarted: boolean;

    isScrolling: boolean;
    zoomDelta: number;
    whRatio: number;
    vbStart: boolean;

    scale: number;
    _scale: number;
    superScale: number;
    scroll: {
        tx?: number, ty?: number,
        vxi?: number, vyi?: number, // initial viewbox when scrollning started
        x?: number, y?: number, // mouse coordinates when scrolling started
        dx?: number, dy?: number, // mouse delta
        vx?: number, vy?: number, // new viewbox x/y
        gx?: number, gy?: number, // for google maps scroll
        touchScrollStart: number
    };

    iosDownscaleFactor: number;

    containers: {
        svg?: SVGSVGElement,
        map?: HTMLElement,
        googleMaps?: HTMLElement,
        mapContainer?: HTMLElement,
        scrollpane?: HTMLElement,
        wrap?: HTMLElement,
        wrapAll?: HTMLElement,
        loading?: HTMLElement,
        directory?: HTMLElement,
        filters?: HTMLElement,
        detailsView?: HTMLElement,
        popover?: HTMLElement,
        tooltip?: HTMLElement,
        layers?: HTMLElement,
        layersControl?: HTMLElement,
        layersControlLabel?: HTMLElement,
        layersControlList?: HTMLElement,
        layersControlListNano?: HTMLElement,
        pagerMap?: HTMLElement,
        pagerDir?: HTMLElement,
        leftSidebar?: HTMLElement,
        rightSidebar?: HTMLElement,
        header?: HTMLElement,
        footer?: HTMLElement,
        filterTags?: HTMLElement,
        filtersModal?: HTMLElement,
        clustersCss?: HTMLStyleElement,
        clustersHoverCss?: HTMLStyleElement,
        markersCss?: HTMLStyleElement,
        controls?: HTMLElement,
        zoomButtons?: HTMLElement,
        legend?: {
            title: HTMLElement,
            text: HTMLElement,
            coloring: HTMLElement,
            description: HTMLElement,
            container: HTMLElement
        },
        choroplethSourceSelect?: {
            container: HTMLElement,
            //label: HTMLElement,
            select: HTMLElement,
            options: Array<HTMLElement>
        }
    };
    containersCreated: boolean;

    controllers: {
        detailsView?: DetailsController,
        popover?: PopoverController,
        directory?: DirectoryController,
        // TODO add tooltip controller
        tooltip?: any,
        filters?: FiltersController
    };

    templates: {
        [key: string]: Function // returned by Handlebars.compile()
    }

    markers: ArrayIndexed<Marker>;
    clusters: object;
    markersClusters: ArrayIndexed<MarkerCluster>;
    firstDataLoad: boolean;
    clustersByZoom: Array<any>;
    selected_id: Array<string>;
    selected_marker: Marker;
    clusterizerWorker: Worker;
    editingMarker: Marker;

    filtersSchema: Schema;

    layers: {
        [key: string]: HTMLElement
    };
    controls: {
        zoom: HTMLElement,
        userLocation: HTMLElement,
        zoomReset: HTMLElement
    };
    formBuilder: any;
    tooltip: {posOriginal: {[key: string]: string}, posShifted: {[key: string]: string}, posShiftedPrev: {[key: string]: string}, mirror: {[key: string]: number}}
    firefoxScroll: {
        insideIframe: boolean;
        scrollX: number;
        scrollY: number;
    };
    canZoom: boolean;
    eventsPreventList: {[key: string]: boolean};
    googleMapsScript: HTMLScriptElement;

    fitOnDataLoadDone: boolean;
    fitDelta: number;
    lastTimeFitWas: number;
    userLocation: Location;
    userLocationMarker: Marker;
    setMarkersByField: boolean;
    locationField: SchemaField;
    popoverShowingFor: MapObject;

    svgFileLastChanged: number;


    constructor(containerId: string, map: {id: number, options: MapOptionsInterface, svgFileLastChanged: number, version: string}) {

        var options = map.options;

        this.updateOutdatedOptions(options);

        this.dirtyFields = [];
        
        this.containerId = containerId;
        this.options     = <MapOptionsInterface>$.extend(true, {}, DefaultOptions, options);

        // cut domain to avoid cross-domain errors
        if(this.options.source.indexOf('//')===0)
            this.options.source = this.options.source.replace(/^\/\/[^\/]+/, '').replace('//','/');
        else
            this.options.source = this.options.source.replace(/^.*:\/\/[^\/]+/, '').replace('//','/');

        this.editMode = this.options.editMode;
        delete this.options.editMode;

        this.id = map.id;
        this.svgFileLastChanged = map.svgFileLastChanged;

        this.regions = new ArrayIndexed('id');
        this.objects = new ArrayIndexed('id');

        this.events = new Events(this);

        this.highlightedRegions = [];
        this.editRegions = {on:false};
        this.editMarkers = {on:false};
        this.editData    = {on:false};

        this.controllers = {};

        // Set containers
        this.containers = {
            map: document.getElementById(this.containerId),
            scrollpane: $('<div class="mapsvg-scrollpane"></div>')[0],
            layers: $('<div class="mapsvg-layers-wrap"></div>')[0]
        };

        this.containers.map.appendChild(this.containers.scrollpane);
        this.containers.scrollpane.appendChild(this.containers.layers);

        this.whRatio = 0;
        this.isScrolling = false;
        this.markerOptions = {};
        this.svgDefault = {};
        this.scale  = 1;         // absolute scale
        this._scale = 1;         // relative scale starting from current zoom level
        this.selected_id    = [];

        this.regions           = new ArrayIndexed('id');

        if(!this.options.database.regionsTableName){
            this.options.database.regionsTableName = 'regions_'+this.id;
        }
        if(!this.options.database.objectsTableName){
            this.options.database.objectsTableName = 'objects_'+this.id;
        }

        this.regionsRepository = new Repository('region', 'regions/'+this.options.database.regionsTableName);
        // Turn off pagination for Regions:
        this.regionsRepository.query.update({perpage: 0});

        this.objectsRepository = new Repository('object', 'objects/'+this.options.database.objectsTableName);
        this.objectsRepository.query.update({perpage: this.options.database.pagination.perpage});

        this.schemaRepository  = new SchemaRepository();

        this.markers         = new ArrayIndexed('id');
        this.markersClusters = new ArrayIndexed('id');
        this._viewBox       = new ViewBox(0,0,0,0); // initial viewBox
        this.viewBox        = new ViewBox(0,0,0,0); // current viewBox
        this.zoomLevel      = 0;
        this.scroll         = {
            tx: 0, ty: 0,
            vxi: 0, vyi: 0, // initial viewbox when scrollning started
            x: 0, y: 0, // mouse coordinates when scrolling started
            dx: 0, dy: 0, // mouse delta
            vx: 0, vy: 0, // new viewbox x/y
            gx: 0, gy: 0, // for google maps scroll
            touchScrollStart: 0
        };
        this.layers         = {};
        this.geoCoordinates = false;
        this.geoViewBox     = new GeoViewBox(new GeoPoint(0,0), new GeoPoint(0,0));
        this.eventsPreventList  = {};
        this.googleMaps     = {loaded: false, initialized: false, map: null, zoomLimit: true};


        this.init();
    }

    /**
     * Sets visiblity switches for groups of SVG objects
     * @private
     */
    setGroups(groups?: GroupOptionsInterface[]){
        let _this = this;

        if(!this.groups){
            _this.groups = new ArrayIndexed('id', _this.options.groups, {autoId: true, unique: true});
        } else {
            this.options.groups = this.groups;
        }

        _this.groups.forEach(function(g: GroupOptionsInterface){
            g.objects && g.objects.length && g.objects.forEach(function(obj){
                _this.containers.svg.querySelector('#'+obj.value).classList.toggle('mapsvg-hidden', !g.visible);
            });
        });
    }



    /**
     * Returns the list of options for visibility settings in admin.js
     */
    getGroupSelectOptions(){
        var _this = this;
        var id;
        var optionGroups = [];
        var options = [];
        var options2 = [];

        $(_this.containers.svg).find('g').each(function(index){
            var id = $(this)[0].getAttribute('id');
            if(id){
                var title = $(this)[0].getAttribute('title');
                options.push({label: title, value: id});
            }
        });
        optionGroups.push({title: "SVG Layers / Groups", options: options});

        $(_this.containers.svg).find('path,ellipse,circle,polyline,polygon,rectangle,img,text').each(function(index){
            var id = $(this)[0].getAttribute('id');
            if(id){
                var title = $(this)[0].getAttribute('title');
                options2.push({label: title, value: id});
            }
        });
        optionGroups.push({title: "Other SVG objects", options: options2});


        return optionGroups;
    }

    /**
     * Sets visibility switches
     * @param {object} options - Options
     * @private
     */
    setLayersControl (options?: LayersControlOptionsInterface) {

        var _this = this;

        if (options)
            $.extend(true, this.options.layersControl, options);

        if (this.options.layersControl.on) {
            if (!this.containers.layersControl) {
                this.containers.layersControl = document.createElement('div');
                this.containers.layersControl.classList.add('mapsvg-layers-control');

                this.containers.layersControlLabel = document.createElement('div');
                this.containers.layersControlLabel.classList.add('mapsvg-layers-label');
                this.containers.layersControl.appendChild(this.containers.layersControlLabel);

                let layersControlWrap = document.createElement('div');
                layersControlWrap.classList.add('mapsvg-layers-list-wrap');
                this.containers.layersControl.appendChild(layersControlWrap);

                this.containers.layersControlListNano = document.createElement('div');
                this.containers.layersControlListNano.classList.add('nano');
                layersControlWrap.appendChild(this.containers.layersControlListNano);

                this.containers.layersControlList = document.createElement('div');
                this.containers.layersControlList.classList.add('mapsvg-layers-list');
                this.containers.layersControlList.classList.add('nano-content');
                this.containers.layersControlListNano.appendChild(this.containers.layersControlList);

                this.containers.mapContainer.appendChild(this.containers.layersControl);
            }
            this.containers.layersControl.style.display = 'block';
            this.containers.layersControlLabel.innerHTML = this.options.layersControl.label;

            this.containers.layersControlLabel.style.display = 'block';
            this.containers.layersControlList.innerHTML = '';
            while (this.containers.layersControlList.firstChild) {
                this.containers.layersControlList.removeChild(this.containers.layersControlList.firstChild);
            }
            this.containers.layersControl.classList.remove('mapsvg-top-left', 'mapsvg-top-right', 'mapsvg-bottom-left', 'mapsvg-bottom-right');
            this.containers.layersControl.classList.add('mapsvg-' + this.options.layersControl.position);
            if (this.options.menu.on && !this.options.menu.customContainer && this.options.layersControl.position.indexOf('left') !== -1) {
                this.containers.layersControl.style.left = this.options.menu.width;
            }

            this.containers.layersControl.style.maxHeight = this.options.layersControl.maxHeight;

            this.options.groups.forEach((g) => {
                let item = document.createElement('div');
                item.classList.add('mapsvg-layers-item');
                item.setAttribute('data-group-id', g.id);
                item.innerHTML = '<input type="checkbox" class="ios8-switch ios8-switch-sm" ' + (g.visible ? 'checked' : '') + ' /><label>' + g.title + '</label>';
                this.containers.layersControlList.appendChild(item);
            });

            // @ts-ignore
            $(this.containers.layersControlListNano).nanoScroller({
                preventPageScrolling: true,
                iOSNativeScrolling: true
            });

            $(this.containers.layersControl).off();
            $(this.containers.layersControl).on('click', '.mapsvg-layers-item', function () {
                var id = $(this).data('group-id');
                var input = $(this).find('input');
                input.prop('checked', !input.prop('checked'));
                _this.groups.forEach(function (g) {
                    if (g.id === id) g.visible = !g.visible;
                });
                _this.setGroups();
            });
            $(this.containers.layersControlLabel).on('click', () => {
                $(_this.containers.layersControlLabel).toggleClass('closed');
            });

            $(this.containers.layersControlLabel).toggleClass('closed', !this.options.layersControl.expanded);

        } else {
            if (this.containers.layersControl) {
                this.containers.layersControl.style.display = 'none';
            }
        }
    }

    loadDataObjects(params?: any){
        return this.objectsRepository.find(params);
    }

    loadDirectory(){

        // If "Load DB on start" is off then
        // don't load directory to prevent 'no records found' message from appearing
        if(!this.editMode && this.options.menu.source === 'database' && this.objectsRepository.getLoaded().length === 0){
            return false;
        }
        if(this.options.menu.on){
            this.controllers.directory.loadItemsToDirectory();
        }
        this.setPagination();

    }

    /**
     * Adds pagination controls to the map and/or directory
     */
    setPagination (){
        var _this = this;

        (this.containers.pagerMap) && $(this.containers.pagerMap).empty().remove();
        (this.containers.pagerDir) && $(this.containers.pagerDir).empty().remove();

        if(_this.options.database.pagination.on && _this.options.database.pagination.perpage !== 0){

            this.containers.directory.classList.toggle('mapsvg-with-pagination', (['directory','both'].indexOf(_this.options.database.pagination.showIn)!==-1));
            this.containers.map.classList.toggle('mapsvg-with-pagination', (['map','both'].indexOf(_this.options.database.pagination.showIn)!==-1));

            if(_this.options.menu.on){
                this.containers.pagerDir = _this.getPagination();
                _this.controllers.directory.addPagination(this.containers.pagerDir);
            }
            this.containers.pagerMap = _this.getPagination();
            this.containers.map.appendChild(this.containers.pagerMap);
        }
    }
    /**
     * Generates HTML with pagination buttons and attaches callback event on button click
     * @param {function} callback - Callback function that should be called on click on a next/prev page button
     */
    getPagination (callback?: Function): HTMLElement{
        var _this = this;

        // pager && (pager.empty().remove());
        var pager = $('<nav class="mapsvg-pagination"><ul class="pager"><!--<li class="mapsvg-first"><a href="#">First</a></li>--><li class="mapsvg-prev"><a href="#">&larr; '+_this.options.database.pagination.prev+' '+_this.options.database.pagination.perpage+'</a></li><li class="mapsvg-next"><a href="#">'+_this.options.database.pagination.next+' '+_this.options.database.pagination.perpage+' &rarr;</a></li><!--<li class="mapsvg-last"><a href="#">Last</a></li>--></ul></nav>');

        if(this.objectsRepository.onFirstPage() && this.objectsRepository.onLastPage()){
            pager.hide();
        }else{
            pager.find('.mapsvg-prev').removeClass('disabled');
            pager.find('.mapsvg-first').removeClass('disabled');
            pager.find('.mapsvg-last').removeClass('disabled');
            pager.find('.mapsvg-next').removeClass('disabled');

            this.objectsRepository.onLastPage() &&
            (pager.find('.mapsvg-next').addClass('disabled') && pager.find('.mapsvg-last').addClass('disabled'));

            this.objectsRepository.onFirstPage() &&
            (pager.find('.mapsvg-prev').addClass('disabled') && pager.find('.mapsvg-first').addClass('disabled'));
        }

        pager.on('click','.mapsvg-next:not(.disabled)', (e) => {
            e.preventDefault();
            if(this.objectsRepository.onLastPage())
                return;
            var query = new Query({page: this.objectsRepository.query.page+1});
            this.objectsRepository.find(query).done(function(){
                callback && callback();
            });
        }).on('click','.mapsvg-prev:not(.disabled)',function(e){
            e.preventDefault();
            if(_this.objectsRepository.onFirstPage())
                return;
            var query = new Query({page: _this.objectsRepository.query.page-1});
            _this.objectsRepository.find(query).done(function(){
                callback && callback();
            });
        }).on('click','.mapsvg-first:not(.disabled)',function(e){
            e.preventDefault();
            if(_this.objectsRepository.onFirstPage())
                return;
            var query = new Query({page: 1});
            _this.objectsRepository.find(query).done(function(){
                callback && callback();
            });
        }).on('click','.mapsvg-last:not(.disabled)',function(e){
            e.preventDefault();
            if(_this.objectsRepository.onLastPage())
                return;
            let query = new Query({lastpage: true});
            _this.objectsRepository.find(query).done(function(){
                callback && callback();
            });
        });

        return pager[0];
    }

    /**
     * Deletes all markers from the map
     */
    deleteMarkers(){
        this.markers.forEach((marker: Marker)=> marker.delete());
        this.markers.clear();
    }

    /**
     * Deletes all markers from the map
     */
    deleteClusters(){
        if(this.markersClusters){
            this.markersClusters.forEach(function(markerCluster){
                markerCluster.destroy();
            });
            this.markersClusters.clear();
        }
    }

    /**
     * Adds locations from the database to the map - as markers or as clusters if clustering is enabled.
     * @private
     */
    addLocations(){
        var _this = this;
        this.firstDataLoad = this.firstDataLoad === undefined;

        var locationField = this.objectsRepository.getSchema().getFieldByType('location');
        if(!locationField){
            return false;
        }
        locationField = locationField.name;

        if(locationField) {

            if(this.firstDataLoad){
                this.setMarkerImagesDependency();
            }

            _this.deleteMarkers();
            _this.deleteClusters();

            _this.clusters = {};
            _this.clustersByZoom = [];
            _this.deleteClusters();

            if(this.objectsRepository.getLoaded().length > 0){
                this.objectsRepository.getLoaded().forEach(function(object){
                    if(object[locationField]){
                        if(object[locationField].geoPoint || object[locationField].svgPoint){
                            new Marker({
                                location: object[locationField],
                                object: object,
                                mapsvg: _this
                            });
                        }
                    }
                });
                if(_this.options.clustering.on){
                    _this.startClusterizer();
                } else {
                    this.objectsRepository.getLoaded().forEach(function(object){
                        if(object.location && object.location.marker){
                            _this.markerAdd(object.location.marker);
                        }
                    });
                    _this.mayBeFitMarkers();
                }
            }
        }
    }
    /**
     * Stores a set of markers/clusters for a certain zoom level for later use.
     * This method gets called by a worker thread that calculates markers/clusters for all zoom levels.
     * @param zoomLevel
     * @param clusters
     * @private
     */
    addClustersFromWorker (zoomLevel: number, clusters){

        var _this = this;

        _this.clustersByZoom[zoomLevel] = [];
        for(var cell in clusters){
            var markers = clusters[cell].markers.map(function(marker){
                // TODO check this, looks broken
                return _this.objectsRepository.objects.findById(marker.id).location.marker;
            });
            _this.clustersByZoom[zoomLevel].push( new MarkerCluster({
                markers: markers,
                svgPoint: new SVGPoint(clusters[cell].x, clusters[cell].y),
                cellX: clusters[cell].cellX,
                cellY: clusters[cell].cellY
            }, _this));

        }
        if(_this.zoomLevel === zoomLevel){
            _this.clusterizeMarkers();
        }
    }
    /**
     * Starts clusterizer worker in a separate thread
     * @private
     */
    startClusterizer (){

        var _this = this;

        if(!_this.objectsRepository || _this.objectsRepository.getLoaded().length === 0){
            return;
        }
        var locationField = _this.objectsRepository.getSchema().getFieldByType('location');
        if(!locationField){
            return false;
        }

        if(!_this.clusterizerWorker){
            _this.clusterizerWorker = new Worker(MapSVG.urls.root+"js/mapsvg/Core/clustering.js");

            // Receive messages from postMessage() calls in the Worker
            _this.clusterizerWorker.onmessage = function(evt) {
                if(evt.data.clusters){
                    _this.addClustersFromWorker(evt.data.zoomLevel, evt.data.clusters);
                }
            };
        }

        // Pass data to the WebWorker
        var objectsData = [];
        _this.objectsRepository.getLoaded().forEach(function(o){
            objectsData.push({id: o.id, x: o.location ? o.location.marker.svgPoint.x : null, y: o.location ? o.location.marker.svgPoint.y : null})
        })
        _this.clusterizerWorker.postMessage({
            objects: objectsData,
            cellSize: 50,
            mapWidth: $(_this.containers.map).width(),
            zoomLevels: _this.zoomLevels,
            zoomLevel: _this.zoomLevel,
            zoomDelta: _this.zoomDelta,
            svgViewBox: _this.svgDefault.viewBox
        });

        _this.events.on("zoom", function(){
            _this.clusterizerWorker.postMessage({
                message: "zoom",
                zoomLevel: _this.zoomLevel
            });
        });

    }
    /**
     * Starts clustering markers on the map
     * @property {boolean} skipFitMarkers - Don't do "fit markers" action. Used to prevent fitting markers
     * on changinh zoom level.
     * @private
     */
    clusterizeMarkers (skipFitMarkers?: boolean){
        var _this = this;

        $(_this.layers.markers).children().each(function(i,obj){
            $(obj).detach();
        });
        _this.markers.clear();
        _this.markersClusters.clear();

        // $(_this.containers.map).addClass('no-transitions-markers');

        _this.clustersByZoom && _this.clustersByZoom[_this.zoomLevel] && _this.clustersByZoom[_this.zoomLevel].forEach(function(cluster){

            // Don't clusterize on google maps with zoom level >= 17
            if(_this.options.googleMaps.on && _this.googleMaps.map && _this.googleMaps.map.getZoom()>=17){
                _this.markerAdd(cluster.markers[0]);

            } else {
                if(cluster.markers.length > 1) {
                    _this.markersClusterAdd(cluster);
                } else {
                    _this.markerAdd(cluster.markers[0]);
                }
            }
        });

        if(_this.editingMarker){
            _this.markerAdd(_this.editingMarker);
        }

        if(!skipFitMarkers){
            _this.mayBeFitMarkers();
        }

        if(_this.options.labelsMarkers.on){
            _this.setLabelsMarkers();
        }

        // $(_this.containers.map).removeClass('no-transitions-markers');
    }
    /**
     * Returns URL of the mapsvg.css file
     * @returns {string} URL
     * @private
     */
    getCssUrl(){
        var _this = this;
        return MapSVG.urls.root+'css/mapsvg.css';
    }
    /**
     * Checks if the map is geo-calibrated
     * @returns {boolean}
     */
    isGeo(){
        var _this = this;
        return _this.mapIsGeo;
    }
    /**
     * Converts a string to function
     * @param string
     * @returns {function|object} Function or object {error: "error text"}
     * @private
     *
     */
    functionFromString(string: string): Function|{error: string} {
        var _this = this;
        var func;
        var error = {error: ''};
        var fn = string.trim();
        if(fn.indexOf("{")==-1 || fn.indexOf("function")!==0 || fn.indexOf("(")==-1){
            return {error: "MapSVG user function error: no function body."};
        }
        var fnBody = fn.substring(fn.indexOf("{") + 1, fn.lastIndexOf("}"));
        var params = fn.substring(fn.indexOf("(") + 1, fn.indexOf(")"));
        try{
            func = new Function(params,fnBody);
        }catch(err){
            error = err;
        }

        if (!error.error)
            return func;
        else
            return error;//{error: {line: error.line, text: "MapSVG user function error: (line "+error.line+"): "+error.message}};
    }
    /**
     * Returns map options.
     * @param {bool} forTemplate - If options should be formatted for use in a template
     * @param {bool} forWeb - If options should be formatted for use in the web
     * @param {object} optionsDelta - used by backend WP admin only, part of options from the previous view mode
     * @returns {object}
     */
    getOptions(forTemplate: boolean, forWeb: boolean) {

        var _this = this;

        var options = <MapOptionsInterface>$.extend(true, {}, _this.options);

        $.extend(true, options, this.optionsDelta);

        options.viewBox = _this._viewBox.toArray();
        options.filtersSchema = _this.filtersSchema.getFieldsAsArray();
        if (options.filtersSchema.length > 0) {
            options.filtersSchema.forEach(function (field) {
                if (field.type === 'distance') {
                    field.value = '';
                }
            });
        }

        // @ts-ignore - old options field from MapSVG versions <5.x
        delete options.markers;

        if (forTemplate){
            // @ts-ignore - may this needs to be removed?
            options.svgFilename = options.source.split('/').pop();
            // @ts-ignore - may this needs to be removed?
            options.svgFiles = MapSVG.svgFiles;
        }

        if(forWeb)
            $.each(options,function(key,val){
                if(JSON.stringify(val) == JSON.stringify(_this.defaults[key]))
                    delete options[key];
            });
        delete options.backend;

        return options;
    }

    /**
     * Restore delta options, used by MapSVG-Admin
     * @private
     */
    restoreDeltaOptions(): void {
        this.update(this.optionsDelta);
        this.optionsDelta = {};
    }

    /**
     * Sets event handlers
     * @param {object} functions - Callbacks {eventName, eventName, ...}
     */
    setEvents(functions: {[key: string]: string|Function}){

        // TODO add namespaces for events as done in jQuery

        var _this = this;
        let compiledFunction;

        for (var eventName in functions) {

            if (typeof functions[eventName] === 'string') {
                compiledFunction = functions[eventName] != "" ? <Function>this.functionFromString(<string>functions[eventName]) : null;
                if (!compiledFunction || compiledFunction.error || (compiledFunction instanceof TypeError || compiledFunction instanceof SyntaxError)){
                    continue;
                }
            } else if(typeof functions[eventName] === 'function') {
                compiledFunction = <Function>functions[eventName];
            }

            // Reset events
            _this.events.off(eventName);
            // Set new event
            _this.events.on(eventName, compiledFunction);

            if(eventName.indexOf('directory')!==-1){
                var event = eventName.split('.')[0];

                if(_this.controllers && _this.controllers.directory){
                    _this.controllers.directory.events.off(event);
                    _this.controllers.directory.events.on(event, compiledFunction);
                }
            }

        }

        $.extend(true, _this.options.events, functions);
    }
    /**
     * Sets map actions that should be performed on Region click. Marker click, etc.
     * @param options
     *
     * @example
     * mapsvg.setActions({
     *   "click.region": {
     *     showPopover: true,
     *     showDetails: false
     *   }
     * })
     */
    setActions (options){
        var _this = this;
        $.extend(true, _this.options.actions, options);
    }
    /**
     * Sets Details View options
     * @param {object} options - Options
     */
    setDetailsView(options?: {[key: string]: any}){

        var _this = this;

        options = options || _this.options.detailsView || {};
        $.extend(true, _this.options.detailsView, options);

        // Since 5.0.0: no top/near locations.
        if(_this.options.detailsView.location === 'top' && _this.options.menu.position === 'left'){
            _this.options.detailsView.location = 'leftSidebar';
        } else if(_this.options.detailsView.location === 'top' && _this.options.menu.position === 'right'){
            _this.options.detailsView.location = 'rightSidebar';
        }
        if(_this.options.detailsView.location === 'near'){
            _this.options.detailsView.location = 'map';
        }

        if(!_this.containers.detailsView){
            _this.containers.detailsView  = $('<div class="mapsvg-details-container"></div>')[0];
        }

        $(_this.containers.detailsView).toggleClass('mapsvg-details-container-relative', !(MapSVG.isPhone && _this.options.detailsView.mobileFullscreen) && !_this.shouldBeScrollable(_this.options.detailsView.location));


        if(_this.options.detailsView.location === 'custom'){
            $('#'+_this.options.detailsView.containerId).append($(_this.containers.detailsView));
        } else {
            if(MapSVG.isPhone && _this.options.detailsView.mobileFullscreen){
                $('body').append($(_this.containers.detailsView));
                $(_this.containers.detailsView).addClass('mapsvg-container-fullscreen')
            }else{
                _this.containers[_this.options.detailsView.location].append(_this.containers.detailsView);
            }
            if(_this.options.detailsView.margin){
                $(_this.containers.detailsView).css('margin',_this.options.detailsView.margin);
            }
            $(_this.containers.detailsView).css('width',_this.options.detailsView.width);
        }
    }
    /**
     * Sets mobile view options
     * @param options
     */
    setMobileView(options){
        var _this = this;
        $.extend(true, _this.options.mobileView, options);
    }
    /**
     * Attaches DB Objects to Regions
     * @param object
     */
    attachDataToRegions(object?: any){
        var _this = this;

        _this.regions.forEach(function(region){
            region.objects = [];
        });

        _this.objectsRepository.getLoaded().forEach(function(obj, index){
            var regions = obj.getRegions(_this.regionsRepository.schema.name);
            if(regions && regions.length){
                regions.forEach(function(region){
                    var r = _this.getRegion(region.id);
                    if(r)
                        r.objects.push(obj);
                });
            }
        });
    }
    /**
     * Sets templates body
     * @param {object} templates - Key:value pairs of template names and HTML content
     */
    setTemplates(templates){
        var _this = this;
        _this.templates = _this.templates || {};
        for (var name in templates){
            if(name != undefined){
                _this.options.templates[name] = templates[name];
                var t = _this.options.templates[name];
                if(name == 'directoryItem' || name == 'directoryCategoryItem'){
                    var dirItemTemplate = _this.options.templates.directoryItem;
                    t = '{{#each items}}<div id="mapsvg-directory-item-{{id}}" class="mapsvg-directory-item" data-object-id="{{id}}">'+dirItemTemplate+'</div>{{/each}}';
                    if(_this.options.menu.categories && _this.options.menu.categories.on && _this.options.menu.categories.groupBy){
                        var t2 = _this.options.templates['directoryCategoryItem'];
                        t = '{{#each items}}{{#with category}}<div id="mapsvg-category-item-{{value}}" class="mapsvg-category-item" data-category-value="{{value}}">'+t2+'</div><div class="mapsvg-category-block" data-category-id="{{value}}">{{/with}}'+t+'</div>{{/each}}';
                    }
                    name = 'directory';
                }


                try {
                    _this.templates[name] = Handlebars.compile(t, {strict: false});
                } catch(err) {
                    console.error(err);
                    _this.templates[name] = Handlebars.compile("", {strict: false});
                }

                if(_this.editMode && ((name == 'directory' || name == 'directoryCategoryItem') && _this.controllers && _this.controllers.directory)){
                    _this.controllers.directory.templates.main = _this.templates[name];
                    _this.loadDirectory();
                }
            }
        }
    }
    // /**
    //  * Sets status of a Region
    //  * @param {Region} region
    //  * @param {number} status
    //  */
    // setRegionStatus (region: Region, status: number){
    //     var _this = this;
    //     var _status = _this.regionsRepository.getSchema().getField('status').options.get(status.toString());
    //     // @ts-ignore
    //     if(_status.disabled)
    //         region.setDisabled(true);
    //     else
    //         region.setDisabled(false);
    //
    //     // @ts-ignore
    //     if(_status.color){
    //         // @ts-ignore
    //         region.setFill(_status.color);
    //     }
    //     else
    //         region.setFill();
    //
    // }
    /**
     * Updates map settings.
     * @param {object} options - Map options
     *
     * @example
     * mapsvg.update({
     *   popovers: {on: true},
     *   colors: {
     *     background: "red"
     *   }
     * });
     */
    update (options){
        var _this = this;
        for (var key in options){
            if (key == "regions"){
                $.each(options.regions,function(id,regionOptions){
                    var region = _this.getRegion(id);
                    region && region.update(regionOptions);
                    if(regionOptions.choroplethValue!=undefined && _this.options.choropleth.on){
                        _this.updateChoroplethMinMax();
                        _this.regionsRedrawColors();
                    }
                    if(regionOptions.disabled!=undefined){
                        _this.deselectRegion(region);
                        // @ts-ignore
                        _this.options.regions[id] = _this.options.regions[id] || {};
                        _this.options.regions[id].disabled = region.disabled;
                    }
                });
            }else if (key == "markers"){
                $.each(options.markers, function(id, markerOptions){
                    var marker = _this.getMarker(id);
                    marker && marker.update(markerOptions);
                });
            }else{
                var setter = 'set'+MapSVG.ucfirst(key);
                if (typeof _this[setter] == 'function')
                    this[setter](options[key]);
                else{
                    _this.options[key] = options[key];
                }
            }
        }
    }

    getDirtyFields(): {[key: string]: any} {
        return this.getData();
    }
    clearDirtyFields(): void {
        this.dirtyFields = [];
    }

    /**
     * Sets map title
     * @param {string} title - Map title
     * @private
     */
    setTitle(title: string): void {
        title && (this.options.title = title);
    }
    /**
     * Adds MapSVG add-ons
     * @param extension
     * @private
     */
    setExtension(extension){
        var _this = this;
        if(extension){
            _this.options.extension = extension;
        }else{
            delete _this.options.extension;
        }
    }
    /**
     * Disables/enables redirection by link on click on a region or marker
     * when "Go to link..." feature is enabled
     * Used to prevent redirection in the map editor.
     * @param {boolean} on - true (enable redirection) of false (disable)
     */
    setDisableLinks(on: boolean){
        var _this = this;
        on = MapSVG.parseBoolean(on);
        if(on){
            $(_this.containers.map).on('click.a.mapsvg','a',function(e){
                e.preventDefault();
            });
        }else{
            $(_this.containers.map).off('click.a.mapsvg');
        }
        _this.disableLinks = on;
    }
    /**
     * Sets loading text message
     * @param {string} val - "Loading map..." text
     */
    setLoadingText(val){
        var _this = this;
        _this.options.loadingText = val
    }
    /**
     * Enable or disable lock aspect ratio. Used in Map Editor.
     * @param {boolean} onoff
     * @private
     */
    setLockAspectRatio(onoff: boolean){
        var _this = this;
        _this.options.lockAspectRatio =  MapSVG.parseBoolean(onoff);
    }
    /**
     * Sets callback for marker click. Used in Map Editor to show an object editing window.
     * @private
     */
    setMarkerEditHandler (handler: Function){
        var _this = this;
        _this.markerEditHandler = handler;
    }
    /**
     * Sets the field that is used for choropleth map
     * @param {string} field - field name
     */
    setChoroplethSourceField (field){
        var _this = this;
        _this.options.choropleth.sourceField = field;
        _this.redrawChoropleth();
    }
    /**
     * Sets callback function that is called on click on a Region.
     * Used in the Map Editor on click on a Region in the "Edit regions" map mode.
     * @param {Function} handler
     */
    setRegionEditHandler (handler: Function){
        this.regionEditHandler = handler;
    }
    /**
     * Disables all Regions if "true" is passed.
     * @param {boolean} on
     */
    setDisableAll(on: boolean){
        on = MapSVG.parseBoolean(on);
        $.extend(true, this.options, {disableAll:on});
        $(this.containers.map).toggleClass('mapsvg-disabled-regions', on);
    }
    /**
     * @private
     */
    setRegionStatuses<T> (_statuses: ArrayIndexed<T>){

        var _this = this;

        // @ts-ignore
        _this.options.regionStatuses = {};
        var colors = {};
        _statuses.forEach(function(statusOptions){
            _this.options.regionStatuses[statusOptions.value] = statusOptions;
            colors[statusOptions.value] = statusOptions.color.length ? statusOptions.color : undefined;
        })
        _this.setColors({status: colors});
    }
    /**
     * @deprecated
     * @private
     */
    setColorsIgnore (val){

        var _this = this;

        _this.options.colorsIgnore = MapSVG.parseBoolean(val);
        _this.regionsRedrawColors();
    }
    /**
     * Adds # hash at the beginning of HEX color value
     * @param {String} color
     * @returns {String}
     * @private
     */
    fixColorHash(color){
        var hexColorNoHash = new RegExp(/^([0-9a-f]{3}|[0-9a-f]{6})$/i);
        if(color && color.match(hexColorNoHash) !== null){
            color = '#'+color;
        }
        return color;
    }
    /**
     * Sets color settings (background, regions, containers, etc.)
     * @param {object} colors
     *
     * @example
     * mapsvg.setColors({
     *   background: "#EEEEEE",
     *   hover: "10",
     *   selected: "20",
     *   leftSidebar: "#FF2233",
     *   detailsView: "#FFFFFF"
     * });
     */
    setColors (colors?: {[key: string]: string|number|object}){

        var _this = this;

        for(var i in colors){
            if(i === 'status'){
                // @ts-ignore
                for(var s in colors[i]){
                    _this.fixColorHash(colors[i][s]);
                }
            } else {
                if(typeof colors[i] == 'string'){
                    _this.fixColorHash(colors[i]);
                }
            }
        }

        $.extend(true, _this.options, {colors:colors});

        if(colors && colors.status)
            _this.options.colors.status = colors.status;

        if(_this.options.colors.markers){
            for(var z in _this.options.colors.markers){
                for(var x in _this.options.colors.markers[z]){
                    _this.options.colors.markers[z][x] = parseInt(_this.options.colors.markers[z][x]);
                }
            }
        }

        if(_this.options.colors.background)
            $(_this.containers.map).css({'background': _this.options.colors.background});
        if(_this.options.colors.hover){
            // @ts-ignore
            _this.options.colors.hover = (_this.options.colors.hover == ""+parseInt(_this.options.colors.hover)) ? parseInt(_this.options.colors.hover) : _this.options.colors.hover;
        }
        if(_this.options.colors.selected) {
            // @ts-ignore
            _this.options.colors.selected = (_this.options.colors.selected == ""+parseInt(_this.options.colors.selected)) ? parseInt(_this.options.colors.selected) : _this.options.colors.selected;
        }

        $(_this.containers.leftSidebar).css({'background-color': _this.options.colors.leftSidebar});
        $(_this.containers.rightSidebar).css({'background-color': _this.options.colors.rightSidebar});
        $(_this.containers.header).css({'background-color': _this.options.colors.header});
        $(_this.containers.footer).css({'background-color': _this.options.colors.footer});


        if($(_this.containers.detailsView) && _this.options.colors.detailsView !== undefined){
            $(_this.containers.detailsView).css({'background-color': _this.options.colors.detailsView});
        }
        if($(_this.containers.directory) && _this.options.colors.directory !== undefined){
            $(_this.containers.directory).css({'background-color': _this.options.colors.directory});
        }
        if($(_this.containers.filtersModal) && _this.options.colors.modalFilters !== undefined){
            $(_this.containers.filtersModal).css({'background-color': _this.options.colors.modalFilters});
        }

        if($(_this.containers.filters) && _this.options.colors.directorySearch){
            $(_this.containers.filters).css({
                'background-color': _this.options.colors.directorySearch
            })
        }else if($(_this.containers.filters)) {
            $(_this.containers.filters).css({
                'background-color': ''
            })
        }

        if(!_this.containers.clustersCss){
            _this.containers.clustersCss = <HTMLStyleElement>$('<style></style>').appendTo('body')[0];
        }
        var css = '';
        if(_this.options.colors.clusters){
            css += "background-color: "+_this.options.colors.clusters+";";
        }
        if(_this.options.colors.clustersBorders){
            css += "border-color: "+_this.options.colors.clustersBorders+";";
        }
        if(_this.options.colors.clustersText){
            css += "color: "+_this.options.colors.clustersText+";";
        }
        $(_this.containers.clustersCss).html(".mapsvg-marker-cluster {"+css+"}");

        if(!_this.containers.clustersHoverCss){
            _this.containers.clustersHoverCss = <HTMLStyleElement>$('<style></style>').appendTo('body')[0];
        }
        var cssHover = "";
        if(_this.options.colors.clustersHover){
            cssHover += "background-color: "+_this.options.colors.clustersHover+";";
        }
        if(_this.options.colors.clustersHoverBorders){
            cssHover += "border-color: "+_this.options.colors.clustersHoverBorders+";";
        }
        if(_this.options.colors.clustersHoverText){
            cssHover += "color: "+_this.options.colors.clustersHoverText+";";
        }
        $(_this.containers.clustersHoverCss).html(".mapsvg-marker-cluster:hover {"+cssHover+"}");

        if(!_this.containers.markersCss){
            _this.containers.markersCss = <HTMLStyleElement>$('<style></style>').appendTo('head')[0];
        }
        var markerCssText = '.mapsvg-with-marker-active .mapsvg-marker {\n' +
            '  opacity: '+_this.options.colors.markers.inactive.opacity/100+';\n' +
            '  -webkit-filter: grayscale('+(100-_this.options.colors.markers.inactive.saturation)+'%);\n' +
            '  filter: grayscale('+(100-_this.options.colors.markers.inactive.saturation)+'%);\n' +
            '}\n' +
            '.mapsvg-with-marker-active .mapsvg-marker-active {\n' +
            '  opacity: '+_this.options.colors.markers.active.opacity/100+';\n' +
            '  -webkit-filter: grayscale('+(100-_this.options.colors.markers.active.saturation)+'%);\n' +
            '  filter: grayscale('+(100-_this.options.colors.markers.active.saturation)+'%);\n' +
            '}\n' +
            '.mapsvg-with-marker-hover .mapsvg-marker {\n' +
            '  opacity: '+_this.options.colors.markers.unhovered.opacity/100+';\n' +
            '  -webkit-filter: grayscale('+(100-_this.options.colors.markers.unhovered.saturation)+'%);\n' +
            '  filter: grayscale('+(100-_this.options.colors.markers.unhovered.saturation)+'%);\n' +
            '}\n' +
            '.mapsvg-with-marker-hover .mapsvg-marker-hover {\n' +
            '  opacity: '+_this.options.colors.markers.hovered.opacity/100+';\n' +
            '  -webkit-filter: grayscale('+(100-_this.options.colors.markers.hovered.saturation)+'%);\n' +
            '  filter: grayscale('+(100-_this.options.colors.markers.hovered.saturation)+'%);\n' +
            '}\n';
        $(_this.containers.markersCss).html(markerCssText);

        $.each(_this.options.colors,function(key, color){
            if(color === null || color == "")
                delete _this.options.colors[key];
        });

        _this.regionsRedrawColors();
    }
    /**
     * Sets tooltips options.
     * @param {object} options
     * @example
     * mapsvg.setTooltips({
     *   on: true,
     *   position: "bottom-left",
     *   maxWidth: "300"
     * })
     */
    setTooltips (options) {

        var _this = this;

        if(options.on !== undefined)
            options.on = MapSVG.parseBoolean(options.on);

        $.extend(true, _this.options, {tooltips: options});

        _this.tooltip = _this.tooltip || {posOriginal: {}, posShifted: {}, posShiftedPrev: {}, mirror: {}};
        _this.tooltip.posOriginal    = {};
        _this.tooltip.posShifted     = {};
        _this.tooltip.posShiftedPrev = {};
        _this.tooltip.mirror         = {};


        if(_this.containers.tooltip){
            _this.containers.tooltip.className = _this.containers.tooltip.className.replace(/(^|\s)mapsvg-tt-\S+/g, '');
        }else{
            _this.containers.tooltip = $('<div />').addClass('mapsvg-tooltip')[0];
            $(_this.containers.map).append(_this.containers.tooltip);
        }


        var ex = _this.options.tooltips.position.split('-');
        if(ex[0].indexOf('top')!=-1 || ex[0].indexOf('bottom')!=-1){
            _this.tooltip.posOriginal.topbottom = ex[0];
        }
        if(ex[0].indexOf('left')!=-1 || ex[0].indexOf('right')!=-1){
            _this.tooltip.posOriginal.leftright = ex[0];
        }
        if(ex[1]){
            _this.tooltip.posOriginal.leftright = ex[1];
        }

        var event = 'mousemove.tooltip.mapsvg-'+$(_this.containers.map).attr('id');
        $(_this.containers.tooltip).addClass('mapsvg-tt-'+_this.options.tooltips.position);

        $(_this.containers.tooltip).css({'min-width': _this.options.tooltips.minWidth+'px', 'max-width': _this.options.tooltips.maxWidth+'px'});

        $('body').off(event).on(event, function(e) {

            MapSVG.mouse = MapSVG.mouseCoords(e);

            _this.containers.tooltip.style.left = (e.clientX + $(window).scrollLeft() - $(_this.containers.map).offset().left) +'px';
            _this.containers.tooltip.style.top  = (e.clientY + $(window).scrollTop()  - $(_this.containers.map).offset().top)  +'px';

            var m = new ScreenPoint(e.clientX + $(window).scrollLeft(), e.clientY + $(window).scrollTop());

            var _tbbox = _this.containers.tooltip.getBoundingClientRect();
            var _mbbox = _this.containers.wrap.getBoundingClientRect();
            var tbbox = {
                top: _tbbox.top + $(window).scrollTop(),
                bottom: _tbbox.bottom + $(window).scrollTop(),
                left: _tbbox.left + $(window).scrollLeft(),
                right: _tbbox.right + $(window).scrollLeft(),
                width: _tbbox.width,
                height: _tbbox.height
            };
            var mbbox = {
                top: _mbbox.top + $(window).scrollTop(),
                bottom: _mbbox.bottom + $(window).scrollTop(),
                left: _mbbox.left + $(window).scrollLeft(),
                right: _mbbox.right + $(window).scrollLeft(),
                width: _mbbox.width,
                height: _mbbox.height
            };

            if(m.x > mbbox.right || m.y > mbbox.bottom || m.x < mbbox.left || m.y < mbbox.top){
                return;
            }

            if(_this.tooltip.mirror.top || _this.tooltip.mirror.bottom){
                // may be cancel mirroring
                if(_this.tooltip.mirror.top && m.y > _this.tooltip.mirror.top){
                    _this.tooltip.mirror.top = 0;
                    delete _this.tooltip.posShifted.topbottom;
                }else if(_this.tooltip.mirror.bottom && m.y < _this.tooltip.mirror.bottom){
                    _this.tooltip.mirror.bottom = 0;
                    delete _this.tooltip.posShifted.topbottom;
                }
            }else{
                // may be need mirroring

                if(tbbox.bottom < mbbox.top + tbbox.height){
                    _this.tooltip.posShifted.topbottom = 'bottom';
                    _this.tooltip.mirror.top    = m.y;
                }else if(tbbox.top > mbbox.bottom - tbbox.height){
                    _this.tooltip.posShifted.topbottom = 'top';
                    _this.tooltip.mirror.bottom = m.y;
                }
            }

            if(_this.tooltip.mirror.right || _this.tooltip.mirror.left){
                // may be cancel mirroring

                if(_this.tooltip.mirror.left && m.x > _this.tooltip.mirror.left){
                    _this.tooltip.mirror.left  = 0;
                    delete _this.tooltip.posShifted.leftright;
                }else if(_this.tooltip.mirror.right && m.x < _this.tooltip.mirror.right){
                    _this.tooltip.mirror.right = 0;
                    delete _this.tooltip.posShifted.leftright;
                }
            }else{
                // may be need mirroring
                if(tbbox.right < mbbox.left + tbbox.width){
                    _this.tooltip.posShifted.leftright = 'right';
                    _this.tooltip.mirror.left = m.x;
                }else if(tbbox.left > mbbox.right - tbbox.width){
                    _this.tooltip.posShifted.leftright = 'left';
                    _this.tooltip.mirror.right = m.x;
                }
            }

            var pos  = $.extend({}, _this.tooltip.posOriginal, _this.tooltip.posShifted);
            var _pos = [];
            pos.topbottom && _pos.push(pos.topbottom);
            pos.leftright && _pos.push(pos.leftright);
            // @ts-ignore
            pos = _pos.join('-');

            if(_this.tooltip.posShifted.topbottom!=_this.tooltip.posOriginal.topbottom  || _this.tooltip.posShifted.leftright!=_this.tooltip.posOriginal.leftright){
                _this.containers.tooltip.className = _this.containers.tooltip.className.replace(/(^|\s)mapsvg-tt-\S+/g, '');
                $(_this.containers.tooltip).addClass('mapsvg-tt-'+pos);
                _this.tooltip.posShiftedPrev = pos;
            }
        });
    }
    /**
     * Sets popover options.
     * @param {object} options
     * @example
     * mapsvg.setPopovers({
     *   on: true,
     *   width: 300, // pixels
     *   maxWidth: 70, // percents of map container
     *   maxHeight: 70, // percents of map container
     *   mobileFullscreen: true
     * });
     */
    setPopovers  (options){

        var _this = this;

        if(options.on !== undefined)
            options.on = MapSVG.parseBoolean(options.on);

        $.extend(_this.options.popovers, options);

        if(!_this.containers.popover) {
            _this.containers.popover = $('<div />').addClass('mapsvg-popover')[0];
            _this.layers.popovers.append(_this.containers.popover);
        }
        $(_this.containers.popover).css({
            width: _this.options.popovers.width + (_this.options.popovers.width == 'auto' ? '' : 'px'),
            'max-width': _this.options.popovers.maxWidth + '%',
            'max-height': _this.options.popovers.maxHeight * $(_this.containers.wrap).outerHeight()/100+'px'
        });

        if(_this.options.popovers.mobileFullscreen && MapSVG.isPhone){
            $('body').toggleClass('mapsvg-fullscreen-popovers', true);
            $(_this.containers.popover).appendTo('body');
        }
    }
    /**
     * Sets region prefix
     * @param {string} prefix
     * @private
     */
    setRegionPrefix (prefix){

        var _this = this;

        _this.options.regionPrefix = prefix;
    }
    /**
     * Sets initial viewbox
     * @param {array} v - [x,y,width,height]
     * @private
     * @deprecated
     */
    setInitialViewBox (v){

        var _this = this;

        if(typeof v == 'string')
            v = v.trim().split(' ').map(function(v){  return parseFloat(v); });
        _this._viewBox = new ViewBox(v);
        if(_this.options.googleMaps.on){
            _this.options.googleMaps.center = _this.googleMaps.map.getCenter().toJSON();
            _this.options.googleMaps.zoom = _this.googleMaps.map.getZoom();
        }
        _this.zoomLevel = 0;
    }
    /**
     * Sets viewbox on map start and calculates initial width/height ratio
     * @private
     */
    setViewBoxOnStart (){

        var _this = this;

        _this.viewBoxFull = _this.svgDefault.viewBox;
        _this.viewBoxFake = _this.viewBox;
        _this.whRatioFull = _this.viewBoxFull.width / _this.viewBox.width;
        _this.containers.svg.setAttribute('viewBox', _this.viewBoxFull.toString());

        if((MapSVG.device.ios || MapSVG.device.android) && _this.svgDefault.viewBox.width>1500){
            _this.iosDownscaleFactor = _this.svgDefault.viewBox.width > 9999 ? 100 : 10;
            _this.containers.svg.style.width = (_this.svgDefault.viewBox.width / _this.iosDownscaleFactor).toString()+'px';
        } else {
            _this.containers.svg.style.width = _this.svgDefault.viewBox.width+'px';
        }

        _this.vbStart = true;
    }
    /**
     * Sets map viewbox
     * @param {ViewBox} viewBox
     * @param {boolean} skipAdjustments - if false is passed, map doesn't get redrawn
     */
    setViewBox (viewBox?: ViewBox, skipAdjustments?: boolean): boolean {

        var _this = this;
        let initial = false;

        if(typeof viewBox === 'undefined' || (viewBox.width === 0 && viewBox.height === 0)){
            viewBox = _this.svgDefault.viewBox;
            initial = true;
        }
        var isZooming = viewBox.width != _this.viewBox.width || viewBox.height != _this.viewBox.height;
        _this.viewBox = viewBox;
        _this.whRatio = _this.viewBox.width / _this.viewBox.height;

        !_this.vbStart && _this.setViewBoxOnStart();

        if(initial){
            if(!_this._viewBox){
                _this._viewBox = _this.viewBox;
            }
            _this._scale = 1;
        }

        var p = _this.options.padding;

        if(p.top){
            _this.viewBox.y -= p.top;
            _this.viewBox.height += p.top;
        }
        if(p.right){
            _this.viewBox.width += p.right;
        }
        if(p.bottom){
            _this.viewBox.height += p.bottom;
        }
        if(p.left){
            _this.viewBox.x -= p.left;
            _this.viewBox.width += p.left;
        }

        _this.scale = _this.getScale();
        _this.superScale = _this.whRatioFull*_this.svgDefault.viewBox.width/_this.viewBox.width;

        var w = _this.svgDefault.viewBox.width / $(_this.containers.map).width();
        _this.superScale = _this.superScale / w;

        if((MapSVG.device.ios || MapSVG.device.android) && _this.svgDefault.viewBox.width>1500){
            _this.superScale *= _this.iosDownscaleFactor;
        }

        _this.scroll.tx = Math.round((_this.svgDefault.viewBox.x-_this.viewBox.x)*_this.scale);
        _this.scroll.ty = Math.round((_this.svgDefault.viewBox.y-_this.viewBox.y)*_this.scale);

        if(isZooming) {
            if(!_this.options.googleMaps.on){
                _this.enableMarkersAnimation();
            }
            // _this.throttle(_this.enableMarkersAnimation, 400, _this);
        }

        _this.containers.scrollpane.style.transform = 'translate('+_this.scroll.tx+'px,'+_this.scroll.ty+'px)';
        _this.containers.svg.style.transform = 'scale('+_this.superScale+')';

        if(isZooming && !skipAdjustments){
            _this.updateSize();
        }

        if(isZooming){
            if(!_this.options.googleMaps.on) {
                setTimeout(function(){
                    _this.disableMarkersAnimation()
                }, 400);
            }
            if(_this.options.clustering.on){
                _this.throttle(_this.clusterizeOnZoom, 400, _this);
            } else {
                _this.events.trigger('zoom');
            }
        }

        return true;
    }
    /**
     * Turns on marker animations
     * @private
     */
    enableMarkersAnimation() {
        $(this.containers.map).removeClass('no-transitions-markers')
    }
    /**
     * Turns off marker animations
     * @private
     */
    disableMarkersAnimation() {
        $(this.containers.map).addClass('no-transitions-markers')
    }
    /**
     * Event handler that clusterizes markers on zoom
     * @event
     * @private
     */

    clusterizeOnZoom(){

        if(this.options.googleMaps.on && this.googleMaps.map && this.zoomDelta) {
            this.zoomLevel = this.googleMaps.map.getZoom() - this.zoomDelta;
        }
        this.events.trigger('zoom');
        this.clusterizeMarkers(true);
    }
    /**
     * Delays method execution.
     * For example, it can be used in search input fields to prevent sending an ajax request on each key press.
     * @param {function} method
     * @param {number} delay
     * @param {object} scope
     * @param {array} params
     * @private
     */
    throttle(method: Function, delay: number, scope: any, params?: any) {
        // @ts-ignore
        clearTimeout(method._tId);
        // @ts-ignore
        method._tId = setTimeout(function(){
            method.apply(scope, params);
        }, delay);
    }
    /**
     * Sets SVG viewBox by Google Maps bounds.
     * Used to overlay SVG map on Google Map.
     */
    setViewBoxByGoogleMapBounds (){

        var _this = this;

        var googleMapBounds = _this.googleMaps.map.getBounds();
        if(!googleMapBounds) return;
        var googleMapBoundsJSON = googleMapBounds.toJSON();

        if(googleMapBoundsJSON.west==-180 && googleMapBoundsJSON.east==180){
            var center = _this.googleMaps.map.getCenter().toJSON();
        }
        var ne = new GeoPoint(googleMapBounds.getNorthEast().lat(), googleMapBounds.getNorthEast().lng());
        var sw = new GeoPoint(googleMapBounds.getSouthWest().lat(), googleMapBounds.getSouthWest().lng());

        var xyNE = _this.convertGeoToSVG(ne);
        var xySW = _this.convertGeoToSVG(sw);

        // Check if map is on border between 180/-180 longitude
        if(xyNE.x < xySW.y){
            var mapPointsWidth = (_this.svgDefault.viewBox.width / _this.mapLonDelta) * 360;
            xySW.x = -(mapPointsWidth - xySW.y);
        }

        var width  = xyNE.x - xySW.x;
        var height = xySW.y - xyNE.y;
        var viewBox = new ViewBox(xySW.x, xyNE.y, width, height);
        _this.setViewBox(viewBox);

    }
    /**
     * Redraws the map.
     * Must be called when the map is shown after being hidden.
     */
    redraw(){

        var _this = this;

        if(MapSVG.browser.ie){
            $(_this.containers.svg).css({height: _this.svgDefault.viewBox.height});
        }

        if(_this.options.googleMaps.on && _this.googleMaps.map){
            // var center = _this.googleMaps.map.getCenter();
            google.maps.event.trigger(_this.googleMaps.map, 'resize');
            // _this.googleMaps.map.setCenter(center);
            // _this.setViewBoxByGoogleMapBounds();
        }else{
            _this.setViewBox(_this.viewBox);
        }
        $(_this.containers.popover) && $(_this.containers.popover).css({
            'max-height': _this.options.popovers.maxHeight*$(_this.containers.wrap).outerHeight()/100+'px'
        });
        if(this.controllers && this.controllers.directory){
            this.controllers.directory.updateTopShift();
            this.controllers.directory.updateScroll();
        }
        _this.updateSize();
    }
    /**
     * Sets map padding.
     * @param {number} options - Padding in pixels
     */
    setPadding(options){

        var _this = this;

        options = options || _this.options.padding;
        for(var i in options){
            options[i] = options[i] ? parseInt(options[i]) : 0;
        }
        $.extend(_this.options.padding, options);

        _this.setViewBox();
        _this.events.trigger('sizeChange');
    }
    /**
     * Sets map size.
     * Can accept both or just 1 parameter - width or height. The missing parameter will be calcualted.
     * @param {number} width
     * @param {number} height
     * @param {boolean} responsive
     * @returns {number[]} - [width, height]
     */
    setSize (width: number, height: number, responsive?: boolean){

        var _this = this;

        // Convert strings to numbers
        _this.options.width      = width;
        _this.options.height     = height;
        _this.options.responsive = responsive!=null && responsive!=undefined  ? MapSVG.parseBoolean(responsive) : _this.options.responsive;

        // Calculate width and height
        if ((!_this.options.width && !_this.options.height)){
            _this.options.width	 = _this.svgDefault.width;
            _this.options.height = _this.svgDefault.height;
        }else if (!_this.options.width && _this.options.height){
            _this.options.width	 =_this.options.height * _this.svgDefault.width / _this.svgDefault.height;
        }else if (_this.options.width && !_this.options.height){
            _this.options.height =_this.options.width * _this.svgDefault.height/_this.svgDefault.width;
        }

        _this.whRatio      = _this.options.width / _this.options.height;
        _this.scale        = _this.getScale();

        _this.setResponsive(responsive);

        if(_this.markers)
            _this.markersAdjustPosition();
        if(_this.options.labelsRegions.on){
            _this.labelsRegionsAdjustPosition();
        }
        if(_this.options.choropleth.on && _this.options.choropleth.bubbleMode){
            _this.redrawBubbles();
        }

        return [_this.options.width, _this.options.height];
    }
    /**
     * Sets map responsiveness on/off. When map is responsive, it takes the full width of the parent container.
     * @param {bool} on
     */
    setResponsive (on: boolean){

        var _this = this;

        on = on != undefined ? MapSVG.parseBoolean(on) : _this.options.responsive;

        $(_this.containers.map).css({
            'width': '100%',
            'height': '0',
            'padding-bottom': (_this.viewBox.height*100/_this.viewBox.width)+'%'
        });
        if(on){
            $(_this.containers.wrap).css({
                'width': '100%',
                'height': 'auto'
            });
        }else{
            $(_this.containers.wrap).css({
                'width': _this.options.width+'px',
                'height': _this.options.height+'px'
            });
        }
        $.extend(true, _this.options, {responsive: on});

        if(!_this.resizeSensor){
            _this.resizeSensor = new ResizeSensor(_this.containers.map, function(){
                _this.redraw();
            });
        }

        _this.redraw();
    }
    /**
     * Sets map scroll options.
     * @param {object} options - scroll options
     * @param {bool} skipEvents - used by Map Editor to prevent re-setting event handlers.
     * @example
     * mapsvg.setScroll({
     *   on: true,
     *   limit: false // limit scroll to map bounds
     * });
     */
    setScroll (options, skipEvents){

        var _this = this;

        options.on != undefined && (options.on = MapSVG.parseBoolean(options.on));
        options.limit != undefined && (options.limit = MapSVG.parseBoolean(options.limit));
        $.extend(true, _this.options, {scroll: options});
        !skipEvents && _this.setEventHandlers();
    }
    /**
     * Sets map zoom options.
     * @param {object} options - zoom options
     * @example
     * mapsvg.setZoom({
     *   on: true,
     *   mousewheel: true,
     *   limit: [-5,10], // allow -5 zoom steps back and +20 zoom steps up from initial position.
     * });
     */
    setZoom  (options){

        var _this = this;

        options = options || {};
        options.on != undefined && (options.on = MapSVG.parseBoolean(options.on));
        options.fingers != undefined && (options.fingers = MapSVG.parseBoolean(options.fingers));
        options.mousewheel != undefined && (options.mousewheel = MapSVG.parseBoolean(options.mousewheel));

        // delta = 1.2 changed to delta = 2 since introducing Google Maps + smooth zoom
        options.delta = 2;

        // options.delta && (options.delta = parseFloat(options.delta));

        if(options.limit){
            if(typeof options.limit == 'string')
                options.limit = options.limit.split(';');
            options.limit = [parseInt(options.limit[0]),parseInt(options.limit[1])];
        }
        if(!_this.zoomLevels){
            _this.setZoomLevels();
        }

        $.extend(true, _this.options, {zoom: options});
        //(options.buttons && options.buttons.on) && (options.buttons.on = MapSVG.parseBoolean(options.buttons.on));
        $(_this.containers.map).off('wheel.mapsvg');


        if(_this.options.zoom.mousewheel){
            // var lastZoomTime = 0;
            // var zoomTimeDelta = 0;

            if(MapSVG.browser.firefox){
                _this.firefoxScroll = {insideIframe: false, scrollX: 0, scrollY: 0};

                $(_this.containers.map).on('mouseenter', function() {
                    _this.firefoxScroll.insideIframe = true;
                    _this.firefoxScroll.scrollX = window.scrollX;
                    _this.firefoxScroll.scrollY = window.scrollY;
                }).on('mouseleave', function() {
                    _this.firefoxScroll.insideIframe = false;
                });

                $(document).scroll(function() {
                    if (_this.firefoxScroll.insideIframe)
                        window.scrollTo(_this.firefoxScroll.scrollX, _this.firefoxScroll.scrollY);
                });
            }

            $(_this.containers.map).on('wheel.mapsvg',function(event) {

                if($(event.target).hasClass('mapsvg-popover') || $(event.target).closest('.mapsvg-popover').length
                   ||
                   $(event.target).hasClass('mapsvg-details-container') || $(event.target).closest('.mapsvg-details-container').length
                ){
                    return;
                }

                event.preventDefault();
                // @ts-ignore - doesn't recognize .deltaY
                var d = Math.sign(-event.originalEvent.deltaY);
                var m = MapSVG.mouseCoords(event.originalEvent);
                m.x = m.x - $(_this.containers.svg).offset().left;
                m.y = m.y - $(_this.containers.svg).offset().top;

                var center = _this.convertPixelToSVG(new ScreenPoint(m.x, m.y));
                d > 0 ? _this.zoomIn(center) : _this.zoomOut(center);
                return false;
            });
        }
        _this.canZoom = true;
    }
    /**
     * Sets map control buttons.
     * @param {object} options - control button options
     * @example
     * mapsvg.setControls({
     *   location: 'right',
     *   zoom: true,
     *   zoomReset: true,
     *   userLocation: true
     * });
     */
    setControls  (options){

        var _this = this;

        options = options || {};
        $.extend(true, _this.options, {controls: options});
        _this.options.controls.zoom = MapSVG.parseBoolean(_this.options.controls.zoom);
        _this.options.controls.zoomReset = MapSVG.parseBoolean(_this.options.controls.zoomReset);
        _this.options.controls.userLocation = MapSVG.parseBoolean(_this.options.controls.userLocation);

        var loc = _this.options.controls.location || 'right';

        if(!_this.containers.controls){

            var buttons = $('<div />').addClass('mapsvg-buttons');

            var zoomGroup = $('<div />').addClass('mapsvg-btn-group').appendTo(buttons);
            var zoomIn = $('<div />').addClass('mapsvg-btn-map mapsvg-in');

            zoomIn.on('touchend click',function(e){
                if(e.cancelable){
                    e.preventDefault();
                }
                e.stopPropagation();
                _this.zoomIn();
            });

            var zoomOut = $('<div />').addClass('mapsvg-btn-map mapsvg-out');
            zoomOut.on('touchend click',function(e){
                if(e.cancelable){
                    e.preventDefault();
                }
                e.stopPropagation();
                _this.zoomOut();
            });
            zoomGroup.append(zoomIn).append(zoomOut);

            var location = $('<div />').addClass('mapsvg-btn-map mapsvg-btn-location');
            location.on('touchend click',function(e){
                if(e.cancelable){
                    e.preventDefault();
                }
                e.stopPropagation();
                _this.showUserLocation(function(location){
                    if(_this.options.scroll.on){
                        _this.centerOn(location.marker);
                    }
                });
            });

            var userLocationIcon = '<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 447.342 447.342" style="enable-background:new 0 0 447.342 447.342;" xml:space="preserve"><path d="M443.537,3.805c-3.84-3.84-9.686-4.893-14.625-2.613L7.553,195.239c-4.827,2.215-7.807,7.153-7.535,12.459 c0.254,5.305,3.727,9.908,8.762,11.63l129.476,44.289c21.349,7.314,38.125,24.089,45.438,45.438l44.321,129.509 c1.72,5.018,6.325,8.491,11.63,8.762c5.306,0.271,10.244-2.725,12.458-7.535L446.15,18.429 C448.428,13.491,447.377,7.644,443.537,3.805z"/></svg>';
            location.html(userLocationIcon);

            var locationGroup = $('<div />').addClass('mapsvg-btn-group').appendTo(buttons);
            locationGroup.append(location);

            var zoomResetIcon = '<svg height="14px" version="1.1" viewBox="0 0 14 14" width="14px" xmlns="http://www.w3.org/2000/svg" xmlns:sketch="http://www.bohemiancoding.com/sketch/ns" xmlns:xlink="http://www.w3.org/1999/xlink"><g fill="none" fill-rule="evenodd" id="Page-1" stroke="none" stroke-width="1"><g fill="#000000" transform="translate(-215.000000, -257.000000)"><g id="fullscreen" transform="translate(215.000000, 257.000000)"><path d="M2,9 L0,9 L0,14 L5,14 L5,12 L2,12 L2,9 L2,9 Z M0,5 L2,5 L2,2 L5,2 L5,0 L0,0 L0,5 L0,5 Z M12,12 L9,12 L9,14 L14,14 L14,9 L12,9 L12,12 L12,12 Z M9,0 L9,2 L12,2 L12,5 L14,5 L14,0 L9,0 L9,0 Z" /></g></g></g></svg>';
            var zoomResetButton = $('<div />').html(zoomResetIcon).addClass('mapsvg-btn-map mapsvg-btn-zoom-reset');
            zoomResetButton.on('touchend click',function(e){
                if(e.cancelable){
                    e.preventDefault();
                }
                e.stopPropagation();
                _this.viewBoxReset(true);
            });
            var zoomResetGroup = $('<div />').addClass('mapsvg-btn-group').appendTo(buttons);
            zoomResetGroup.append(zoomResetButton);


            _this.containers.controls = buttons[0];
            _this.controls = {
                zoom: zoomGroup[0],
                userLocation: locationGroup[0],
                zoomReset: zoomResetGroup[0]
            };
            $(_this.containers.map).append($(_this.containers.controls));
        }

        $(_this.controls.zoom).toggle(_this.options.controls.zoom);
        $(_this.controls.userLocation).toggle(_this.options.controls.userLocation);
        $(_this.controls.zoomReset).toggle(_this.options.controls.zoomReset);

        $(_this.containers.controls).removeClass('left');
        $(_this.containers.controls).removeClass('right');
        loc == 'right' && $(_this.containers.controls).addClass('right')
        ||
        loc == 'left' && $(_this.containers.controls).addClass('left');

        // (_this.options.controls.on &&  loc!='hide') ? _this.containers.zoomButtons.show() : _this.containers.zoomButtons.hide();
    }
    /**
     * Calcualtes map viewBox parameter for each zoom level
     * @private
     */
    setZoomLevels (){

        var _this = this;

        if(!_this.zoomLevels){
            _this.zoomLevels = new ArrayIndexed('zoomLevel');
        } else {
            _this.zoomLevels.clear();
        }

        for(var i = -20; i < 0; i++){
            let _scale = 1/Math.pow(_this.options.zoom.delta, Math.abs(i));
            _this.zoomLevels.push({
                zoomLevel: i,
                _scale: _scale,
                viewBox: new ViewBox(0, 0, _this._viewBox.width /_scale, _this._viewBox.height /_scale)
            });
        }

        for(var i = 0; i <= 20; i++){
            let _scale = Math.pow(_this.options.zoom.delta, Math.abs(i));
            _this.zoomLevels.push({
                zoomLevel: i,
                _scale: _scale,
                viewBox: new ViewBox(0, 0, _this._viewBox.width /_scale, _this._viewBox.height /_scale)
            });
        }
    }
    /**
     * Sets mouse pointer cursor style on hover on regions / markers.
     * @param {string} type - "pointer" or "default"
     */
    setCursor (type){

        var _this = this;

        type = type == 'pointer' ? 'pointer' : 'default';
        _this.options.cursor = type;
        if(type == 'pointer')
            $(_this.containers.map).addClass('mapsvg-cursor-pointer');
        else
            $(_this.containers.map).removeClass('mapsvg-cursor-pointer');
    }
    /**
     * Enables/disables "multiselect" option that allows to select multiple regions.
     * @param {boolean} on
     * @param {boolean} deselect - If true, deselects currently selected Regions
     */
    setMultiSelect  (on: boolean, deselect?: boolean){

        var _this = this;

        _this.options.multiSelect = MapSVG.parseBoolean(on);
        if(deselect !== false)
            _this.deselectAllRegions();
    }
    /**
     * Sets choropleth map options
     * @param {object} options
     *
     * @example
     * mapsvg.setChoropleth({
     *   on: true,
     *   colors: {
     *     high: "#FF0000",
     *     low: "#00FF00"
     *   }
     *   labels: {
     *     high: "high",
     *     low: "low"
     *   }
     * });
     */
    setChoropleth  (options?: any){
        const _this = this;

        options = options || _this.options.choropleth;
        options.on != undefined && (options.on = MapSVG.parseBoolean(options.on));

        if ( typeof options.coloring === 'undefined' || typeof options.coloring.palette === 'undefined' || typeof options.coloring.palette.colors === 'undefined'){
            if ((typeof options.sourceFieldSelect === 'undefined') || (typeof options.sourceFieldSelect.variants === 'undefined')){
                $.extend(true, _this.options.choropleth, options);
            }
            else {
                _this.options.choropleth.sourceFieldSelect.variants = options.sourceFieldSelect.variants;
            }
        }
        else {
            let paletteColorsIndexes = Object.keys(options.coloring.palette.colors);
            if ((paletteColorsIndexes.length > 1) || (paletteColorsIndexes[0] == '0' &&  Object.keys(options.coloring.palette.colors[0]).length > 1)){
                _this.options.choropleth.coloring.palette.colors = options.coloring.palette.colors;
            }
            else {
                let paletteColorIndex = Object.keys(options.coloring.palette.colors)[0];
                $.extend(true, _this.options.choropleth.coloring.palette.colors[paletteColorIndex], options.coloring.palette.colors[paletteColorIndex]);
            }
        }

        _this.updateChoroplethMinMax();

        if (_this.options.choropleth.on && _this.options.choropleth.sourceFieldSelect.on){

            if (!_this.containers.choroplethSourceSelect) {
                let sourceSelectOptions = [];
                _this.options.choropleth.sourceFieldSelect.variants.forEach(function (variant) {
                    sourceSelectOptions.push($('<option value="' + variant + '" ' + (variant === _this.options.choropleth.sourceField ? 'selected' : '') + '>' + variant + '</option>'));
                });

                _this.containers.choroplethSourceSelect = {
                    container: $('<div class="mapsvg-choropleath-source-field"></div>')[0],
                    select: $('<select id="mapsvg-choropleth-source-field-select" class="mapsvg-select2"></select>')[0],
                    options: sourceSelectOptions
                };

                $(_this.containers.choroplethSourceSelect.select).append(_this.containers.choroplethSourceSelect.options);
                //$(_this.containers.choroplethSourceSelect.container).append($(_this.containers.choroplethSourceSelect.label));
                $(_this.containers.choroplethSourceSelect.container).append($(_this.containers.choroplethSourceSelect.select));

                $(_this.containers.map).append($(_this.containers.choroplethSourceSelect.container));

                $(_this.containers.choroplethSourceSelect.select).mselect2();

                //select2 lib bug workaround. Should be on('change'...)
                $(_this.containers.choroplethSourceSelect.select).mselect2().on('select2:select select2:unselecting', function (e) {
                    if (e.cancelable) {
                        e.preventDefault();
                    }
                    e.stopPropagation();
                    _this.setChoropleth({sourceField: $(this).mselect2().val()});
                });
            }
            else {
                $(_this.containers.choroplethSourceSelect.select).mselect2('destroy');
                $(_this.containers.choroplethSourceSelect.select).find('option').remove();
                _this.containers.choroplethSourceSelect.options = [];
                _this.options.choropleth.sourceFieldSelect.variants.forEach(function (variant) {
                    _this.containers.choroplethSourceSelect.options.push($('<option value="' + variant + '" ' + (variant === _this.options.choropleth.sourceField ? 'selected' : '') + '>' + variant + '</option>')[0]);
                });
                $(_this.containers.choroplethSourceSelect.select).append(_this.containers.choroplethSourceSelect.options);
                $(_this.containers.choroplethSourceSelect.select).mselect2({width: '100%'});
            }
        }

        if ((!_this.options.choropleth.on || !_this.options.choropleth.sourceFieldSelect.on) && _this.containers.choroplethSourceSelect && $(_this.containers.choroplethSourceSelect.container).is(":visible")){
            $(_this.containers.choroplethSourceSelect.container).hide();
        }else if(_this.options.choropleth.on && _this.options.choropleth.sourceFieldSelect.on && _this.containers.choroplethSourceSelect && !$(_this.containers.choroplethSourceSelect.container).is(":visible")){
            $(_this.containers.choroplethSourceSelect.container).show();
        }

       $(_this.containers.map).find('.mapsvg-choropleth-legend').remove();

        if(_this.options.choropleth.on && _this.options.choropleth.coloring.legend.on) {
            let legend = _this.options.choropleth.coloring.legend,
                coloring = '';

            if  (_this.options.choropleth.coloring.mode === 'gradient'){
                //Gradient mode
                for (let chunkIdx=1; chunkIdx<5; chunkIdx++){
                    coloring += '<div class="mapsvg-choropleth-legend-gradient-chunk">'+((_this.options.choropleth.coloring.gradient.values.maxAdjusted*chunkIdx/5)+_this.options.choropleth.coloring.gradient.values.min)+'</div>';
                }
            }
            else {
                //Palette mode
                let paletteColors = _this.options.choropleth.coloring.palette.colors;

                paletteColors.forEach(function (paletteColor, idx) {
                     let paletteColorElementText = '';
                     if (paletteColor.description){
                         paletteColorElementText = paletteColor.description;
                     }
                     else {
                         if (idx === 0 && !paletteColor.valueFrom && paletteColor.valueFrom !== 0 ){
                             if (legend.layout === 'vertical'){
                                 paletteColorElementText = 'Less then '+paletteColor.valueTo;
                             }
                             else {
                                 paletteColorElementText = '< '+paletteColor.valueTo;
                             }

                         }
                         else if (idx === (paletteColors.length-1) && !paletteColor.valueTo) {
                             if (legend.layout === 'vertical'){
                                 paletteColorElementText = paletteColor.valueFrom + ' or more';
                             }
                             else {
                                 paletteColorElementText = paletteColor.valueFrom + ' <';
                             }
                         }
                         else {
                             paletteColorElementText =  paletteColor.valueFrom + ' &#8804; ' + paletteColor.valueTo;
                         }
                     }

                    coloring +=
                         '<div class="mapsvg-choropleth-legend-palette-color-wrap" data-idx="'+idx+'">'+
                            '<div class="mapsvg-choropleth-legend-palette-color"></div>'+
                            '<div class="mapsvg-choropleth-legend-palette-color-description">'+paletteColorElementText+'</div>'+
                         '</div>'
                     ;
                });
            }

            _this.containers.legend = {
                title: $('<div class="mapsvg-choropleth-legend-title">'+ legend.title +'</div>')[0],
                text: $('<div class="mapsvg-choropleth-legend-text">'+ legend.text +'</div>')[0],
                coloring: $('<div class="mapsvg-choropleth-legend-'+_this.options.choropleth.coloring.mode+'">'+coloring+'</div>')[0],
                description: $('<div class="mapsvg-choropleth-legend-description">'+ legend.description +'</div>')[0],
                container: $('<div />').addClass('mapsvg-choropleth-legend mapsvg-choropleth-legend-'+legend.layout+' mapsvg-choropleth-legend-container-'+legend.container)[0]
            };

            $(_this.containers.legend.container)
                .append(_this.containers.legend.title)
                .append(_this.containers.legend.text)
                .append(_this.containers.legend.coloring)
                .append(_this.containers.legend.description)
            ;
            $(_this.containers.map).append(_this.containers.legend.container);

            _this.setChoroplethLegendCSS();

            _this.regionsRepository.events.on('updated',function(){
                _this.redrawChoropleth();
            });

            _this.objectsRepository.events.on('updated',function(){
                _this.redrawChoropleth();
            });
        }

        if (_this.options.choropleth.on && _this.options.choropleth.coloring.mode === 'gradient'){
            let colors = _this.options.choropleth.coloring.gradient.colors;
            if (colors){
                colors.lowRGB = tinycolor(colors.low).toRgb();
                colors.highRGB = tinycolor(colors.high).toRgb();
                colors.diffRGB = {
                    r: colors.highRGB.r - colors.lowRGB.r,
                    g: colors.highRGB.g - colors.lowRGB.g,
                    b: colors.highRGB.b - colors.lowRGB.b,
                    a: colors.highRGB.a - colors.lowRGB.a
                };
                _this.containers.legend && _this.setChoroplethLegendCSS();
            }
        }

        _this.redrawChoropleth();
    }
    /**
     * Redraws choropleth map colors
     * @private
     */
    redrawChoropleth (){

        var _this = this;

        _this.updateChoroplethMinMax();
        _this.redrawBubbles();
        _this.regionsRedrawColors();
    }
    /**
     * Updates min/max values of choropleth fields
     * @private
     */
    updateChoroplethMinMax (){
        let _this = this;

        if  (_this.options.choropleth.on){
            let gradient = _this.options.choropleth.coloring.gradient,
                values = [];

            gradient.values.min = 0;
            gradient.values.max = null;

            if (_this.options.choropleth.source === 'regions'){
                _this.regions.forEach(function(region){
                    var choropleth = region.data && region.data[_this.options.choropleth.sourceField];
                    choropleth != undefined && choropleth !== '' && values.push(choropleth);
                });
            }
            else {
                _this.objectsRepository.objects.forEach(function(object){
                    var choropleth = object[_this.options.choropleth.sourceField];
                    choropleth != undefined && choropleth !== '' && values.push(choropleth);
                });
            }

            if(values.length > 0){
                gradient.values.min = Math.min.apply(null,values);
                gradient.values.max = Math.max.apply(null,values);
                gradient.values.maxAdjusted = gradient.values.max - gradient.values.min;
            }
        };
    }
    /**
     * Sets gradient for choropleth map
     * @private
     */
    setChoroplethLegendCSS(){
        let gradient = this.options.choropleth.coloring.gradient,
            legend = this.options.choropleth.coloring.legend;

        $('.mapsvg-choropleth-legend').css({
            'width': legend.width,
            'height': legend.height
        });

        if  (this.options.choropleth.coloring.mode === 'gradient'){
            if (legend.layout === 'horizontal'){
                // horizontal legend
                $('.mapsvg-choropleth-legend-horizontal .mapsvg-choropleth-legend-gradient').css({
                    'background': 'linear-gradient(to right,' + gradient.colors.low + ' 1%,' + gradient.colors.high + ' 100%)'
                });
            }
            else {
                // vertical legend
                $('.mapsvg-choropleth-legend-vertical .mapsvg-choropleth-legend-gradient').css({
                    'background': 'linear-gradient(to bottom,' + gradient.colors.low + ' 1%,' + gradient.colors.high + ' 100%)'
                });
            }
        }
        else {
            let paletteColors = this.options.choropleth.coloring.palette.colors;

            paletteColors.forEach(function (paletteColor, idx){
                $('.mapsvg-choropleth-legend-palette-color-wrap[data-idx="'+idx+'"] .mapsvg-choropleth-legend-palette-color').css({
                    'background-color': paletteColor.color
                });
            });
        }

    }
    /**
     * Sets custom map CSS.
     * CSS is added as <style>...</style> tag in the page <header>
     * @param {string} css
     * @private
     */
    setCss (css?: string): void {

        var _this = this;

        _this.options.css = css || (_this.options.css ? _this.options.css.replace(/%id%/g, ''+this.id) : '');
        _this.liveCss = _this.liveCss || <HTMLStyleElement>$('<style></style>').appendTo('head')[0];
        $(_this.liveCss).html(_this.options.css);
    }
    /**
     * Sets filter options
     * @param {object} options
     * @example
     * mapsvg.setFilters{{
     *   on: true,
     *   location: "leftSidebar"
     * }};
     */
    setFilters (options?: {[key: string]: any}){

        var _this = this;

        options                              = options || _this.options.filters;
        options.on != undefined              && (options.on = MapSVG.parseBoolean(options.on));
        options.hide != undefined          && (options.hide = MapSVG.parseBoolean(options.hide));
        $.extend(true, _this.options, {filters: options});

        var scrollable = false;

        if(['leftSidebar','rightSidebar','header','footer','custom','map'].indexOf(_this.options.filters.location)===-1){
            _this.options.filters.location = 'leftSidebar';
        }

        if(_this.options.filters.on){

            if(_this.formBuilder){
                _this.formBuilder.destroy();
            }

            if(!_this.containers.filters){
                _this.containers.filters = $('<div class="mapsvg-filters-wrap"></div>')[0];
            } else {
                $(_this.containers.filters).empty();
                $(_this.containers.filters).show();
            }

            $(_this.containers.filters).css({
                'background-color':_this.options.colors.directorySearch,
            });

            if($(_this.containers.filtersModal)){
                $(_this.containers.filtersModal).css({width: _this.options.filters.width});
            }

            if(_this.options.filters.location === 'custom'){
                $(_this.containers.filters).removeClass('mapsvg-filter-container-custom').addClass('mapsvg-filter-container-custom');
                if($('#'+_this.options.filters.containerId).length){
                    $('#'+_this.options.filters.containerId).append(_this.containers.filters);
                } else {
                    $(_this.containers.filters).hide();
                    console.error('MapSVG: filter container #'+_this.options.filters.containerId+' does not exists');
                }
            } else {
                if(MapSVG.isPhone){
                    $(_this.containers.header).append($(_this.containers.filters));
                    _this.setContainers({header:{on:true}});
                }else{
                    var location = MapSVG.isPhone ? 'header' : _this.options.filters.location;
                    if(_this.options.menu.on && _this.controllers.directory && _this.options.menu.location === _this.options.filters.location){
                        $(_this.controllers.directory.containers.view).find('.mapsvg-directory-filter-wrap').append($(_this.containers.filters));
                        _this.controllers.directory.updateTopShift();
                    } else {
                        $(_this.containers[location]).append($(_this.containers.filters));
                        _this.controllers.directory && _this.controllers.directory.updateTopShift();
                    }
                }
            }

            _this.loadFiltersController(_this.containers.filters, false);

            _this.updateFiltersState();
        } else {
            if($(_this.containers.filters)){
                $(_this.containers.filters).empty();
                $(_this.containers.filters).hide();
            }
        }

        if(_this.options.menu.on && _this.controllers.directory && _this.options.menu.location === _this.options.filters.location){
            _this.controllers.directory.updateTopShift();
        }
    }
    /**
     * Updates filters in drop-downs. For example, when region is clicked and data is filtered -
     * it selects corresponding region in the drop-down filter
     * @private
     */
    updateFiltersState (){

        var _this = this;

        $(_this.containers.filterTags) && $(_this.containers.filterTags).empty();

        if((_this.options.filters && _this.options.filters.on) || _this.objectsRepository.query.hasFilters()){

            for(var field_name in _this.objectsRepository.query.filters){
                var field_value = _this.objectsRepository.query.filters[field_name];
                var _field_name = field_name;
                var filterField = _this.filtersSchema.getField(_field_name);

                if(_this.options.filters.on && filterField){
                    $(_this.containers.filters).find('select[data-parameter-name="'+_field_name+'"],radio[data-parameter-name="\'+_field_name+\'"]')
                        .data('ignoreSelect2Change', true)
                        .val(field_value)
                        .trigger('change');
                }else{
                    if(field_name == 'regions'){
                        // check if there is such filter. If there is then change its value
                        // if there isn't then add a tag with close button
                        _field_name = '';
                        var field_value = field_value.region_ids.map(id => _this.getRegion(id).title);
                    } else {
                        _field_name = filterField && filterField.label;
                    }
                    if(field_name !== 'distance'){
                        if(!_this.containers.filterTags){
                            _this.containers.filterTags = $('<div class="mapsvg-filter-tags"></div>')[0];
                            // TODO If filtersmodeal on then dont append
                            if($(_this.containers.filters)){
                                // $(_this.containers.filters).append($(_this.containers.filterTags));
                            } else {
                                if(_this.options.menu.on && _this.controllers.directory){
                                    $(_this.controllers.directory.containers.toolbar).append(_this.containers.filterTags);
                                    _this.controllers.directory.updateTopShift();
                                } else {
                                    $(_this.containers.map).append(_this.containers.filterTags);
                                    if(_this.options.zoom.buttons.on){
                                        if(_this.options.layersControl.on){
                                            if(_this.options.layersControl.position=='top-left'){
                                                $(_this.containers.filterTags).css({
                                                    right: 0,
                                                    bottom: 0
                                                });
                                            } else {
                                                $(_this.containers.filterTags).css({
                                                    bottom: 0
                                                });
                                            }
                                        } else {
                                            if(_this.options.zoom.buttons.location=='left'){
                                                $(_this.containers.filterTags).css({
                                                    right: 0
                                                });
                                            }
                                        }
                                    }
                                }
                            }

                            $(_this.containers.filterTags).on('click','.mapsvg-filter-delete',function(e){
                                var filterField = $(this).data('filter');
                                $(this).parent().remove();
                                _this.objectsRepository.query.removeFilter(filterField);
                                _this.deselectAllRegions();
                                _this.loadDataObjects();
                            });
                        }
                        $(_this.containers.filterTags).append('<div class="mapsvg-filter-tag">'+(_field_name?_field_name+': ':'')+field_value+' <span class="mapsvg-filter-delete" data-filter="'+field_name+'">×</span></div>');
                    }
                }
            }
            // this.view.addClass('mapsvg-with-filter');

        }else{
            // this.view.removeClass('mapsvg-with-filter');
        }
    }
    /**
     * Sets container options: leftSidebar, rightSidebar, header, footer.
     * @param {object} options
     *
     * @example
     * mapsvg.setContainers({
     *   leftSidebar: {
     *     on: true,
     *     width: "300px"
     *   }
     * });
     */
    setContainers (options){

        var _this = this;

        if(!this.containersCreated){

            this.containers.wrapAll = document.createElement('div');
            this.containers.wrapAll.classList.add('mapsvg-wrap-all');
            this.containers.wrapAll.id = 'mapsvg-map-'+this.id;
            this.containers.wrapAll.setAttribute('data-map-id', this.id ? (this.id).toString() : '');

            this.containers.wrap = document.createElement('div');
            this.containers.wrap.classList.add('mapsvg-wrap');

            this.containers.mapContainer = document.createElement('div');
            this.containers.mapContainer.classList.add('mapsvg-map-container');

            this.containers.leftSidebar = document.createElement('div');
            this.containers.leftSidebar.className = 'mapsvg-sidebar mapsvg-top-container mapsvg-sidebar-left';
            this.containers.rightSidebar = document.createElement('div');
            this.containers.rightSidebar.className = "mapsvg-sidebar mapsvg-top-container mapsvg-sidebar-right";

            this.containers.header = document.createElement('div');
            this.containers.header.className = "mapsvg-header mapsvg-top-container";
            this.containers.footer = document.createElement('div');
            this.containers.footer.className = "mapsvg-footer mapsvg-top-container";


            _this.containers.wrapAll = $('<div class="mapsvg-wrap-all"></div>').attr('id', 'mapsvg-map-'+this.id).attr('data-map-id', this.id)[0];
            _this.containers.wrap    = $('<div class="mapsvg-wrap"></div>')[0];
            _this.containers.mapContainer = $('<div class="mapsvg-map-container"></div>')[0];
            _this.containers.leftSidebar  = $('<div class="mapsvg-sidebar mapsvg-top-container mapsvg-sidebar-left"></div>')[0];
            _this.containers.rightSidebar = $('<div class="mapsvg-sidebar mapsvg-top-container mapsvg-sidebar-right"></div>')[0];
            _this.containers.header       = $('<div class="mapsvg-header mapsvg-top-container"></div>')[0];
            _this.containers.footer       = $('<div class="mapsvg-footer mapsvg-top-container"></div>')[0];

            $(_this.containers.wrapAll).insertBefore(_this.containers.map);
            $(_this.containers.wrapAll).append(_this.containers.header);
            $(_this.containers.wrapAll).append(_this.containers.wrap);
            $(_this.containers.wrapAll).append(_this.containers.footer);


            $(_this.containers.mapContainer).append(_this.containers.map);

            $(_this.containers.wrap).append(_this.containers.leftSidebar);
            $(_this.containers.wrap).append(_this.containers.mapContainer);
            $(_this.containers.wrap).append(_this.containers.rightSidebar);
            _this.containersCreated = true;
        }

        options = options || _this.options.containers || {};

        for(var contName in options){

            if(options[contName].on !== undefined){
                options[contName].on = MapSVG.parseBoolean(options[contName].on);
            }

            if(options[contName].width){
                if((typeof options[contName].width != 'string') || options[contName].width.indexOf('px')===-1 && options[contName].width.indexOf('%')===-1 && options[contName].width!=='auto'){
                    options[contName].width = options[contName].width+'px';
                }
                $(_this.containers[contName]).css({'flex-basis': options[contName].width});
            }
            if(options[contName].height){
                if((typeof options[contName].height != 'string') || options[contName].height.indexOf('px')===-1 && options[contName].height.indexOf('%')===-1 && options[contName].height!=='auto'){
                    options[contName].height = options[contName].height+'px';
                }
                $(_this.containers[contName]).css({'flex-basis': options[contName].height, height: options[contName].height});
            }

            $.extend(true, _this.options, {containers: options});

            var on = _this.options.containers[contName].on;

            if(MapSVG.isPhone && _this.options.menu.hideOnMobile && _this.options.menu.location === contName && ['leftSidebar','rightSidebar'].indexOf(contName) !==-1 ) {
                on = false;
            } else if(MapSVG.isPhone && _this.options.menu.location === 'custom' && ['leftSidebar','rightSidebar'].indexOf(contName) !==-1 ){
                // hide sidebars on mobiles if there's no directory in there because filters are always moved to header (or custom) on mobiles
                on = false;
                $(_this.containers.wrapAll).addClass('mapsvg-hide-map-list-buttons');
            } else if (MapSVG.isPhone && !_this.options.menu.hideOnMobile && _this.options.menu.location === contName && ['leftSidebar','rightSidebar'].indexOf(contName) !==-1 ){
                $(_this.containers.wrapAll).addClass('mapsvg-hide-map-list-buttons');
                $(_this.containers.wrapAll).addClass('mapsvg-directory-visible');
            }
            $(_this.containers[contName]).toggle(on);
        }

        _this.setDetailsView();
    }
    /**
     * Checks if container should be scrollable
     * @param {string} container - mapContainer / leftSidebar / rightSidebar / custom / header / footer
     * @returns {boolean}
     * @private
     */
    shouldBeScrollable(container){

        var _this = this;

        switch (container){
            case 'map':
            case 'leftSidebar':
            case 'rightSidebar':
                return true;
                break;
            case 'custom':
                return false;
                break;
            case 'header':
            case 'footer':
                if(_this.options.containers[container].height && _this.options.containers[container].height !== 'auto' &&  _this.options.containers[container].height !== '100%'){
                    return true;
                } else {
                    return false;
                }
                break;
            default: return false; break;
        }
    }
    /**
     * Sets directory options.
     * @alias setMenu
     * @param {object} options
     * @returns {*|void}
     *
     * @example
     * mapsvg.setDirectory({
     *   on: true,
     *   container: "leftSidebar"
     * });
     */
    setDirectory (options){

        var _this = this;

        return _this.setMenu(options);
    }
    /**
     * Sets menu (directory) options
     * @param options
     * @private
     */
    setMenu (options?: {[key: string]: any}){

        var _this = this;

        options                               = options || _this.options.menu;
        options.on != undefined              && (options.on = MapSVG.parseBoolean(options.on));
        options.search != undefined          && (options.search = MapSVG.parseBoolean(options.search));
        options.showMapOnClick != undefined          && (options.showMapOnClick = MapSVG.parseBoolean(options.showMapOnClick));
        options.searchFallback != undefined          && (options.searchFallback = MapSVG.parseBoolean(options.searchFallback));
        options.customContainer != undefined && (options.customContainer = MapSVG.parseBoolean(options.customContainer));

        $.extend(true, _this.options, {menu: options});

        _this.controllers = _this.controllers || {};

        if(!_this.containers.directory){
            _this.containers.directory = $('<div class="mapsvg-directory"></div>')[0];
        }

        // If directory will be scrollable make it absolutely positioned, fill the parent container.
        $(_this.containers.directory).toggleClass('flex', _this.shouldBeScrollable(_this.options.menu.location));

        if(_this.options.menu.on){

            if(!_this.controllers.directory){
                _this.controllers.directory = new DirectoryController({
                    container: _this.containers.directory,
                    template: _this.templates.directory,
                    mapsvg: _this,
                    repository: _this.options.menu.source === 'regions' ? _this.regionsRepository : _this.objectsRepository,
                    scrollable: _this.shouldBeScrollable(_this.options.menu.location),//_this.options.menu.location === 'leftSidebar' || _this.options.menu.location === 'rightSidebar',
                    // position: _this.options.menu.position,
                    // search: _this.options.menu.search,
                    events : {
                        click: function(e, regionOrObject, mapsvg){ _this.events.trigger('click.directoryItem', this, [e, regionOrObject, mapsvg]); },
                        mouseover: function(e, regionOrObject, mapsvg){
                            _this.events.trigger('mouseover.directoryItem', this, [e, regionOrObject, mapsvg]);
                        },
                        mouseout: function(e, regionOrObject, mapsvg){ _this.events.trigger('mouseout.directoryItem', this, [e, regionOrObject, mapsvg]); }
                    }
                });
                _this.controllers.directory._init();
            } else {
                _this.controllers.directory.repository = _this.options.menu.source === 'regions' ? _this.regionsRepository : _this.objectsRepository;
                _this.controllers.directory.repository.query.update({sort: [{
                    field: _this.options.menu.sortBy,
                    order: _this.options.menu.sortDirection
                }]});
                if(options.filterout){
                    var f = {};
                    f[_this.options.menu.filterout.field] = _this.options.menu.filterout.val;
                    _this.controllers.directory.repository.query.setFilterOut(f);
                }
                _this.controllers.directory.scrollable = _this.shouldBeScrollable(_this.options.menu.location)
            }

            var $container;
            if(MapSVG.isPhone && _this.options.menu.hideOnMobile){
                $container = $(_this.containers.leftSidebar);
            }else{
                $container = _this.options.menu.location !== 'custom' ? $(_this.containers[_this.options.menu.location]) : $('#' + _this.options.menu.containerId);
            }
            $container.append(_this.containers.directory);

            if(_this.options.colors.directory){
                $(_this.containers.directory).css({
                    'background-color': _this.options.colors.directory
                });
            }
            _this.setFilters();
            _this.setTemplates({directoryItem: _this.options.templates.directoryItem});
            if((_this.options.menu.source === 'regions' && _this.regionsRepository.loaded) || (_this.options.menu.source === 'database' && _this.objectsRepository.loaded)){
                if(_this.editMode && (options.sortBy || options.sortDirection || options.filterout)){
                    _this.controllers.directory.repository.reload();
                }
                _this.loadDirectory();
            }

        } else {
            _this.controllers.directory && _this.controllers.directory.destroy();
            _this.controllers.directory = null;
        }
    }
    /**
     * Sets database options.
     * @param {object} options
     * @example
     * mapsvg.setDatabase({
     *   pagination: {on: true, perpage: 30}
     * });
     */
    setDatabase (options){

        var _this = this;

        options = options || _this.options.database;

        if(options.pagination){
            if(options.pagination.on != undefined){
                options.pagination.on = MapSVG.parseBoolean(options.pagination.on);
            }
            if(options.pagination.perpage != undefined){
                options.pagination.perpage = parseInt(options.pagination.perpage);
            }
        }
        $.extend(true, _this.options, {database: options});
        if(options.pagination){
            if(options.pagination.on !== undefined || options.pagination.perpage){
                var query = new Query({
                    perpage   : _this.options.database.pagination.on ? _this.options.database.pagination.perpage : 0
                });

                _this.objectsRepository.find(query);
            } else {
                _this.setPagination();
            }
        }
    }
    /**
     * Sets Google Map options.
     * @param {object} options
     * @example
     * mapsvg.setGoogleMaps({
     *   on: true,
     *   type: "terrain"
     * });
     *
     * // Get Google Maps instance:
     * var gm = mapsvg.googleMaps.map;
     */
    setGoogleMaps (options?: any){

        var _this = this;

        options    = options || _this.options.googleMaps;
        options.on != undefined && (options.on = MapSVG.parseBoolean(options.on));

        if(!_this.googleMaps){
            _this.googleMaps = {loaded: false, initialized: false, map: null, overlay: null};
        }

        $.extend(true, _this.options, {googleMaps: options});

        if(_this.options.googleMaps.on){
            $(_this.containers.map).toggleClass('mapsvg-with-google-map', true);
            // _this.setResponsive(false);
            // if(!_this.googleMaps.loaded){
            if(!MapSVG.googleMapsApiLoaded){
                _this.loadGoogleMapsAPI(
                    function(){
                        _this.setGoogleMaps();
                    },
                    function(){
                        _this.setGoogleMaps({on:false});
                    }
                );
            } else {
                if(!_this.googleMaps.map){
                    _this.containers.googleMaps = $('<div class="mapsvg-layer mapsvg-layer-gm" id="mapsvg-google-maps-'+_this.id+'"></div>').prependTo(_this.containers.map)[0];
                    $(_this.containers.googleMaps).css({
                        position: 'absolute',
                        top:0,
                        left: 0,
                        bottom: 0,
                        right: 0,
                        'z-index': '0'
                    });
                    _this.googleMaps.map = new google.maps.Map(_this.containers.googleMaps, {
                        mapTypeId: options.type,
                        fullscreenControl: false,
                        keyboardShortcuts: false,
                        mapTypeControl: false,
                        scaleControl: false,
                        scrollwheel: false,
                        streetViewControl: false,
                        zoomControl: false,
                        styles: options.styleJSON

                    });
                    var overlay;
                    USGSOverlay.prototype = new google.maps.OverlayView();

                    // @ts-ignore
                    function USGSOverlay(bounds, map) {
                        // Initialize all properties.
                        this.bounds_ = bounds;
                        this.map_ = map;
                        this.setMap(map);
                        this.prevCoords = {
                            sw:  {x:0,y:0},
                            sw2: {x:0,y:0},
                            ne:  {x:0,y:0},
                            ne2: {x:0,y:0}
                        };
                    }
                    USGSOverlay.prototype.onAdd = function() {

                        var div = document.createElement('div');
                        div.style.borderStyle = 'none';
                        div.style.borderWidth = '0px';
                        div.style.position    = 'absolute';

                        this.div_ = div;
                        // Add the element to the "overlayLayer" pane.
                        var panes = this.getPanes();
                        panes.overlayLayer.appendChild(div);
                    };

                    USGSOverlay.prototype.draw = function(t) {

                        // return;

                        if (_this.isScrolling) return;


                        var overlayProjection = this.getProjection();
                        if(!overlayProjection) return;

                        var geoSW = this.bounds_.getSouthWest();
                        var geoNE = this.bounds_.getNorthEast();

                        var coords = {
                            sw: overlayProjection.fromLatLngToDivPixel(geoSW),
                            ne: overlayProjection.fromLatLngToDivPixel(geoNE),
                            sw2: overlayProjection.fromLatLngToContainerPixel(geoSW),
                            ne2: overlayProjection.fromLatLngToContainerPixel(geoNE)
                        };

                        // check if map on border between 180/-180 longitude
                        // if(ne.x < sw.x){
                        //     sw.x = sw.x - overlayProjection.getWorldWidth();
                        // }
                        // console.log('NOW sw:'+sw.x+' and ne:'+ne.x+'and W-width:'+overlayProjection.getWorldWidth());

                        // if(ne2.x < sw2.x){
                        //     sw2.x = sw2.x - overlayProjection.getWorldWidth();
                        // }

                        var ww = overlayProjection.getWorldWidth();

                        if(this.prevCoords.sw){

                            if(coords.ne.x < coords.sw.x){
                                if(Math.abs(this.prevCoords.sw.x - coords.sw.x) > Math.abs(this.prevCoords.ne.x - coords.ne.x)){
                                    coords.sw.x = coords.sw.x - ww;
                                }else{
                                    coords.ne.x = coords.ne.x + ww;
                                }
                                if(Math.abs(this.prevCoords.sw2.x - coords.sw2.x) > Math.abs(this.prevCoords.ne2.x - coords.ne2.x)){
                                    coords.sw2.x = coords.sw2.x - ww;
                                }else{
                                    coords.ne2.x = coords.ne2.x + ww;
                                }
                            }
                        }

                        for (var i in this.prevCoords){}

                        this.prevCoords = coords;

                        var scale = (coords.ne2.x - coords.sw2.x)/_this.svgDefault.viewBox.width;

                        // var scale = (ne.x - sw.x)/_this.svgDefault.viewBox.width;
                        var vb = new ViewBox(
                            _this.svgDefault.viewBox.x - coords.sw2.x/scale,
                            _this.svgDefault.viewBox.y - coords.ne2.y/scale,
                            $(_this.containers.map).width()/scale,
                            $(_this.containers.map).outerHeight()/scale
                        );
                        _this.setViewBox(vb);
                        // var div = this.div_;
                        // div.style.background = 'rgba(255,0,0,.5)';
                        // div.style.left   = coords.sw.x + 'px';
                        // div.style.top    = coords.ne.y + 'px';
                        // div.style.width  = (coords.ne.x - coords.sw.x) + 'px';
                        // div.style.height = (coords.sw.y - coords.ne.y) + 'px';
                    };

                    var southWest = new google.maps.LatLng(_this.geoViewBox.sw.lat, _this.geoViewBox.sw.lng);
                    var northEast = new google.maps.LatLng(_this.geoViewBox.ne.lat, _this.geoViewBox.ne.lng);
                    var bounds = new google.maps.LatLngBounds(southWest,northEast);

                    _this.googleMaps.overlay = new USGSOverlay(bounds, _this.googleMaps.map);

                    if(!_this.options.googleMaps.center || !_this.options.googleMaps.zoom){
                        // var southWest = new google.maps.LatLng(_this.geoViewBox.bottomLat, _this.geoViewBox.leftLon);
                        // var northEast = new google.maps.LatLng(_this.geoViewBox.topLat, _this.geoViewBox.rightLon);
                        // var bounds = new google.maps.LatLngBounds(southWest,northEast);
                        _this.googleMaps.map.fitBounds(bounds, 0);
                    }else{
                        _this.googleMaps.map.setZoom(_this.options.googleMaps.zoom);
                        // _this.options.googleMaps.center.lat = parseFloat(_this.options.googleMaps.center.lat);
                        // _this.options.googleMaps.center.lng = parseFloat(_this.options.googleMaps.center.lng);
                        _this.googleMaps.map.setCenter(_this.options.googleMaps.center);
                    }
                    _this.googleMaps.initialized = true;
                    _this.googleMaps.map.addListener('idle',function(){
                        _this.isZooming = false;
                    });
                    google.maps.event.addListenerOnce(_this.googleMaps.map, 'idle', function(){

                        setTimeout(function() {
                            $(_this.containers.map).addClass('mapsvg-fade-in');
                            setTimeout(function() {
                                $(_this.containers.map).removeClass('mapsvg-google-map-loading');
                                $(_this.containers.map).removeClass('mapsvg-fade-in');
                                // _this.googleMaps.overlay.draw();
                                if(!_this.options.googleMaps.center || !_this.options.googleMaps.zoom) {
                                    _this.options.googleMaps.center = _this.googleMaps.map.getCenter().toJSON();
                                    _this.options.googleMaps.zoom = _this.googleMaps.map.getZoom();
                                }
                                _this.zoomDelta = _this.options.googleMaps.zoom - _this.zoomLevel;
                                _this.events.trigger('googleMapsLoaded');
                            }, 300);
                        }, 1);
                    });
                    // setTimeout(function(){
                    // _this.googleMaps.map.addListener('bounds_changed',function(){
                    //     _this.googleMaps.overlay.draw(1);
                    // if (!_this.isScrolling)
                    // setTimeout(function(){
                    //     if (!_this.isScrolling) {
                    //         null;
                    //     }
                    //         // _this.googleMaps.overlay.draw();
                    //         // _this.setViewBoxByGoogleMapBounds();
                    // },2);
                    // });
                    // _this.googleMaps.map.addListener('zoom_changed',function(){
                    //     setTimeout(function(){
                    //         _this.events.trigger('zoom');
                    //     },200);
                    // });

                    // _this.setViewBoxByGoogleMapBounds();
                    // },2500);

                }else{
                    $(_this.containers.map).toggleClass('mapsvg-with-google-map', true);
                    $(_this.containers.googleMaps) && $(_this.containers.googleMaps).show();
                    if(options.type){
                        _this.googleMaps.map.setMapTypeId(options.type);
                    }
                }
            }
        }else{
            // TODO: destroy google maps
            $(_this.containers.map).toggleClass('mapsvg-with-google-map', false);
            $(_this.containers.googleMaps) && $(_this.containers.googleMaps).hide();
            _this.googleMaps.initialized = false;

        }

    }
    /**
     * Loads Google Maps API (js file)
     * @param {function} callback - called on file load
     * @param fail
     * @private
     */
    loadGoogleMapsAPI (callback, fail){

        var _this = this;

        if(window.google !== undefined && google.maps){
            MapSVG.googleMapsApiLoaded = true;
        }

        if(MapSVG.googleMapsApiLoaded){
            if(typeof callback == 'function'){
                callback();
            }
            return;
        }

        MapSVG.googleMapsLoadCallbacks = MapSVG.googleMapsLoadCallbacks || [];
        if(typeof callback == 'function') {
            MapSVG.googleMapsLoadCallbacks.push(callback);
        }

        if(MapSVG.googleMapsApiIsLoading){
            return;
        }
        MapSVG.googleMapsApiIsLoading = true;

        // @ts-ignore
        window.gm_authFailure = function() {
            if(MapSVG.GoogleMapBadApiKey){
                MapSVG.GoogleMapBadApiKey();
            }else{
                if(_this.editMode) {
                    alert("Google maps API key is incorrect.");
                } else {
                    console.error("MapSVG: Google maps API key is incorrect.");
                }
            }
        };
        _this.googleMapsScript = document.createElement('script');
        _this.googleMapsScript.onload = function(){
            MapSVG.googleMapsApiLoaded = true;
            MapSVG.googleMapsLoadCallbacks.forEach(function(_callback){
                if(typeof callback == 'function')
                    _callback();
            });
        };
        var gmLibraries = [];
        if(_this.options.googleMaps.drawingTools){
            gmLibraries.push('drawing');
        }
        if(_this.options.googleMaps.geometry){
            gmLibraries.push('geometry');
        }
        var libraries = '';
        if(gmLibraries.length > 0 ){
            libraries = '&libraries='+ gmLibraries.join(',');
        }
        _this.googleMapsScript.src = 'https://maps.googleapis.com/maps/api/js?language=en&key='+_this.options.googleMaps.apiKey+libraries;

        document.head.appendChild(_this.googleMapsScript);
    }
    /**
     * Loads Details View for an object (Region or DB Object)
     * @param {Region|object} obj
     *
     * @example
     * var region = mapsvg.getRegion("US-TX");
     * mapsvg.loadDetailsView(region);
     *
     * var object = mapsvg.database.getLoadedObject(12);
     * mapsvg.loadDetailsView(object);
     */
    loadDetailsView (obj){

        var _this = this;

        _this.controllers.popover && _this.controllers.popover.close();
        if(_this.controllers.detailsView)
            _this.controllers.detailsView.destroy();

        _this.controllers.detailsView = new DetailsController({
            // color: _this.options.colors.detailsView,
            autoresize: MapSVG.isPhone && _this.options.detailsView.mobileFullscreen && _this.options.detailsView.location !== 'custom' ? false : _this.options.detailsView.autoresize,
            container: _this.containers.detailsView,
            template: obj instanceof Region ?  _this.templates.detailsViewRegion : _this.templates.detailsView,
            mapsvg: _this,
            data: obj.getData(this.regionsRepository.schema.name),
            modal: (MapSVG.isPhone && _this.options.detailsView.mobileFullscreen && _this.options.detailsView.location !== 'custom'),
            scrollable: (MapSVG.isPhone && _this.options.detailsView.mobileFullscreen && _this.options.detailsView.location !== 'custom') || _this.shouldBeScrollable(_this.options.detailsView.location),//['custom','header','footer'].indexOf(_this.options.detailsView.location) === -1,
            withToolbar: !(MapSVG.isPhone && _this.options.detailsView.mobileFullscreen && _this.options.detailsView.location !== 'custom') && _this.shouldBeScrollable(_this.options.detailsView.location),//['custom','header','footer'].indexOf(_this.options.detailsView.location) === -1,
            // width: _this.options.detailsView.width,
            events: {
                shown: function(mapsvg){
                    _this.events.trigger('shown.detailsView', _this);
                },
                closed: function(mapsvg){
                    _this.deselectAllRegions();
                    _this.deselectAllMarkers();
                    _this.controllers && _this.controllers.directory && _this.controllers.directory.deselectItems();
                    _this.events.trigger('closed.detailsView', _this);
                }
            }
        });
        _this.controllers.detailsView._init();
    }
    /**
     * Loads modal window with filters
     * @private
     */
    loadFiltersModal (){

        var _this = this;

        if(_this.options.filters.modalLocation != 'custom'){
            if(!_this.containers.filtersModal){
                _this.containers.filtersModal = $('<div class="mapsvg-details-container mapsvg-filters-wrap"></div>')[0];
            }
            _this.setColors();
            $(_this.containers.filtersModal).css({width: _this.options.filters.width});
            if(MapSVG.isPhone){
                $('body').append($(_this.containers.filtersModal));
                $(_this.containers.filtersModal).css({width: ''});
            }else{
                $(_this.containers[_this.options.filters.modalLocation]).append($(_this.containers.filtersModal));
            }
        }else{
            _this.containers.filtersModal = $('#'+_this.options.filters.containerId)[0];
            $(_this.containers.filtersModal).css({width: ''});
        }

        _this.loadFiltersController(_this.containers.filtersModal, true);

    }
    /**
     * Loads filters controller into a provided container
     * @param {HTMLElement} container - Container, jQuery object
     * @param {boolean} modal - If filter should be in a modal window
     */
    loadFiltersController (container: HTMLElement, modal: boolean = false){

        var _this = this;

        // If the list of filter fields is empty, exit
        if(_this.filtersSchema.getFields().length === 0){
            return;
        }

        let filtersInDirectory: boolean,
            filtersHide: boolean;

        if(MapSVG.isPhone){
            filtersInDirectory = true;
            filtersHide = _this.options.filters.hideOnMobile; //_this.filtersSchema.schema.length > 2;
        }else{
            filtersInDirectory = (_this.options.menu.on && _this.controllers.directory && _this.options.menu.location === _this.options.filters.location);
            filtersHide = _this.options.filters.hide;
        }
        var scrollable = modal || (!filtersInDirectory && (['leftSidebar','rightSidebar'].indexOf(_this.options.filters.location) !== -1));

        this.filtersRepository = _this.options.filters.source === 'regions' ? _this.regionsRepository : _this.objectsRepository;

        this.controllers.filters = new FiltersController({
            container: container,
            query: this.filtersRepository.query,
            mapsvg: _this,
            schema: _this.filtersSchema,
            template: Handlebars.compile('<div class="mapsvg-filters-container"></div>'),
            scrollable: scrollable,
            modal: modal,
            withToolbar: MapSVG.isPhone ? false : modal,
            width: $(container).hasClass('mapsvg-map-container') ? _this.options.filters.width : '100%',
            hide: _this.options.filters.hide,
            hideOnMobile: _this.options.filters.hideOnMobile,
            showButtonText: _this.options.filters.showButtonText,
            clearButton: _this.options.filters.clearButton,
            clearButtonText: _this.options.filters.clearButtonText,
            padding: _this.options.filters.padding,
            events: {
                'cleared.fields': () => {
                    _this.deselectAllRegions();
                },
                'changed.fields': () => {
                    _this.throttle(_this.filtersRepository.reload, 400, _this.filtersRepository);
                },
                'changed.search': () => {
                    _this.throttle(_this.filtersRepository.reload, 400, _this.filtersRepository);
                },
                'shown': function(mapsvg){
                },
                'closed': function(mapsvg){
                },
                'loaded': () => {
                    // TODO add resize sensor to directory instead of this:
                    console.log('_this.controllers.directory');
                    console.log(_this.controllers.directory);
                    _this.controllers.directory && _this.controllers.directory.updateTopShift();
                },
                'click.btn.showFilters': ()=>{
                    _this.loadFiltersModal();
                }

            }
        });
        this.controllers.filters._init();
    }
    /**
     * Event handler for text search input
     * @event
     * @param {string} text
     * @param {fallback} boolean
     * @private
     */
    textSearch (text: string, fallback: boolean = false){

        var query = new Query({
            filters: {"search": text},
            searchFallback: fallback
        });

        this.filtersRepository.find(query);
    }
    /**
     * Finds a Region by ID
     * @param {string} id - Region ID
     * @returns {Region}

     * @example
     * var region = mapsvg.getRegion("US-TX");
     */
    getRegion (id): Region {
        return this.regions.findById(id);
    }
    /**
     * Returns all Regions
     * @returns {Region[]}
     */
    getRegions () {
        return this.regions;
    }
    /**
     * Finds a Marker by ID
     * @param {string} id - Marker ID
     * @returns {Marker}

     * @example
     * var marker = mapsvg.getMarker("marker_12");
     */
    getMarker (id): Marker {
        return this.markers.findById(id);
    }
    /**
     * Checks if IDs is unique
     * @param id
     * @returns {bool|string} - true if ID is available, {error: "error text"} if not.
     * @private
     */
    checkId (id){
        var _this = this;
        if(_this.getRegion(id))
            return {error: "This ID is already being used by a Region"};
        else if(_this.getMarker(id))
            return {error: "This ID is already being used by another Marker"};
        else
            return true;

    }
    /**
     * Redraws colors of regions.
     * Used when Region statuses are loaded from the database or when choropleth map is enabled.
     */
    regionsRedrawColors(){
        var _this = this;
        _this.regions.forEach(function(region){
            region.setFill();
        });
    }
    /**
     * Redraw choropleth bubbles.
     */
    redrawBubbles(){
        $(this.containers.map).removeClass('bubbles-regions-on bubbles-database-on');

        if (this.options.choropleth.on && this.options.choropleth.bubbleMode){
            $(this.containers.map).addClass('bubbles-'+this.options.choropleth.source+'-on');
        }

        this.regions.forEach(function(region){
            region.drawBubble();
        });

        this.objectsRepository.objects.forEach(function (object){
            object.location.marker.setBubbleMode();
        });
    }
    /**
     * Destroys the map and all related containers.
     * @returns {Map}
     */
    destroy (){
        var _this = this;
        if(_this.controllers && _this.controllers.directory){
            _this.controllers.directory.mobileButtons.remove();
        }
        $(_this.containers.map).empty().insertBefore($(_this.containers.wrapAll)).attr('style','').removeClass('mapsvg mapsvg-responsive');

        _this.controllers.popover && _this.controllers.popover.close();

        if(_this.controllers.detailsView)
            _this.controllers.detailsView.destroy();

        $(_this.containers.wrapAll).remove();

        return _this;
    }
    /**
     * Was used previously to return _data that contained all map properties.
     * Now properties are stored in the map instance itself.
     * @returns {Map}
     */
    getData(): {[key: string]: any} {
        return {
            id: this.id,
            title: this.options.title,
            options: this.getOptions(false, false)
        };
    }
    /**
     * Checks if fitmarkers() action can be performed and does it
     * @private
     */
    mayBeFitMarkers(){

        var _this = this;

        if(!this.lastTimeFitWas){
            this.lastTimeFitWas = Date.now() - 99999;
        }

        this.fitDelta = Date.now() - this.lastTimeFitWas;

        if(this.fitDelta > 1000 && !_this.firstDataLoad && !_this.fitOnDataLoadDone && _this.options.fitMarkers){
            _this.fitMarkers();
            _this.fitOnDataLoadDone = true;
        }
        if(_this.firstDataLoad && _this.options.fitMarkersOnStart){
            _this.firstDataLoad = false;
            if(_this.options.googleMaps.on && !_this.googleMaps.map){
                _this.events.on('googleMapsLoaded', function(){
                    _this.fitMarkers();
                });
            }else{
                _this.fitMarkers();
            }
        }

        this.lastTimeFitWas = Date.now();
    }
    /**
     * Changes maps viewBox to fit loaded markers.
     */
    fitMarkers (){

        var _this = this;

        var dbObjects = _this.objectsRepository.getLoaded();

        if(!dbObjects || dbObjects.length === 0){
            return;
        }

        if(_this.options.googleMaps.on && typeof google !== "undefined"){

            var lats = []; var lngs = [];

            if(dbObjects.length > 1){
                dbObjects.forEach(function(object){
                    if(object.location && object.location.geoPoint){
                        lats.push(object.location.geoPoint.lat);
                        lngs.push(object.location.geoPoint.lng);
                    }
                });

                // calc the min and max lng and lat
                var minlat = Math.min.apply(null, lats),
                    maxlat = Math.max.apply(null, lats);
                var minlng = Math.min.apply(null, lngs),
                    maxlng = Math.max.apply(null, lngs);

                var bbox = new google.maps.LatLngBounds({lat: minlat, lng: minlng},{lat: maxlat, lng: maxlng});
                _this.googleMaps.map.fitBounds(bbox, 0);
            } else {
                if(dbObjects[0].location && dbObjects[0].location.lat && dbObjects[0].location.lng){
                    var coords = {lat: dbObjects[0].location.lat, lng: dbObjects[0].location.lng};
                    if(_this.googleMaps.map){
                        _this.googleMaps.map.setCenter(coords);
                        var max = _this.googleMaps.zoomLimit ? 17 : 20;
                        _this.googleMaps.map.setZoom(max);
                    }
                }

            }
        } else {
            if(_this.options.clustering.on){
                let arr = [];
                _this.markersClusters.forEach(function(c){
                    arr.push(c);
                })
                _this.markers.forEach(function(m){
                    arr.push(m);
                })
                return _this.zoomTo(arr);
            } else {
                return _this.zoomTo(_this.markers);
            }
        }
    }
    /**
     * Shows user current location
     * Works only under HTTPS connection
     * @returns {boolean|object} - "false" if geolocation is unavailable, or {lat: float, lng: float} if it's available
     */
    showUserLocation (callback){

        var _this = this;

        this.getUserLocation(function(geoPoint: GeoPoint){

            _this.userLocation = null;
            _this.userLocation = new Location({
                geoPoint: geoPoint,
                img: MapSVG.urls.root+'/markers/user-location.svg'
            });
            _this.userLocationMarker && _this.userLocationMarker.delete();
            _this.userLocationMarker = new Marker({
                location: _this.userLocation,
                mapsvg: _this,
                width: 15,
                height: 15
            });
            $(_this.userLocationMarker.element).addClass('mapsvg-user-location');
            _this.userLocationMarker.centered = true;
            $(_this.containers.scrollpane).append(_this.userLocationMarker.element);
            _this.userLocationMarker.adjustPosition();
            callback && callback(_this.userLocation);
        });
    }
    /**
     * Gets user's current location by using browser's HTML5 geolocation feature.
     * Works only under HTTPS connection!
     * @returns {boolean|object} - "false" if geolocation is unavailable, or {lat: float, lng: float} if it's available
     */
    getUserLocation (callback){

        var _this = this;

        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(function(position){
                var pos = new GeoPoint(position.coords.latitude, position.coords.longitude);
                callback && callback(pos);
            });
        } else {
            return false;
        }
    }
    /**
     * Returns current SVG scale related to screen - map screen pixels to SVG points ratio.
     * Example: if SVG current viewBox width is 600 and the map is shown in a 300px container,
     * the map scale is 0.5 (300/600 = 0.5)
     * @returns {number}
     */
    getScale(){

        var _this = this;

        var scale2 = $(_this.containers.map).width() / _this.viewBox.width;

        return scale2 || 1;
    }
    /**
     * Updates size of the map and containers
     * @private
     */
    updateSize (){

        var _this = this;

        _this.scale = _this.getScale();
        _this.controllers.popover && _this.controllers.popover.adjustPosition();
        _this.markersAdjustPosition();
        if(_this.options.labelsRegions.on){
            _this.labelsRegionsAdjustPosition();
        }
        if(_this.options.choropleth.on && _this.options.choropleth.bubbleMode){
            _this.redrawBubbles();
        }
        _this.mapAdjustStrokes();
        // if(_this.directoryWrap)
        //     _this.directoryWrap.height($(_this.containers.wrap).outerHeight());
    }
    /**
     * Returns current viewBox
     * @returns {array} - [x,y,width,height]
     */
    getViewBox (){
        return this.viewBox;
    }
    /**
     * Sets map container size and viewBox size.
     * This method should be used when you need to change both map container size and viewBox size.
     * @param {number} width
     * @param {number} height
     * @returns {Array} - viewBox, [x,y,width,height]
     */
    viewBoxSetBySize (width,height){

        var _this = this;

        width = parseFloat(width);
        height = parseFloat(height);
        _this.setSize(width,height);
        _this._viewBox = _this.viewBoxGetBySize(width,height);
        // _this.options.width = parseFloat(width);
        // _this.options.height = parseFloat(height);

        _this.setViewBox(_this._viewBox);
        $(window).trigger('resize');
        _this.setSize(width,height);
        _this.setZoomLevels();

        // _this.whRatio = _this.viewBox.width / _this.viewBox.height;
        // if(!_this.options.responsive)
        //     _this.setResponsive();

        return _this.viewBox;
    }
    /**
     * Returns viewBox for a provided width/height
     * @param width
     * @param height
     * @returns {Array} - viewBox, [x,y,width,height]
     * @private
     */
    viewBoxGetBySize (width, height){

        var _this = this;

        var new_ratio = width / height;
        var old_ratio = _this.svgDefault.viewBox.width / _this.svgDefault.viewBox.height;

        var vb = $.extend([],_this.svgDefault.viewBox);

        if (new_ratio != old_ratio){
            //vb[2] = width*_this.svgDefault.viewBox.width / _this.svgDefault.width;
            //vb[3] = height*_this.svgDefault.viewBox.height / _this.svgDefault.height;
            if (new_ratio > old_ratio){
                vb[2] = _this.svgDefault.viewBox.height * new_ratio;
                vb[0] = _this.svgDefault.viewBox.x - ((vb[2] - _this.svgDefault.viewBox.width)/2);
            }else{
                vb[3] = _this.svgDefault.viewBox.width / new_ratio;
                vb[1] = _this.svgDefault.viewBox.y - ((vb[3] - _this.svgDefault.viewBox.height)/2);
            }

        }

        return vb;
    }
    /**
     * Resets map zoom and scroll to initial position.
     * @param {bool} toInitial - Set to "true" if you want to reset to initial viewBox that was set by user;
     * set to "false" to reset to original SVG viewBox as defined in the SVG file
     * @returns {Array} - viewBox, [x,y,width,height]
     */
    viewBoxReset (toInitial){

        var _this = this;

        if(_this.options.googleMaps.on && _this.googleMaps.map){
            if(!toInitial){
                _this.options.googleMaps.center = null;
                _this.options.googleMaps.zoom = null;
            }
            if(!_this.options.googleMaps.center || !_this.options.googleMaps.zoom){
                var southWest = new google.maps.LatLng(_this.geoViewBox.sw.lat, _this.geoViewBox.sw.lng);
                var northEast = new google.maps.LatLng(_this.geoViewBox.ne.lat, _this.geoViewBox.ne.lng);
                var bounds = new google.maps.LatLngBounds(southWest,northEast);
                _this.googleMaps.map.fitBounds(bounds, 0);
                _this.options.googleMaps.center = _this.googleMaps.map.getCenter().toJSON();
                _this.options.googleMaps.zoom = _this.googleMaps.map.getZoom();
            }else{
                _this.googleMaps.map.setZoom(_this.options.googleMaps.zoom);
                _this.googleMaps.map.setCenter(_this.options.googleMaps.center);
            }
        }else{
            if(toInitial){
                var v = _this._viewBox || _this.svgDefault.viewBox;
                _this.zoomLevel = 0;
                _this._scale = 1;
                _this.setViewBox(v);
            }else{
                _this.setViewBox();
            }
        }
        return this.viewBox;
    }
    /**
     * Returns geo-bounds of the map.
     * @returns {number[]} - [leftLon, topLat, rightLon, bottomLat]
     */
    getGeoViewBox (){

        var _this = this;

        var v  = _this.viewBox;
        var p1 = new SVGPoint(v.x,v.y);
        var p2 = new SVGPoint(v.x+v.width,v.y);
        var p3 = new SVGPoint(v.x,v.y);
        var p4 = new SVGPoint(v.x,v.y+v.height);

        var leftLon   = _this.convertSVGToGeo(p1).lng;
        var rightLon  = _this.convertSVGToGeo(p2).lng;
        var topLat    = _this.convertSVGToGeo(p3).lat;
        var bottomLat = _this.convertSVGToGeo(p4).lat;

        return [leftLon, topLat, rightLon, bottomLat];
    }
    /**
     * Adjusts stroke widths on zoom change to keeps their widths the same on all zoom levels.
     */
    mapAdjustStrokes (){

        var _this = this;

        // TODO add an option to turn on/off non-scaling strokes
        this.regions.forEach(region => region.adjustStroke(_this.scale));

        // $(this.containers.svg).find('path, polygon, circle, ellipse, rect').each(function(index){
        //     if($(this).data('stroke-width')) {
        //         $(this).css('stroke-width', $(this).data('stroke-width') / _this.scale);
        //     }
        // });
    }
    /**
     * Zooms-in the map
     * @param {SVGPoint} center - if provided, zoom will shift the center point
     */
    zoomIn(center?: SVGPoint){

        var _this = this;

        if(_this.googleMaps.map){
            if(!_this.isZooming){
                var currentZoomInRange = _this.zoomLevel >= _this.options.zoom.limit[0] && _this.zoomLevel <= _this.options.zoom.limit[1];
                var zoom = _this.googleMaps.map.getZoom();
                // Limit zoom of Google map to level "17"
                // If zoom more - browser can't position markers
                // because css transform/translate is limited to 33mil px
                // var google_zoom_new = (zoom+1) > 17 ? 17 : zoom+1;
                var max = _this.googleMaps.zoomLimit ? 17 : 20;
                var google_zoom_new = (zoom+1) > max ? max : zoom+1;
                var svg_zoom_new = google_zoom_new - _this.zoomDelta;

                var newZoomInInRange = svg_zoom_new >= _this.options.zoom.limit[0] && svg_zoom_new <= _this.options.zoom.limit[1];
                if(currentZoomInRange && !newZoomInInRange){
                    return false;
                }
                _this.isZooming = true;
                _this.googleMaps.map.setZoom(google_zoom_new);

                if(center){
                    var centerGeo = _this.convertSVGToGeo(center);
                    _this.googleMaps.map.setCenter(centerGeo);
                }

                _this.zoomLevel = svg_zoom_new;
            }
        }else if(_this.canZoom){
            _this.canZoom = false;
            setTimeout(function(){
                _this.canZoom = true;
            }, 700);
            _this.zoom(1, center);
        }
    }
    /**
     * Zooms-out the map
     * @param {SVGPoint} center - [x,y] center point (optional)
     */
    zoomOut(center?: SVGPoint){

        var _this = this;

        if(_this.googleMaps.map){
            if(!_this.isZooming && _this.googleMaps.map.getZoom()-1 >= _this.options.googleMaps.minZoom) {

                var currentZoomInRange = _this.zoomLevel >= _this.options.zoom.limit[0] && _this.zoomLevel <= _this.options.zoom.limit[1];

                var zoom = _this.googleMaps.map.getZoom();
                var google_zoom_new = (zoom - 1) < 1 ? 1 : (zoom-1);
                var svg_zoom_new = google_zoom_new - _this.zoomDelta;

                var newZoomInInRange = svg_zoom_new >= _this.options.zoom.limit[0] && svg_zoom_new <= _this.options.zoom.limit[1];

                if(currentZoomInRange && !newZoomInInRange){
                    return false;
                }
                _this.isZooming = true;
                _this.googleMaps.map.setZoom(google_zoom_new);
                _this.zoomLevel = svg_zoom_new;
            }
        }else if(_this.canZoom){
            _this.canZoom = false;
            setTimeout(function(){
                _this.canZoom = true;
            }, 700);
            _this.zoom(-1, center);
        }
    }
    /**
     * Event handler, zoom on 2-fingers touch
     * @event
     * @param touchScale
     * @private
     */
    touchZoomMove (){

    }
    /**
     * Event handler, zoom on 2-fingers touch
     * @event
     * @param touchScale
     * @private
     */
    touchZoomEnd (){

    }
    /**
     * Zooms to Region, Marker or array of Markers.
     * @param {String|Region|Marker|Marker[]|MarkersCluster[]} mapObjects - Region ID, Region, Marker, array of Markers, array of MarkerClusters
     * @param {number} zoomToLevel - Zoom level
     *
     * @example
     * var region = mapsvg.getRegion("US-TX");
     * mapsvg.zoomTo(region);
     */
    zoomTo  (mapObjects, zoomToLevel?: number){

        var _this = this;

        // If string if provided - its a region ID.
        if(typeof mapObjects == 'string') {
            mapObjects = _this.getRegion(mapObjects);
        }

        if(_this.googleMaps.map) {
            if(mapObjects instanceof Marker){
                var geoPoint = _this.convertSVGToGeo(mapObjects.svgPoint);
                _this.googleMaps.map.setZoom(zoomToLevel || 1);
                _this.googleMaps.map.setCenter({lat: geoPoint.lat, lng: geoPoint.lng});
                this.zoomLevel = this.googleMaps.map.getZoom() - this.zoomDelta;
            }else{
                if(mapObjects && mapObjects.length !== undefined){
                    var rbounds = mapObjects[0].getGeoBounds();
                    var southWest = new google.maps.LatLng(rbounds.sw.lat, rbounds.sw.lng);
                    var northEast = new google.maps.LatLng(rbounds.ne.lat, rbounds.ne.lng);
                    var bounds = new google.maps.LatLngBounds(southWest,northEast);
                    for(var i = 1; i < mapObjects.length-1; i++){
                        var rbounds2 = mapObjects[i].getGeoBounds();
                        var southWest2 = new google.maps.LatLng(rbounds2.sw.lat, rbounds2.sw.lng);
                        var northEast2 = new google.maps.LatLng(rbounds2.ne.lat, rbounds2.ne.lng);
                        bounds.extend(southWest2);
                        bounds.extend(northEast2);
                    }
                } else {
                    var objectBounds = mapObjects.getGeoBounds();
                    var southWest = new google.maps.LatLng(objectBounds.sw.lat, objectBounds.sw.lng);
                    var northEast = new google.maps.LatLng(objectBounds.ne.lat, objectBounds.ne.lng);
                    var bounds = new google.maps.LatLngBounds(southWest,northEast);
                }
                _this.googleMaps.map.fitBounds(bounds, 0);
                if(_this.googleMaps.zoomLimit && (_this.googleMaps.map.getZoom() > 17)){
                    _this.googleMaps.map.setZoom(17);
                }
                this.zoomLevel = this.googleMaps.map.getZoom() - this.zoomDelta;
            }
            return;
        }

        let bbox: ViewBox,
            viewBox: ViewBox,
            viewBoxPrev: ViewBox;

        if(mapObjects instanceof Marker || mapObjects instanceof MarkerCluster){
            return _this.zoomToMarkerOrCluster(mapObjects, zoomToLevel);
        }

        if(typeof mapObjects == 'object' && mapObjects.length !== undefined){
            // multiple objects
            var _bbox;

            if(mapObjects[0] instanceof Region){
                bbox = mapObjects[0].getBBox();
                var xmin = [bbox.x];
                var ymin = [bbox.y];

                var w = (bbox.x+bbox.width);
                var xmax = [w];
                var h = (bbox.y+bbox.height);
                var ymax = [h];
                if (mapObjects.length > 1){
                    for (var i = 1; i < mapObjects.length; i++){
                        _bbox = mapObjects[i].getBBox();
                        xmin.push(_bbox.x);
                        ymin.push(_bbox.y);
                        var _w = _bbox.x+_bbox.width;
                        var _h = _bbox.y+_bbox.height;
                        xmax.push(_w);
                        ymax.push(_h);
                    }
                }
                var _xmin = Math.min.apply(Math, xmin);
                var _ymin = Math.min.apply(Math, ymin);

                // @ts-ignore
                var w = Math.max.apply(Math, _xmax) - _xmin;
                // @ts-ignore
                var h = Math.max.apply(Math, _ymax) - _ymin;
                bbox = new ViewBox(_xmin, _ymin, w, h);
            } else if(mapObjects[0] instanceof Marker || mapObjects[0] instanceof MarkerCluster) {
                var xs = []; var ys = [];

                if(mapObjects.length === 1){
                    return _this.zoomToMarkerOrCluster(mapObjects[0]);
                }

                mapObjects.forEach(function(object){
                    xs.push(object.svgPoint.x);
                    ys.push(object.svgPoint.y);
                });

                // calc the min and max lng and lat
                var minx = Math.min.apply(null, xs),
                    maxx = Math.max.apply(null, xs);
                var miny = Math.min.apply(null, ys),
                    maxy = Math.max.apply(null, ys);

                var padding = 10;
                var point1 = new ScreenPoint(padding,0);
                var point2 = new ScreenPoint(0,0);
                padding = _this.convertPixelToSVG(point1).x - _this.convertPixelToSVG(point2).x;

                var width  = maxx - minx;
                var height = maxy - miny;
                bbox = new ViewBox(minx-padding, miny-padding, width+padding*2, height+padding*2);
            }

        }else{
            // single object
            bbox = mapObjects.getBBox();
        }

        var searching = true;

        this.zoomLevels.forEach( (zoomLevel) => {
            if(searching && (viewBoxPrev && viewBoxPrev.x !== undefined)){
                if(
                    (viewBoxPrev.width > bbox.width && viewBoxPrev.height > bbox.height)
                    &&
                    (bbox.width > zoomLevel.viewBox.width || bbox.height > zoomLevel.viewBox.height)
                )
                {
                    _this.zoomLevel = zoomToLevel ? zoomToLevel :  zoomLevel.zoomLevel-1;
                    var vb = _this.zoomLevels.get(_this.zoomLevel).viewBox;

                    var newVb = new ViewBox(
                        bbox.x-vb.width/2+bbox.width/2,
                        bbox.y-vb.height/2+bbox.height/2,
                        vb.width,
                        vb.height
                    )
                    _this.setViewBox(newVb);
                    _this._scale = _this.zoomLevels[_this.zoomLevel]._scale;
                    searching = false;

                }
            }
            viewBoxPrev = zoomLevel && zoomLevel.viewBox;
        });
    }
    /**
     * Zooms to a single marker or cluster
     * @param mapObject
     * @param zoomToLevel
     * @private
     */
    zoomToMarkerOrCluster (mapObject, zoomToLevel?: number){

        var _this = this;

        _this.zoomLevel = zoomToLevel || 1;
        var vb = _this.zoomLevels.get(_this.zoomLevel).viewBox;
        var newViewBox = new ViewBox(
            mapObject.x-vb.width/2,
            mapObject.y-vb.height/2,
            vb.width,
            vb.height
        );
        _this.setViewBox(newViewBox);

        _this._scale = _this.zoomLevels.get(_this.zoomLevel)._scale;
        return;
    }
    /**
     * Centers map on Region or Marker.
     * @param {Region|Marker} region - Region or Marker
     * @param {number} yShift - Vertical shift from center. Used by showPopover method to fit popover in the map container
     */
    centerOn (region: Region|Marker, yShift?: number){

        var _this = this;

        if(_this.options.googleMaps.on){
            yShift = yShift ? (yShift+12)/_this.getScale() : 0;
            $(_this.containers.map).addClass('scrolling');
            var latLng = region.getCenterLatLng(yShift);
            _this.googleMaps.map.panTo(latLng);
            setTimeout(function(){
                $(_this.containers.map).removeClass('scrolling');
            },100);
        }else{
            yShift = yShift ? (yShift+12)/_this.getScale() : 0;
            var bbox = region.getBBox();
            var vb   = _this.viewBox;
            var newViewBox = new ViewBox(
                    bbox.x-vb.width/2+bbox.width/2,
                    bbox.y-vb.height/2+bbox.height/2 - yShift,
                    vb.width,
                    vb.height
                );
            _this.setViewBox(newViewBox);
        }

    }
    /**
     * Zooms the map
     * @param {number} delta - 1/-1
     * @param {SVGPoint} center - [x,y] zoom center point
     * @param {number} exact - (optional) Exact scale value
     * @returns {boolean}
     */
    zoom  (delta: number, center?: SVGPoint, exact?: number){

        var _this = this;

        var vWidth     = _this.viewBox.width;
        var vHeight    = _this.viewBox.height;
        var newViewBox = new ViewBox(0,0,0,0);

        var isInZoomRange = _this.zoomLevel >= _this.options.zoom.limit[0] && _this.zoomLevel <= _this.options.zoom.limit[1];

        if(!exact){
            // check for zoom limit
            var d = delta > 0 ? 1 : -1;

            if(!_this.zoomLevels.get(_this.zoomLevel+d))
                return;

            _this._zoomLevel = _this.zoomLevel;
            _this._zoomLevel += d;

            if(isInZoomRange && (_this._zoomLevel > _this.options.zoom.limit[1] || _this._zoomLevel < _this.options.zoom.limit[0]))
                return false;

            _this.zoomLevel = _this._zoomLevel;
            //
            //var zoom_k = d * _this.options.zoom.delta;
            //if (zoom_k < 1) zoom_k = -1/zoom_k;
            //
            //_this._scale         = _this._scale * zoom_k;
            //newViewBox.width  = _this._viewBox.width / _this._scale;
            //newViewBox.height  = _this._viewBox.height / _this._scale;

            var z = _this.zoomLevels.get(_this.zoomLevel);
            _this._scale         = z._scale;
            newViewBox           = z.viewBox;
        }else{
            // var foundZoomLevel = false, i = 1, prevScale, newScale;
            // prevScale = _this.zoomLevels[0]._scale;
            // while(!foundZoomLevel){
            //     if(exact >= prevScale && exact <= _this.zoomLevels[i]._scale){
            //         foundZoomLevel = _this.zoomLevels[i];
            //     }
            //     i++;
            // }
            // if(isInZoomRange && (foundZoomLevel > _this.options.zoom.limit[1] || foundZoomLevel < _this.options.zoom.limit[0]))
            //     return false;

            // _this._scale    = exact;
            // _this.zoomLevel = foundZoomLevel;


            newViewBox.width  = _this._viewBox.width / exact;
            newViewBox.height  = _this._viewBox.height / exact;
        }

        var shift = [];
        if(center){
            var koef = d > 0 ? 0.5 : -1; // 1/2 * (d=1) || 2 * (d=-1)
            shift = [((center.x - _this.viewBox.x) * koef), ((center.y - _this.viewBox.y) * koef)];
            newViewBox.x = _this.viewBox.x + shift[0];
            newViewBox.y = _this.viewBox.y + shift[1];
        }else{
            shift = [(vWidth - newViewBox.width) / 2, (vHeight - newViewBox.height) / 2];
            newViewBox.x  = _this.viewBox.x + shift[0];
            newViewBox.y  = _this.viewBox.y + shift[1];
        }
        // Limit scroll to map's boundaries
        if(_this.options.scroll.limit)
        {
            if(newViewBox.x < _this.svgDefault.viewBox.x)
                newViewBox.x = _this.svgDefault.viewBox.x;
            else if(newViewBox.x + newViewBox.width > _this.svgDefault.viewBox.x + _this.svgDefault.viewBox.width)
                newViewBox.x = _this.svgDefault.viewBox.x+_this.svgDefault.viewBox.width-newViewBox.width;

            if(newViewBox.y < _this.svgDefault.viewBox.y)
                newViewBox.y = _this.svgDefault.viewBox.y;
            else if(newViewBox.y + newViewBox.height > _this.svgDefault.viewBox.y +_this.svgDefault.viewBox.height)
                newViewBox.y = _this.svgDefault.viewBox.y+_this.svgDefault.viewBox.height-newViewBox.height;
        }

        _this.setViewBox(newViewBox);
        // _this.events.trigger('zoom');
    }
    /**
     * Deletes a marker
     * @param {Marker} marker
     */
    markerDelete(marker: Marker){

        var _this = this;

        if(_this.editingMarker && _this.editingMarker.id == marker.id){
            _this.editingMarker = null;
            delete _this.editingMarker;
        }

        if(this.markers.findById(marker.id)) {
            this.markers.findById(marker.id).element.remove();
            this.markers.delete(marker.id);
            marker = null;
        }
        if (_this.markers.length === 0)
            _this.options.markerLastID = 0;
    }
    /**
     * Adds a marker cluster
     * @param {MarkerCluster} markersCluster
     */
    markersClusterAdd (markersCluster: MarkerCluster) {
        var _this = this;
        _this.layers.markers.append(markersCluster.elem);
        _this.markersClusters.push(markersCluster);
        markersCluster.adjustPosition();
    }
    /** Adds a marker to the map.
     * @param {Marker} marker
     * @example
     */
    markerAdd (marker) {

        var _this = this;

        $(marker.element).hide();
        marker.adjustPosition();
        _this.layers.markers.append(marker.element);
        _this.markers.push(marker);
        marker.mapped = true;
        setTimeout(function(){
            $(marker.element).show();
        },100);
    }
    /**
     * Removes marker from the map
     * @param marker
     */
    markerRemove (marker: Marker) {

        var _this = this;

        if(_this.editingMarker && _this.editingMarker.id == marker.id){
            _this.editingMarker = null;
            delete _this.editingMarker;
        }

        if(this.markers.findById(marker.id)) {
            this.markers.findById(marker.id).element.remove();
            this.markers.delete(marker.id);
            marker = null;
        }
        if (_this.markers.length === 0)
            _this.options.markerLastID = 0;    }
    /**
     * Generates new Marker ID
     * @returns {*}
     * @private
     */
    markerId(){

        var _this = this;

        _this.options.markerLastID = _this.options.markerLastID + 1;
        var id = 'marker_'+(_this.options.markerLastID);
        if(_this.getMarker(id))
            return _this.markerId();
        else
            return id;
    }

    /**
     * Adjusts position of Region Labels
     */
    labelsRegionsAdjustPosition (){

        var _this = this;

        var dx, dy;
        if(!$(_this.containers.map).is(":visible")){
            return;
        }
        _this.regions.forEach(function(region){
            if(!region.center){
                region.center = region.getCenterSVG();
            }
            var pos = _this.convertSVGToPixel(region.center);
            if(region.textLabel)
                region.textLabel.style.transform = 'translate(-50%,-50%) translate(' + pos.x + 'px,' + pos.y + 'px)';
        });
    }
    /**
     * Adjusts position of Markers and MarkerClusters.
     * This method is called on zoom or when map container is resized.
     */
    markersAdjustPosition (){

        var _this = this;

        _this.markers.forEach(function(marker){
            marker.adjustPosition();
        });
        _this.markersClusters.forEach(function(cluster){
            cluster.adjustPosition();
        });
        if(_this.userLocationMarker){
            _this.userLocationMarker.adjustPosition();
        }
    }
    /**
     * Drag marker event handler. Used in Map Editor.
     * @event
     * @private
     */
    markerMoveStart(){

        // var _this = this;

        // storing original coordinates
        // this.data('ox', parseFloat(this.attr('x')));
        // this.data('oy', parseFloat(this.attr('y')));
    }
    /**
     * Drag marker event handler. Used in Map Editor.
     * @event
     * @private
     */
    markerMove  (dx, dy) {
        // var _this = this;
        // dx = dx / _this.scale;
        // dy = dy / _this.scale;
        // this.attr({x: this.data('ox') + dx, y: this.data('oy') + dy});
    }
    /**
     * Drag marker event handler. Used in Map Editor.
     * @event
     * @private
     */
    markerMoveEnd  () {

        // var _this = this;
        //
        // // if coordinates are same then it was a "click" and we should start editing
        // if(this.data('ox') == this.attr('x') && this.data('oy') == this.attr('y')){
        //     options.markerEditHandler.call(this);
        // }
    }
    /**
     * Sets marker into "edit mode".
     * Used in Map Editor.
     * @param {Marker} marker
     * @private
     */
    setEditingMarker  (marker: Marker) {

        var _this = this;

        _this.editingMarker = marker;
        if(!_this.editingMarker.mapped){
            _this.editingMarker.needToRemove = true;
            // _this.editingMarker.node.addClass("mapsvg-editing-marker");
            _this.markerAdd(_this.editingMarker);
        }
    }
    /**
     * Disables marker "edit mode".
     * Used in Map Editor.
     * @private
     */
    unsetEditingMarker (){
        var _this = this;
        if(_this.editingMarker && _this.editingMarker.needToRemove){
            _this.markerRemove(_this.editingMarker);
        }
        _this.editingMarker = null;
    }
    /**
     * Returns marker that is currently in the "edit mode"
     * Used in Map Editor.
     * @private
     */
    getEditingMarker (){
        var _this = this;
        return _this.editingMarker;
    }
    /**
     * Event handler - called when map scroll starts
     * @param e
     * @param mapsvg
     * @returns {boolean}
     * @event
     * @private
     */
    scrollStart(e,mapsvg){

        var _this = this;

        if($(e.target).hasClass('mapsvg-btn-map') || $(e.target).closest('.mapsvg-choropleth').length)
            return false;

        if(_this.editMarkers.on && $(e.target).hasClass('mapsvg-marker'))
            return false;

        e.preventDefault();

        $(this.containers.map).addClass('no-transitions');

        var ce = e.originalEvent && e.originalEvent.touches && e.originalEvent.touches[0] ? e.originalEvent.touches[0] : e;

        _this.scrollStarted = true;

        this.scroll = {
            tx: _this.scroll.tx || 0,
            ty: _this.scroll.ty || 0,
            // initial viewbox when scrollning started
            vxi: _this.viewBox.x,
            vyi: _this.viewBox.y,
            // mouse coordinates when scrolling started
            x: ce.clientX,
            y: ce.clientY,
            // mouse delta
            dx: 0,
            dy: 0,
            // new viewbox x/y
            vx: 0,
            vy: 0,
            // for google maps scroll
            gx: ce.clientX,
            gy: ce.clientY,
            touchScrollStart: 0
        };


        if(e.type.indexOf('mouse') === 0 ){
            $(document).on('mousemove.scroll.mapsvg', function(e){
                _this.scrollMove(e);
            });
            if(_this.options.scroll.spacebar){
                $(document).on('keyup.scroll.mapsvg', function (e) {
                    if (e.keyCode == 32) {
                        _this.scrollEnd(e, mapsvg);
                    }
                });
            }else{
                $(document).on('mouseup.scroll.mapsvg', function(e){
                    _this.scrollEnd(e,mapsvg);
                });
            }
        }
    }
    /**
     * Event handler - called when map scroll moves
     * @param e
     * @event
     * @private
     */
    scrollMove(e){

        var _this = this;

        e.preventDefault();

        if(!_this.isScrolling){
            _this.isScrolling = true;
            // $(_this.containers.map).css('pointer-events','none');
            $(_this.containers.map).addClass('scrolling');
        }

        var ce = e.originalEvent && e.originalEvent.touches && e.originalEvent.touches[0] ? e.originalEvent.touches[0] : e;

        // TODO: на каждый зум лев считать допустимые translate xy при данном scale
        var scrolled = _this.panBy((_this.scroll.gx - ce.clientX),(_this.scroll.gy - ce.clientY));
        if(_this.googleMaps.map && (scrolled.x || scrolled.y)){

            var point = _this.googleMaps.map.getCenter();

            var projection = _this.googleMaps.overlay.getProjection();

            var pixelpoint = projection.fromLatLngToDivPixel(point);
            pixelpoint.x += scrolled.x ? _this.scroll.gx - ce.clientX : 0;
            pixelpoint.y += scrolled.y ? _this.scroll.gy - ce.clientY : 0;

            point = projection.fromDivPixelToLatLng(pixelpoint);

            _this.googleMaps.map.setCenter(point);
        }

        _this.scroll.gx  = ce.clientX;
        _this.scroll.gy  = ce.clientY;

        // delta x/y
        _this.scroll.dx = (_this.scroll.x - ce.clientX);
        _this.scroll.dy = (_this.scroll.y - ce.clientY);

        // new viewBox x/y
        var vx = _this.scroll.vxi + _this.scroll.dx /_this.scale;
        var vy = _this.scroll.vyi + _this.scroll.dy /_this.scale;

        // Limit scroll to map boundaries
        if(_this.options.scroll.limit){

            if(vx < _this.svgDefault.viewBox.x)
                vx = _this.svgDefault.viewBox.x;
            else if(_this.viewBox.width + vx > _this.svgDefault.viewBox.x + _this.svgDefault.viewBox.width)
                vx = (_this.svgDefault.viewBox.x+_this.svgDefault.viewBox.width-_this.viewBox.width);

            if(vy < _this.svgDefault.viewBox.y)
                vy = _this.svgDefault.viewBox.y;
            else if(_this.viewBox.height + vy > _this.svgDefault.viewBox.y + _this.svgDefault.viewBox.height)
                vy = (_this.svgDefault.viewBox.y+_this.svgDefault.viewBox.height-_this.viewBox.height);

        }


        _this.scroll.vx = vx;
        _this.scroll.vy = vy;


        // set new viewBox
        // _this.setViewBox([_this.scroll.vx,  _this.scroll.vy, _this.viewBox.width, _this.viewBox.height]);

    }
    /**
     * Event handler - called when map scroll ends
     * @param {jQuery.Event} e
     * @param {MapSVGMap} mapsvg
     * @param {boolean} noClick
     * @returns {boolean}
     * @event
     * @private
     */
    scrollEnd(e: JQuery.Event, mapsvg: MapSVGMap, noClick?: boolean) {

        var _this = this;

        // _this.scroll.tx = (_this.scroll.tx - _this.scroll.dx);
        // _this.scroll.ty = (_this.scroll.ty - _this.scroll.dy);


        setTimeout(function(){
            $(_this.containers.map).removeClass('no-transitions');
            _this.scrollStarted = false;
            _this.isScrolling = false;
        }, 100);
        _this.googleMaps && _this.googleMaps.overlay && _this.googleMaps.overlay.draw();
        $(_this.containers.map).removeClass('scrolling');
        $(document).off('keyup.scroll.mapsvg');
        $(document).off('mousemove.scroll.mapsvg');
        $(document).off('mouseup.scroll.mapsvg');

        // call regionClickHandler if mouse did not move more than 5 pixels
        if (noClick !== true && Math.abs(_this.scroll.dx)<5 && Math.abs(_this.scroll.dy)<5){
            // _this.controllers.popoverOffHandler(e);
            if(_this.editMarkers.on)
                _this.clickAddsMarker && _this.markerAddClickHandler(e);
            else if (_this.region_clicked)
                _this.regionClickHandler(e, _this.region_clicked);
        }


        _this.viewBox.x = _this.scroll.vx || _this.viewBox.x;
        _this.viewBox.y = _this.scroll.vy || _this.viewBox.y ;


        // $(_this.containers.map).css('pointer-events','auto');
        // $('body').css({'cursor': 'default'});

        // if(_this.googleMaps.map) {
        // fix shift
        // _this.setViewBoxByGoogleMapBounds();
        // }
    }
    /**
     * Shift the map by x,y pixels
     * @param {number} x
     * @param {number} y
     */
    panBy(x, y){

        var _this = this;

        var tx = _this.scroll.tx - x;
        var ty = _this.scroll.ty - y;

        var scrolled = {x:true, y:true};

        //!_this.options.googleMaps.on &&
        if(_this.options.scroll.limit){
            var svg = $(_this.containers.svg)[0].getBoundingClientRect();
            var bounds = $(_this.containers.map)[0].getBoundingClientRect();
            if((svg.left-x > bounds.left && x < 0) || (svg.right-x < bounds.right && x > 0)){
                tx = _this.scroll.tx;
                scrolled.x = false;
            }
            if((svg.top-y > bounds.top && y < 0) || (svg.bottom-y < bounds.bottom && y > 0)){
                ty = _this.scroll.ty;
                scrolled.y = false;
            }
        }

        $(_this.containers.scrollpane).css({
            'transform': 'translate('+tx+'px,'+ty+'px)'
        });

        _this.scroll.tx = tx;
        _this.scroll.ty = ty;
        return scrolled;
    }
    /**
     * Save the Region ID that was clicked before starting map scroll.
     * It is used to trigger .regionClickHandler() later if scroll was less than 5px
     * @param {jQuery.Event} e - Event object
     * @param {Region} region - Clicked Region
     * @private
     */
    scrollRegionClickHandler(e: JQuery.Event, region: Region) {
        this.region_clicked = region;
    }
    /**
     * Event hanlder
     * @param _e
     * @param mapsvg
     * @private
     * @event
     */
    touchStart(_e,mapsvg){

        var _this = this;

        // if($(_e.target).hasClass('mapsvg-popover') || $(_e.target).closest('.mapsvg-popover').length ){
        //     return true;
        // }
        _e.preventDefault();
        // _e.stopPropagation();

        // stop scroll and cancel click event
        if(_this.scrollStarted){
            _this.scrollEnd(_e, mapsvg, true);
        }
        var e = _e.originalEvent;

        if(_this.options.zoom.fingers && e.touches && e.touches.length == 2){
            // _this.touchZoomStartViewBox = _this.viewBox;
            // _this.touchZoomStartScale =  _this.scale;
            _this.touchZoomStart   =  true;
            _this.scaleDistStart = Math.hypot(
                e.touches[0].pageX - e.touches[1].pageX,
                e.touches[0].pageY - e.touches[1].pageY);
        }else if(e.touches && e.touches.length == 1){
            _this.scrollStart(_e,mapsvg);
        }

        $(document).on('touchmove.scroll.mapsvg', function(e){
            e.preventDefault(); _this.touchMove(e,_this);
        }).on('touchend.scroll.mapsvg', function(e){
            e.preventDefault(); _this.touchEnd(e,_this);
        });
    };
    /**
     * Event hanlder
     * @param {JQuery.Event} _e
     * @param mapsvg
     * @private
     * @event
     */
    touchMove(_e: JQuery.Event, mapsvg: MapSVGMap){

        var _this = this;
        // if($(_e.target).hasClass('mapsvg-popover') || $(_e.target).closest('.mapsvg-popover').length ){
        //     return true;
        // }
        _e.preventDefault();
        // @ts-ignore
        var e = _e.originalEvent;

        if(_this.options.zoom.fingers && e.touches && e.touches.length == 2){
            if(!MapSVG.ios){
                e.scale = Math.hypot(
                    e.touches[0].pageX - e.touches[1].pageX,
                    e.touches[0].pageY - e.touches[1].pageY)/_this.scaleDistStart;
            }

            if(e.scale!=1 && _this.canZoom) {
                var d = e.scale > 1 ? 1 : -1;

                var cx = e.touches[0].pageX >= e.touches[1].pageX ? e.touches[0].pageX - (e.touches[0].pageX - e.touches[1].pageX)/2 - $(_this.containers.svg).offset().left : e.touches[1].pageX - (e.touches[1].pageX - e.touches[0].pageX)/2 - $(_this.containers.svg).offset().left;
                var cy = e.touches[0].pageY >= e.touches[1].pageY ? e.touches[0].pageY - (e.touches[0].pageY - e.touches[1].pageY) - $(_this.containers.svg).offset().top : e.touches[1].pageY - (e.touches[1].pageY - e.touches[0].pageY) - $(_this.containers.svg).offset().top;

                var center = _this.convertPixelToSVG(new ScreenPoint(cx,cy));

                if (d > 0)
                    _this.zoomIn(center);
                else
                    _this.zoomOut(center);
            }
        }else if(e.touches && e.touches.length == 1){
            _this.scrollMove(_e);
        }
    };
    /**
     * Event hanlder
     * @param _e
     * @param mapsvg
     * @private
     * @event
     */
    touchEnd(_e, mapsvg){

        var _this = this;

        // if($(_e.target).hasClass('mapsvg-popover') || $(_e.target).closest('.mapsvg-popover').length ){
        //     return true;
        // }
        _e.preventDefault();
        var e = _e.originalEvent;
        if(_this.touchZoomStart){
            _this.touchZoomStart  = false;
        }else if(_this.scrollStarted){
            _this.scrollEnd(_e, mapsvg);
        }

        $(document).off('touchmove.scroll.mapsvg');
        $(document).off('touchend.scroll.mapsvg');
    };
    /**
     * Returns array of IDs of selected Regions
     * @returns {String[]}
     */
    getSelected(){
        return this.selected_id;
    };
    /**
     * Selects a Region
     * @param {Region|string} id - Region or ID
     * @param {bool} skipDirectorySelection
     * @returns {boolean}
     */
    selectRegion(id: string|Region, skipDirectorySelection?: boolean){

        var _this = this;
        let region: Region;

        // _this.hidePopover();
        if(typeof id == "string"){
            region = _this.getRegion(id);
        }else{
            region = id;
        }
        if(!region) return false;

        var ids: Array<string>;

        if(_this.options.multiSelect && !_this.editRegions.on){
            if(region.selected){
                _this.deselectRegion(region);
                if(!skipDirectorySelection && _this.options.menu.on){
                    if(_this.options.menu.source == 'database') {
                        if (region.objects && region.objects.length) {
                            var ids = region.objects.map(function (obj: CustomObject) {
                                return obj.id.toString();
                            });
                        }
                    }else{
                        var ids = [region.id];
                    }
                    _this.controllers.directory.deselectItems();
                }

                return;
            }
        }else if(_this.selected_id.length>0){
            _this.deselectAllRegions();
            if(!skipDirectorySelection && _this.options.menu.on){
                if(_this.options.menu.source == 'database') {
                    if (region.objects && region.objects.length) {
                        var ids = region.objects.map(function (obj: CustomObject) {
                            return obj.id.toString();
                        });
                    }
                }else{
                    var ids = [region.id];
                }
                _this.controllers.directory.deselectItems();
            }
        }

        _this.selected_id.push(region.id);
        region.select();

        var skip = _this.options.actions.region.click.filterDirectory;

        if(!skip && !skipDirectorySelection && _this.options.menu.on && _this.controllers && _this.controllers.directory){
            if(_this.options.menu.source == 'database'){
                if(region.objects && region.objects.length) {
                    var ids = region.objects.map(function(obj: CustomObject){
                        return obj.id.toString();
                    });
                } else {
                    var ids = [region.id];
                }
            }else{
                var ids = [region.id];
            }
            _this.controllers.directory.selectItems(ids);
        }

        if(_this.options.actions.region.click.addIdToUrl && !_this.options.actions.region.click.showAnotherMap){
            window.location.hash = "/m/"+region.id;
            // history.replaceState(null, null, region.id);
            // history.replaceState("", document.title, window.location.pathname
            //     + window.location.search + '#m_'+region.id);

        }
    }
    /**
     * Deselects all Regions
     */
    deselectAllRegions (){

        var _this = this;

        $.each(_this.selected_id, function(index,id){
            _this.deselectRegion(_this.getRegion(id));
        });
    }
    /**
     * Deselects one Region
     * @param {Region} region
     */
    deselectRegion(region){

        var _this = this;

        if(!region)
            region = _this.getRegion(_this.selected_id[0]);
        if(region){
            region.deselect();
            var i = $.inArray(region.id, _this.selected_id);
            _this.selected_id.splice(i,1);
            // if(MapSVG.browser.ie)//|| MapSVG.browser.firefox)
            //     _this.mapAdjustStrokes();
        }
        if(_this.options.actions.region.click.addIdToUrl){
            // window.location.hash = ' '; //window.location.hash.replace(region.id,'');
            // history.replaceState("", document.title, window.location.pathname
            //     + window.location.search);
            if(window.location.hash.indexOf(region.id) !== -1){
                history.replaceState(null, null, ' ');
            }
        }
    }
    /**
     * Highlights an array of Regions (used on mouseover)
     * @param {Region[]} regions
     */
    highlightRegions(regions){

        var _this = this;

        regions.forEach(function(region){
            if(region && !region.selected && !region.disabled){
                _this.highlightedRegions.push(region);
                region.highlight();
            }
        })
    }
    /**
     * Unhighlights all Regions  (used on mouseout)
     */
    unhighlightRegions(){

        var _this = this;

        _this.highlightedRegions.forEach(function(region: Region){
            if(region && !region.selected && !region.disabled)
                region.unhighlight();
        });
        _this.highlightedRegions = [];
    }
    /**
     * Selects a Marker
     * @param {Marker} marker
     */
    selectMarker(marker: Marker){

        var _this = this;

        if(!(marker instanceof Marker))
            return false;

        _this.deselectAllMarkers();
        marker.select();
        _this.selected_marker = marker;

        $(_this.layers.markers).addClass('mapsvg-with-marker-active');

        if(_this.options.menu.on && _this.options.menu.source == 'database'){
            _this.controllers.directory.deselectItems();
            _this.controllers.directory.selectItems(marker.object.id);
        }
    }

    /**
     * Deselects all Markers
     */
    deselectAllMarkers(){

        var _this = this;
        _this.selected_marker && _this.selected_marker.deselect();
        $(_this.layers.markers).removeClass('mapsvg-with-marker-active');
    }

    /**
     * Deselects one Marker
     * @param {Marker} marker
     */
    deselectMarker(marker){

        var _this = this;

        if(marker){
            marker.deselect();
        }
    }
    /**
     * Highlight marker
     * @param {Marker} marker
     */
    highlightMarker(marker){

        var _this = this;

        $(_this.layers.markers).addClass('mapsvg-with-marker-hover');
        marker.highlight();
        _this.highlighted_marker = marker;
    }
    /**
     * Unhighlights all Regions  (used on mouseout)
     */
    unhighlightMarker(){

        var _this = this;

        $(_this.layers.markers).removeClass('mapsvg-with-marker-hover');
        _this.highlighted_marker && _this.highlighted_marker.unhighlight();
    }
    /**
     * Converts mouse pointer coordinates to SVG coordinates
     * @param {object} e - Event object
     * @returns {Array} - [x,y] SVG coordinates
     */
    convertMouseToSVG(e): SVGPoint {

        var _this = this;

        var mc = MapSVG.mouseCoords(e);
        var x = mc.x - $(_this.containers.svg).offset().left;
        var y = mc.y - $(_this.containers.svg).offset().top;
        var screenPoint = new ScreenPoint(x,y);
        return _this.convertPixelToSVG(screenPoint);
    }
    /**
     * Converts SVG coordinates to pixel coodinates relative to map container
     * @param {SVGPoint} svgPoint
     * @returns {ScreenPoint}
     */
    convertSVGToPixel(svgPoint: SVGPoint): ScreenPoint {

        var _this = this;
        var scale = _this.getScale();

        var shiftX = 0, shiftY = 0;

        if(_this.options.googleMaps.on){
            if((_this.viewBox.x-_this.svgDefault.viewBox.x) > _this.svgDefault.viewBox.width){
                var worldMapWidth = ((_this.svgDefault.viewBox.width / _this.mapLonDelta) * 360);
                shiftX = worldMapWidth * Math.floor((_this.viewBox.x-_this.svgDefault.viewBox.x) / _this.svgDefault.viewBox.width);
            }
        }

        let screenPoint = new ScreenPoint((svgPoint.x-_this.svgDefault.viewBox.x+shiftX)*scale, (svgPoint.y-_this.svgDefault.viewBox.y+shiftY)*scale);

        return screenPoint;
    }
    /**
     * Converts pixel coordinates (relative to map container) to SVG coordinates
     * @param {Array} xy - [x,y] Pixel coordinates
     * @returns {number[]} - [x,y] SVG coordinates
     */
    convertPixelToSVG(screenPoint: ScreenPoint): SVGPoint {
        var _this = this;
        var scale = _this.getScale();
        return new SVGPoint(screenPoint.x/scale+_this.svgDefault.viewBox.x, screenPoint.y/scale+_this.svgDefault.viewBox.y);
    }
    /**
     * Converts geo-coordinates (latitude/lognitude) to SVG coordinates
     * @param {GeoPoint} coords - [lat,lon] Geo-coodinates
     * @returns {SVGPoint}
     */
    convertGeoToSVG(coords: GeoPoint): SVGPoint {
        var _this = this;
        var x = (coords.lng - _this.geoViewBox.sw.lng) * (_this.svgDefault.viewBox.width / _this.mapLonDelta);
        var lat = coords.lat * 3.14159 / 180;
        var worldMapWidth = ((_this.svgDefault.viewBox.width / _this.mapLonDelta) * 360) / (2 * 3.14159);
        var mapOffsetY    = (worldMapWidth / 2 * Math.log((1 + Math.sin(_this.mapLatBottomDegree)) / (1 - Math.sin(_this.mapLatBottomDegree))));
        var y = _this.svgDefault.viewBox.height - ((worldMapWidth / 2 * Math.log((1 + Math.sin(lat)) / (1 - Math.sin(lat)))) - mapOffsetY);

        x += _this.svgDefault.viewBox.x;
        y += _this.svgDefault.viewBox.y;

        return (new SVGPoint(x, y));
    }
    /**
     * Converts SVG coordinates to geo-coordinates (latitude/lognitude).
     * @param {SVGPoint} point
     * @param {number} ty - SVG y coordinate
     * @returns {number[]} - [lat,lon] Geo-coordinates
     */
    convertSVGToGeo(point: SVGPoint): GeoPoint{

        var _this = this;

        let tx = point.x - _this.svgDefault.viewBox.x;
        let ty = point.y - _this.svgDefault.viewBox.y;
        /* called worldMapWidth in Raphael's Code, but I think that's the radius since it's the map width or circumference divided by 2*PI  */
        var worldMapRadius = _this.svgDefault.viewBox.width / _this.mapLonDelta * 360/(2 * Math.PI);
        var mapOffsetY = ( worldMapRadius / 2 * Math.log( (1 + Math.sin(_this.mapLatBottomDegree) ) / (1 - Math.sin(_this.mapLatBottomDegree))  ));
        var equatorY = _this.svgDefault.viewBox.height + mapOffsetY;
        var a = (equatorY-ty)/worldMapRadius;
        var lat = 180/Math.PI * (2 * Math.atan(Math.exp(a)) - Math.PI/2);
        var lng = _this.geoViewBox.sw.lng + tx/_this.svgDefault.viewBox.width * _this.mapLonDelta;
        lat = parseFloat(lat.toFixed(6));
        lng = parseFloat(lng.toFixed(6));
        return (new GeoPoint(lat, lng));
    }
    /**
     * Converts map geo-boundaries to viewBox
     * @param sw
     * @param ne
     * @returns {*[]}
     *
     * @private
     * @deprecated
     */
    /*
    convertGeoBoundsToViewBox (geoViewBox: GeoViewBox): ViewBox {
        //sw, ne
        var _this = this;

        var lat = parseFloat(coords[0]);
        var lon = parseFloat(coords[1]);
        var x = (lon - _this.geoViewBox.leftLon) * (_this.svgDefault.viewBox.width / _this.mapLonDelta);

        var lat = lat * 3.14159 / 180;
        // var worldMapWidth = ((_this.svgDefault.width / _this.mapLonDelta) * 360) / (2 * 3.14159);
        var worldMapWidth = ((_this.svgDefault.viewBox.width / _this.mapLonDelta) * 360) / (2 * 3.14159);
        var mapOffsetY = (worldMapWidth / 2 * Math.log((1 + Math.sin(_this.mapLatBottomDegree)) / (1 - Math.sin(_this.mapLatBottomDegree))));
        var y = _this.svgDefault.viewBox.height - ((worldMapWidth / 2 * Math.log((1 + Math.sin(lat)) / (1 - Math.sin(lat)))) - mapOffsetY);

        x += _this.svgDefault.viewBox.x;
        y += _this.svgDefault.viewBox.y;

        return [x, y];
    }
    */

    /**
     * For choropleth map: returns color for given number value
     * @param {number} choroplethValue - Number value
     * @returns {{r: number, g: number, b: number, a: number}} - Color values, 0-255.
     */
    pickChoroplethColor(choroplethValue: number): {r: number, g: number, b: number, a: number} {
        var _this = this;

        var w = (choroplethValue - _this.options.choropleth.coloring.gradient.values.min) / _this.options.choropleth.coloring.gradient.values.maxAdjusted;
        var rgba = {
            r: Math.round(_this.options.choropleth.coloring.gradient.colors.diffRGB.r * w + _this.options.choropleth.coloring.gradient.colors.lowRGB.r),
            g: Math.round(_this.options.choropleth.coloring.gradient.colors.diffRGB.g * w + _this.options.choropleth.coloring.gradient.colors.lowRGB.g),
            b: Math.round(_this.options.choropleth.coloring.gradient.colors.diffRGB.b * w + _this.options.choropleth.coloring.gradient.colors.lowRGB.b),
            a: Math.round(_this.options.choropleth.coloring.gradient.colors.diffRGB.a * w + _this.options.choropleth.coloring.gradient.colors.lowRGB.a)
        };
        return rgba;
    }
    /**
     * Checks if Region should be disabled
     * @param {string} id - Region ID
     * @param {string} svgfill - Region color ("fill" attribute)
     * @returns {boolean} - "true" if Region should be disabled.
     */
    isRegionDisabled  (id: string, svgfill: string): boolean {

        var _this = this;

        if(_this.options.regions[id] && (_this.options.regions[id].disabled || svgfill == 'none') ){
            return true;
        }else if(
            (_this.options.regions[id] == undefined || MapSVG.parseBoolean(_this.options.regions[id].disabled)) &&
            (_this.options.disableAll || svgfill == 'none' || id == 'labels' || id == 'Labels')

        ){
            return true;
        }else{
            return false;
        }
    }

    /**
     * Gets map settings from the server
     */
    loadMap (id: number, container: HTMLElement): void {
        let mapsRepo = new MapsRepository();
        mapsRepo.findById(id).done((map) => {
            if($(container).find('svg').length){
                // @ts-ignore
                container.mapSvg().destroy();
            }
            // @ts-ignore
            container.mapSvg(map.options);
        });
    }

    /**
     * Event handler that is fired on click on a Region / Marker / MarkerCluster
     * @param {JQuery.Event} e - Event object
     * @param {Region|Marker|MarkerCluster} region
     * @returns {boolean}
     */
    regionClickHandler (e: JQuery.Event, region: Region|Marker|MarkerCluster){

        var _this = this;

        _this.region_clicked = null;
        var actions = _this.options.actions;

        if(_this.eventsPreventList['click'])
            return;

        if(_this.editRegions.on){
            _this.selectRegion(region.id);
            _this.regionEditHandler.call(region);
            return;
        }
        // _this.hidePopover();

        if(region instanceof MarkerCluster){
            _this.zoomTo(region.markers);
            return;
        }

        if(region instanceof Region){

            _this.selectRegion(region.id);

            if(actions.region.click.zoom){
                _this.zoomTo(region, actions.region.click.zoomToLevel);
            }

            if(actions.region.click.filterDirectory){
                let query = new Query({filters: {regions: {table_name: this.regionsRepository.getSchema().name, region_ids: [region.id]}}});
                _this.objectsRepository.find(query).done(function(){
                    if(_this.controllers.popover){
                        _this.controllers.popover.redraw(region.forTemplate());
                    }
                    if(_this.controllers.detailsView){
                        _this.controllers.detailsView.redraw(region.forTemplate());
                    }
                });
                _this.updateFiltersState();
            }

            if(actions.region.click.showDetails){
                _this.loadDetailsView(region);
            }

            if(actions.region.click.showPopover){
                if(actions.region.click.zoom){
                    setTimeout(function(){
                        _this.showPopover(region);
                    },400);
                }else{
                    _this.showPopover(region);
                }
            }else if(e && e.type.indexOf('touch')!==-1 && actions.region.touch.showPopover){
                if(actions.region.click.zoom){
                    setTimeout(function(){
                        _this.showPopover(region);
                    },400);
                }else{
                    _this.showPopover(region);
                }
            }

            if(actions.region.click.goToLink){
                var linkParts = actions.region.click.linkField.split('.');
                var url;
                if(linkParts.length > 1){
                    var obj = linkParts.shift();
                    var attr = '.'+linkParts.join('.');
                    if(obj == 'Region'){
                        if(region.data){
                            try {
                                url = eval('region.data'+attr);
                            }catch(err){
                                console.log("No such field as region.data"+attr);
                            }
                        }
                    }else{
                        if(region.objects && region.objects[0]){
                            try {
                                url = eval('region.objects[0]'+attr);
                            }catch(err){
                                console.log("No such field as region.objects[0]"+attr);
                            }
                        }
                    }

                    if(url && !_this.disableLinks){
                        if(_this.editMode){
                            alert('Redirect: '+url+'\nLinks are disabled in the preview.');
                            return true;
                        }
                        if(actions.region.click.newTab){
                            var win = window.open(url, '_blank');
                            win.focus();
                        }else{
                            window.location.href = url;
                        }
                    }
                }
            }
            if(actions.region.click.showAnotherMap){
                if(_this.editMode){
                    alert('"Show another map" action is disabled in the preview');
                    return true;
                }
                var linkParts = actions.region.click.showAnotherMapField.split('.');
                var url;
                if(linkParts.length > 1){
                    var obj = linkParts.shift();
                    var attr = '.'+linkParts.join('.');
                    var map_id;
                    if(obj == 'Region'){
                        if(region.data)
                            map_id = eval('region.data'+attr);
                    }else{
                        if(region.objects && region.objects[0])
                            map_id = eval('region.objects[0]'+attr);
                    }

                    if(map_id){
                        var container = actions.region.click.showAnotherMapContainerId ? $('#'+actions.region.click.showAnotherMapContainerId)[0] : $(_this.containers.map)[0];
                        _this.loadMap(map_id, container);
                    }
                }
            }
            _this.events.trigger('click.region', region, [e, _this]);
        }else if(region instanceof Marker){
            _this.selectMarker(region);

            var passingObject = region.object;

            if(actions.marker.click.zoom) {
                _this.zoomTo(region, actions.marker.click.zoomToLevel);
            }

            if(actions.marker.click.filterDirectory){
                let query = new Query({filters: {id: region.object.id}});
                _this.objectsRepository.find(query);
                _this.updateFiltersState();
            }


            if(actions.marker.click.showDetails)
                _this.loadDetailsView(passingObject);
            if(actions.marker.click.showPopover){
                if(actions.marker.click.zoom){
                    setTimeout(function(){
                        _this.showPopover(passingObject);
                    },500);
                }else{
                    _this.showPopover(passingObject);
                }
            }else if(e && e.type.indexOf('touch')!==-1 && actions.marker.touch.showPopover){
                if(actions.marker.click.zoom){
                    setTimeout(function(){
                        _this.showPopover(passingObject);
                    },500);
                }else{
                    _this.showPopover(passingObject);
                }
            }
            if(actions.marker.click.goToLink){
                var linkParts = actions.marker.click.linkField.split('.');
                var url;
                if(linkParts.length > 1){
                    var obj = linkParts.shift();
                    var attr = '.'+linkParts.join('.');
                    try {
                        url = eval('passingObject'+attr);
                    }catch(err){
                        console.log("MapSVG: No such field as passingObject"+attr);
                    }
                    if(url && !_this.disableLinks)
                        if(_this.editMode){
                            alert('Redirect: '+url+'\nLinks are disabled in the preview.');
                            return true;
                        }
                    if(actions.marker.click.newTab){
                        var win = window.open(url, '_blank');
                        win.focus();
                    }else{
                        window.location.href = url;
                    }
                }
            }
            _this.events.trigger('click.marker', region, [e, _this]);
        }
    }
    /**
     * Checks if file exists by provided URL.
     * @param {string} url
     * @returns {boolean}
     *
     * @private
     */
    fileExists (url){

        var _this = this;

        if(url.substr(0,4)=="data")
            return true;
        var http = new XMLHttpRequest();
        http.open('HEAD', url, false);
        http.send();
        return http.status!=404;
    }
    /**
     * Returns CSS style of an SVG element
     * @param elem
     * @param prop
     * @returns {*|string} - CSS
     *
     * @private
     * @deprecated
     */
    getStyle (elem,prop){

        var _this = this;

        if (elem.currentStyle) {
            return elem.currentStyle.margin;
        } else if (window.getComputedStyle) {
            // @ts-ignore
            if (window.getComputedStyle.getPropertyValue){
                return window.getComputedStyle(elem, null).getPropertyValue(prop)
            } else {
                return window.getComputedStyle(elem)[prop];
            }
        }
    }
    /**
     * Hides all markers except one.
     * Used in Map Editor.
     * @param {string} id - ID of the Marker
     * @private
     */
    hideMarkersExceptOne(id){

        var _this = this;

        /*
        var objects = _this.objectsRepository.getLoaded();

        objects.forEach(function(object){
            if((id != object.id) && object.location && object.location.marker){
                object.location.marker.hide();
            }
        });
        */

        _this.markers.forEach(function(marker){
            if(typeof id === 'undefined' || (marker.object && id != marker.object.id)){
                marker.hide();
            }
        });

        $(_this.containers.wrap).addClass('mapsvg-edit-marker-mode');
    }
    /**
     * Shows all markers after .hideMarkersExceptOne()
     * Used in Map Editor.
     * @private
     */
    showMarkers(){

        var _this = this;

        _this.markers.forEach(function(m){
            m.show();
        });
        _this.deselectAllMarkers();
        // $(_this.containers.wrap).removeClass('mapsvg-clusters-hidden');
        $(_this.containers.wrap).removeClass('mapsvg-edit-marker-mode');

    }
    /**
     * Event handler that creates marker on click on the map.
     * Used in the Map Editor.
     * @param {object} e - Event object
     * @returns {boolean}
     * @private
     */
    markerAddClickHandler (e){

        var _this = this;

        // Don't add marker if marker was clicked
        if($(e.target).hasClass('mapsvg-marker')) return false;

        var mc = MapSVG.mouseCoords(e);
        var x  = mc.x - $(_this.containers.svg).offset().left;
        var y  = mc.y - $(_this.containers.svg).offset().top;
        var screenPoint = new ScreenPoint(x,y);
        var svgPoint = _this.convertPixelToSVG(screenPoint);
        var geoPoint = _this.convertSVGToGeo(svgPoint);

        if(!$.isNumeric(x) || !$.isNumeric(y))
            return false;

        var location = new Location({
            svgPoint: svgPoint,
            geoPoint: geoPoint,
            img: _this.options.defaultMarkerImage
        });

        // When Form Builder is opened in MapSVG Builder, there could be created marker
        // already so we want to move the marker to a new position on map click
        // instead of creating a new marker
        if(_this.editingMarker){
            // _this.editingMarker.moveToClick([x,y]);
            _this.editingMarker.setPoint(svgPoint);
            return;
        }

        var marker = new Marker({
            location: location,
            mapsvg: this
        });
        _this.markerAdd(marker);

        _this.markerEditHandler && _this.markerEditHandler.call(marker);

    }
    /**
     * Sets default marker image.
     * Used in Map Editor.
     * @param {string} src - Image URL
     * @private
     */
    setDefaultMarkerImage (src){

        var _this = this;

        _this.options.defaultMarkerImage = src;
    }

    /**
     * Checks and remebers if marker images should be set by a field value
     * @private
     */
    setMarkerImagesDependency (){
        var _this = this;
        _this.locationField = _this.objectsRepository.schema.getFieldByType('location');
        // @ts-ignore
        if(_this.locationField.markersByFieldEnabled && _this.locationField.markerField && Object.values(_this.locationField.markersByField).length > 0){
            this.setMarkersByField = true;
        } else {
            this.setMarkersByField = false;
        }
    }

    /**
     * Returns default marker image or marker image by field value if such option is enabled
     * @param {Number|String} fieldValue
     * @returns {String} URL of marker image
     * @private
     */
    getMarkerImage (fieldValueOrObject: any, location?: Location): string {
        var _this = this;

        var fieldValue;

        if(this.setMarkersByField){
            if(typeof fieldValueOrObject === 'object'){
                // @ts-ignore
                fieldValue = fieldValueOrObject[_this.locationField.markerField];
            } else {
                fieldValue = fieldValueOrObject;
            }
            // @ts-ignore
            if(_this.locationField.markersByField[fieldValue]){
                // @ts-ignore
                return _this.locationField.markersByField[fieldValue];
            }
        }

        return (location && location.img) ?  location.img : (this.options.defaultMarkerImage ? this.options.defaultMarkerImage : MapSVG.urls.root+'markers/_pin_default.png');
    }

    /**
     * Sets on/off "edit markers" mode
     * @param {bool} on - on/off
     * @param {bool} clickAddsMarker - defines if click on the map should add a marker
     * @private
     */
    setMarkersEditMode (on, clickAddsMarker){

        var _this = this;

        _this.editMarkers.on = MapSVG.parseBoolean(on);
        _this.clickAddsMarker = _this.editMarkers.on;
        _this.setEventHandlers();
    }

    /**
     * Sets on/off "edit regions" mode
     * Used in Map Editor.
     * @param {bool} on - on/off
     *
     * @private
     */
    setRegionsEditMode (on){

        var _this = this;

        _this.editRegions.on = MapSVG.parseBoolean(on);
        _this.deselectAllRegions();
        _this.setEventHandlers();
    }

    /**
     * Enables edit mode (which means that the map is going to be shown in the Map Editor)
     * Used in the Map Editor.
     * @param {bool} on
     * @private
     */
    setEditMode(on){

        var _this = this;

        _this.editMode = on;
    }

    /**
     * Enables "Edit objects" mode
     * Used in the Map Editor.
     * @param {bool} on
     * @private
     */
    setDataEditMode (on){

        var _this = this;

        _this.editData.on = MapSVG.parseBoolean(on);
        _this.deselectAllRegions();
        _this.setEventHandlers();
    }

    /**
     * Downloads SVG file.
     * @private
     */
    /*
    download(){

        var _this = this;

        var downloadForm;
        if($('#mdownload').length === 1){
            downloadForm = $('#mdownload');
        } else {
            downloadForm = $('<form id="mdownload" action="/wp-content/plugins/mapsvg-dev/download.php" method="POST"><input type="hidden" name="svg_file" value="0" /><input type="hidden" name="svg_title"></form>');
            downloadForm.appendTo('body');
        }

        downloadForm.find('input[name="svg_file"]').val($(_this.containers.svg).prop('outerHTML'));
        downloadForm.find('input[name="svg_title"]').val(_this.options.title);
        setTimeout(function() {
            jQuery('#mdownload').submit();
        }, 500);
    }
    */

    /**
     * Shows the tooltip with provided HTML content.
     * @param {string} html - HTML content
     */
    showTooltip (html){

        var _this = this;

        if (html.length){
            $(_this.containers.tooltip).html(html);
            $(_this.containers.tooltip).addClass('mapsvg-tooltip-visible');
        }
    }

    /**
     * Adjusts popover position. User on zoom and when map container is resized.
     */
    popoverAdjustPosition(){

        var _this = this;

        if(!$(_this.containers.popover) || !$(_this.containers.popover).data('point')) return;

        var pos = _this.convertSVGToPixel($(_this.containers.popover).data('point'));

        // pos[0] = pos[0] - (_this.layers.popovers.offset().left - $(_this.containers.map).offset().left);
        // pos[1] = pos[1] - (_this.layers.popovers.offset().top - $(_this.containers.map).offset().top);

        $(_this.containers.popover)[0].style.transform = 'translateX(-50%) translate('+pos[0]+'px,'+pos[1]+'px)';
    }

    /**
     * Shows a popover for provided Region or DB Object.
     * @param {Region|object} object - Region or DB Object
     *
     * @example
     * var region = mapsvg.getRegion("US-TX");
     * mapsvg.showPopover(region);
     */
    showPopover  (object){

        var _this = this;

        var mapObject = object instanceof Region ? object : (object.location && object.location.marker && object.location.marker ? object.location.marker : null);
        if(!mapObject)
            return;

        var point;
        if(mapObject instanceof Marker){
            point = mapObject.svgPoint;
        } else {
            point = mapObject.getCenterSVG();
        }
        _this.controllers.popover && _this.controllers.popover.destroy();
        _this.controllers.popover = new PopoverController({
            container: _this.containers.popover,
            point: point,
            yShift: mapObject instanceof Marker ? mapObject.height : 0,
            template: object instanceof Region ?  _this.templates.popoverRegion : _this.templates.popoverMarker,
            mapsvg: _this,
            data: object.getData(this.regionsRepository.schema.name),
            mapObject: mapObject,
            scrollable: true,
            withToolbar: MapSVG.isPhone && _this.options.popovers.mobileFullscreen ? false : true,
            events: {
                shown: function(mapsvg){
                    if(_this.options.popovers.centerOn){
                        var shift = $(this.containers.main).height()/2;
                        if(_this.options.popovers.centerOn && !(MapSVG.isPhone && _this.options.popovers.mobileFullscreen)){
                            _this.centerOn(mapObject, shift);
                        }
                    }
                    _this.popoverShowingFor = mapObject;
                    _this.events.trigger('shown.popover', this, [_this]);
                },
                closed: function(mapsvg){
                    _this.options.popovers.resetViewboxOnClose && _this.viewBoxReset(true);
                    _this.popoverShowingFor = null;
                    _this.events.trigger('closed.popover', this, [mapsvg]);
                },
                resize: function(){
                    if(_this.options.popovers.centerOn){
                        var shift = $(this.containers.main).height()/2;
                        if(_this.options.popovers.centerOn && !(MapSVG.isPhone && _this.options.popovers.mobileFullscreen)){
                            _this.centerOn(mapObject, shift);
                        }
                    }
                }
            }
        });
        _this.controllers.popover._init();
    }

    /**
     * Hides the popover
     */
    hidePopover (){

        var _this = this;

        _this.controllers.popover && _this.controllers.popover.close();
        // $('body').toggleClass('mapsvg-popover-open', false);
    }

    /**
     * Hides the tooltip
     */
    hideTip  (){

        var _this = this;

        $(_this.containers.tooltip).removeClass('mapsvg-tooltip-visible');
        //_this.containers.tooltip.html('');
    }

    /**
     * Event handler that catches clicks outside of the popover and closes the popover.
     * @param {object} e - Event object
     */
    popoverOffHandler (e){

        var _this = this;

        if(_this.isScrolling || $(e.target).closest('.mapsvg-popover').length || $(e.target).hasClass('mapsvg-btn-map'))
            return;
        this.controllers.popover && this.controllers.popover.close();
    }

    /**
     * Mouseover event handler for Regions and Markers
     * @param {object} e - Event object
     * @param {Marker|Region} object
     * @private
     */
    mouseOverHandler (e, object){

        var _this = this;

        if(_this.eventsPreventList['mouseover']){
            return;
        }

        if(_this.options.tooltips.on){
            var name, data, _object;
            if(object instanceof Region) {
                name = 'tooltipRegion';
                _object = object;
            }
            if(object instanceof Marker) {
                name = 'tooltipMarker';
                _object = object.object;
            }
            if(_object != null && _object.id && _this.popoverShowingFor !== object){
                _this.showTooltip(_this.templates[name](object.getData(this.regionsRepository.schema.name)));
            }
        }

        let ids: any[];
        if(_this.options.menu.on){
            if(_this.options.menu.source == 'database'){
                if((object instanceof Region) && object.objects.length) {
                    ids = object.objects.map(function(obj){
                        return obj.id;
                    });
                }
                if(object instanceof Marker) {
                    ids = object.object ? [object.object.id] : [];
                }
            }else{
                if((object instanceof Region)) {
                    ids = [object.id];
                }
                if(this instanceof Marker && object.object.regions && object.object.regions.length) {
                    ids = object.object.regions.map(function(obj){
                        return obj.id;
                    });
                }
            }
            _this.controllers.directory.highlightItems(ids);
        }

        if(object instanceof Region) {
            if (!object.selected)
                object.highlight();
            _this.events.trigger('mouseover.region', object, [e, _this]);
        }else{
            _this.highlightMarker(object);
            _this.events.trigger('mouseover.marker', object, [e, _this]);
        }
    }

    /**
     * Mouseout event handler for Regions and Markers
     * @param {object} e - Event object
     * @param {Marker|Region} object
     * @private
     */
    mouseOutHandler (e, object){

        var _this = this;

        if(_this.eventsPreventList['mouseout']){
            return;
        }

        if(_this.options.tooltips.on)
            _this.hideTip();
        if(object instanceof Region) {
            if (!object.selected)
                object.unhighlight();
            _this.events.trigger('mouseout.region', object, [e, _this]);
        }else{
            _this.unhighlightMarker();
            _this.events.trigger('mouseout.marker', object, [e, _this]);
        }

        let ids: any[];
        if(_this.options.menu.on){
            if(_this.options.menu.source == 'database'){
                if(object instanceof MapSVG.Marker) {
                    ids = object.object ? [object.object.id] : [];
                }
            }
            _this.controllers.directory.unhighlightItems();
        }

    }

    /**
     * Prevents provided event from being fired
     * @param {string} event - Event name
     * @private
     */
    eventsPrevent(event){

        var _this = this;

        _this.eventsPreventList[event] = true;
    }

    /**
     * Restores event disabled by .eventsPrevent()
     * @param {string} event - Event name
     * @private
     */
    eventsRestore(event){
        var _this = this;
        if(event){
            _this.eventsPreventList[event] = false;
        } else {
            _this.eventsPreventList = {};
        }
    }

    /**
     * Sets all event handlers
     * @private
     */
    setEventHandlers (){

        var _this = this;

        $(_this.containers.map).off('.common.mapsvg');
        $(_this.containers.scrollpane).off('.common.mapsvg');
        $(document).off('keydown.scroll.mapsvg');
        $(document).off('mousemove.scrollInit.mapsvg');
        $(document).off('mouseup.scrollInit.mapsvg');

        if(_this.editMarkers.on){

            $(_this.containers.map).on('touchstart.common.mapsvg mousedown.common.mapsvg', '.mapsvg-marker',function(e){
                e.originalEvent.preventDefault();
                var marker = _this.getMarker($(this).attr('id'));
                var startCoords = MapSVG.mouseCoords(e);
                marker.drag(startCoords, _this.scale);

                /*
                marker.drag(startCoords, _this.scale, function() {
                    if (_this.mapIsGeo){
                        var svgPoint = new SVGPoint(this.x + this.width / 2, this.y + (this.height-1));
                        this.geoCoords = _this.convertSVGToGeo(svgPoint);
                    }
                    //_this.markerEditHandler && _this.markerEditHandler.call(this,true);
                },function(){
                    //_this.markerEditHandler && _this.markerEditHandler.call(this);
                });

                 */
            });
        }

        // REGIONS
        if(!_this.editMarkers.on) {
            $(_this.containers.map).on('mouseover.common.mapsvg', '.mapsvg-region', function (e) {
                var id = $(this).attr('id');
                _this.mouseOverHandler.call(_this, e, _this.getRegion(id));
            }).on('mouseleave.common.mapsvg', '.mapsvg-region', function (e) {
                var id = $(this).attr('id');
                _this.mouseOutHandler.call(_this, e, _this.getRegion(id));
            });
        }
        if(!_this.editRegions.on){
            $(_this.containers.map).on('mouseover.common.mapsvg', '.mapsvg-marker', function (e) {
                var id = $(this).attr('id');
                _this.mouseOverHandler.call(_this, e, _this.getMarker(id));
            }).on('mouseleave.common.mapsvg', '.mapsvg-marker', function (e) {
                var id = $(this).attr('id');
                _this.mouseOutHandler.call(_this, e, _this.getMarker(id));
            });
        }

        if(_this.options.scroll.spacebar){
            $(document).on('keydown.scroll.mapsvg', function(e) {
                if(document.activeElement.tagName !=='INPUT' && !_this.isScrolling && e.keyCode == 32){
                    e.preventDefault();
                    $(_this.containers.map).addClass('mapsvg-scrollable');
                    $(document).on('mousemove.scrollInit.mapsvg', function(e) {
                        _this.isScrolling = true;
                        $(document).off('mousemove.scrollInit.mapsvg');
                        _this.scrollStart(e,_this);
                    }).on('keyup.scroll.mapsvg', function (e) {
                        if (e.keyCode == 32) {
                            $(document).off('mousemove.scrollInit.mapsvg');
                            $(_this.containers.map).removeClass('mapsvg-scrollable');
                        }
                    });
                }
            });
        }else if (!_this.options.scroll.on) {

            if(!_this.editMarkers.on) {
                $(_this.containers.map).on('touchstart.common.mapsvg', '.mapsvg-region', function (e) {
                    _this.scroll.touchScrollStart = $(window).scrollTop();
                });
                $(_this.containers.map).on('touchstart.common.mapsvg', '.mapsvg-marker', function (e) {
                    _this.scroll.touchScrollStart = $(window).scrollTop();
                });

                $(_this.containers.map).on('touchend.common.mapsvg mouseup.common.mapsvg', '.mapsvg-region', function (e) {
                    if (e.cancelable) {
                        e.preventDefault();
                    }
                    if(_this.scroll.touchScrollStart === undefined || _this.scroll.touchScrollStart === $(window).scrollTop()){
                        _this.regionClickHandler.call(_this, e, _this.getRegion($(this).attr('id')));
                    }
                    // _this.regionClickHandler.call(_this, e, _this.getRegion($(this).attr('id')));
                });
                $(_this.containers.map).on('touchend.common.mapsvg mouseup.common.mapsvg','.mapsvg-marker',  function (e) {
                    if (e.cancelable) {
                        e.preventDefault();
                    }
                    if(_this.scroll.touchScrollStart === undefined || _this.scroll.touchScrollStart === $(window).scrollTop()){
                        _this.regionClickHandler.call(_this, e, _this.getMarker($(this).attr('id')));
                    }
                });
                $(_this.containers.map).on('touchend.common.mapsvg mouseup.common.mapsvg','.mapsvg-marker-cluster',  function (e) {
                    if (e.cancelable) {
                        e.preventDefault();
                    }
                    if(!_this.scroll.touchScrollStart || _this.scroll.touchScrollStart == $(window).scrollTop()) {
                        var cluster = $(this).data("cluster");
                        _this.zoomTo(cluster.markers);
                    }
                });
                // }
            }else{

                if(_this.clickAddsMarker)
                    $(_this.containers.map).on('touchend.common.mapsvg mouseup.common.mapsvg', function (e) {
                        // e.stopImmediatePropagation();
                        if (e.cancelable) {
                            e.preventDefault();
                        }
                        _this.markerAddClickHandler(e);
                    });
            }
        } else {

            $(_this.containers.map).on('touchstart.common.mapsvg mousedown.common.mapsvg', function(e){

                if($(e.target).hasClass('mapsvg-popover')||$(e.target).closest('.mapsvg-popover').length){
                    // Prevent even dobule firing touchstart+mousedown on clicking popover close button
                    if($(e.target).hasClass('mapsvg-popover-close')){
                        if(e.type=='touchstart'){
                            if (e.cancelable) {
                                e.preventDefault();
                            }
                        }
                    }
                    return;
                }

                if(e.type=='touchstart'){
                    if (e.cancelable) {
                        e.preventDefault();
                    }
                }

                let obj: any;

                if(e.target && $(e.target).attr('class') && $(e.target).attr('class').indexOf('mapsvg-region')!=-1){
                    obj = _this.getRegion($(e.target).attr('id'));
                    _this.scrollRegionClickHandler.call(_this, e, obj);
                }else if(e.target && $(e.target).attr('class') && $(e.target).attr('class').indexOf('mapsvg-marker')!=-1 && $(e.target).attr('class').indexOf('mapsvg-marker-cluster')===-1){
                    if(_this.editMarkers.on){
                        return;
                    }
                    obj = _this.getMarker($(e.target).attr('id'));
                    _this.scrollRegionClickHandler.call(_this, e, obj);
                }else if(e.target && $(e.target).attr('class') && $(e.target).attr('class').indexOf('mapsvg-marker-cluster')!=-1){
                    if(_this.editMarkers.on){
                        return;
                    }
                    obj = ($(e.target).data('cluster'));
                    _this.scrollRegionClickHandler.call(_this, e, obj);
                }
                if(e.type=='mousedown'){
                    _this.scrollStart(e,_this);
                }else{
                    _this.touchStart(e,_this);
                }
            });

        }

        //TODO Vyacheslav - переделать под новый horopleth
        /*
        $(_this.containers.map).on('mouseover.common.mapsvg', '.mapsvg-choropleth-gradient-wrap', function(e){
            let currentSegment = _this.options.choropleth.segments[$(e.target).parents('.mapsvg-choropleth-gradient-wrap').data('idx')];

            if (currentSegment.description){
                _this.showTooltip(currentSegment.description);
            }
        });
        */

        $(_this.containers.map).on('mouseleave.common.mapsvg', '.mapsvg-choropleth-gradient-wrap', function(e){
            _this.hideTip();
        });

    }

    setLabelsRegions(options?: any){

        var _this = this;

        options = options || _this.options.labelsRegions;
        options.on != undefined && (options.on = MapSVG.parseBoolean(options.on));
        $.extend(true, _this.options, {labelsRegions: options});

        if(_this.options.labelsRegions.on){
            _this.regions.forEach(function (region) {
                if(!region.textLabel){
                    region.textLabel = jQuery('<div class="mapsvg-region-label" />')[0];
                    $(_this.containers.scrollpane).append(region.textLabel);
                }
                try{
                    $(region.textLabel).html(_this.templates.labelRegion(region.forTemplate()));
                }catch (err) {
                    console.error('MapSVG: Error in the "Region Label" template');
                }

            });
            _this.labelsRegionsAdjustPosition();
        } else {
            _this.regions.forEach(function (region) {
                if(region.textLabel){
                    $(region.textLabel).remove();
                    region.textLabel = null;
                    delete region.textLabel;
                }
            });
        }
    }

    /**
     * Deletes Marker lables
     */
    deleteLabelsMarkers(){

        var _this = this;

        _this.markers.forEach(function (marker) {
            if(marker.textLabel){
                marker.textLabel.remove();
                marker.textLabel = null;
                delete marker.textLabel;
            }
        });
    }

    /**
     * Sets Marker labels
     * @param {object} options
     */
    setLabelsMarkers(options?: any){

        var _this = this;

        options = options || _this.options.labelsMarkers;
        options.on != undefined && (options.on = MapSVG.parseBoolean(options.on));
        $.extend(true, _this.options, {labelsMarkers: options});

        if(_this.options.labelsMarkers.on){
            _this.markers.forEach(function (marker) {
                if(!marker.textLabel){
                    marker.textLabel = jQuery('<div class="mapsvg-marker-label" data-object-id="'+marker.object.id+'"/>')[0];
                    $(_this.containers.scrollpane).append(marker.textLabel);
                }
                try{
                    $(marker.textLabel).html(_this.templates.labelMarker(marker.object));
                }catch (err) {
                    console.error('MapSVG: Error in the "Marker Label" template');
                }
            });
            _this.markersAdjustPosition();
        } else {
            _this.deleteLabelsMarkers();
        }
    }

    /**
     * Adds a layer to the map that may contain some objects.
     * @param {string} name - Layer name
     * @private
     */
    addLayer(name){

        var _this = this;

        _this.layers[name] = $('<div class="mapsvg-layer mapsvg-layer-'+name+'"></div>')[0];
        _this.containers.layers.appendChild(_this.layers[name]);
        return _this.layers[name];
    }

    /**
     * Returns Database
     * @returns {DatabaseService}
     * @example
     * var objects = mapsvg.getDatabase().getLoaded();
     * var object  = mapsvg.getDatabase().getLoadedObject(12);
     *
     * // Filter DB by region "US-TX". This automatically triggers markers and directory reloading
     * mapsvg.getDatabase().getAll({filters: {regions: "US-TX"}});
     */
    getDb(){
        var _this = this;
        return this.objects;
    }

    /**
     * Returns Regions database
     * @returns {DatabaseService}
     */
    getDbRegions(){
        var _this = this;
        return this.regions;
    }

    /**
     * Adds an SVG object as Region to MapSVG
     * @param {object} svgObject - SVG Object
     * @returns {Region}
     * @private
     */
    regionAdd(svgObject: SVGPathElement|SVGCircleElement|SVGEllipseElement|SVGRectElement|SVGPolygonElement|SVGPolylineElement){

        var _this = this;

        var region = new Region(svgObject, _this);
        region.setStatus(1);
        _this.regions.push(region);
        _this.regions.sort(function(a,b){
            return a.id == b.id ? 0 : +(a.id > b.id) || -1;
        });
        return region;
    }

    /**
     * Deletes a Region from the map
     * @param {string} id - Region ID
     * @private
     */
    regionDelete(id: string){

        if(this.regions.findById(id)){
            this.regions.findById(id).elem.remove();
            this.regions.delete(id);
        } else if ($('#'+id).length){
            $('#'+id).remove();
        }
    }
    /**
     * Reloads Regions from SVG file
     */
    reloadRegions (){

        var _this = this;

        _this.regions.clear();
        $(_this.containers.svg).find('.mapsvg-region').removeClass('mapsvg-region');
        $(_this.containers.svg).find('.mapsvg-region-disabled').removeClass('mapsvg-region-disabled');
        $(_this.containers.svg).find('path, polygon, circle, ellipse, rect').each(function(index){

            // @ts-ignore
            var elem = <SVGElement>this;

            if($(elem).closest('defs').length)
                return;
            if(elem.getAttribute('id')) {
                if(!_this.options.regionPrefix || (_this.options.regionPrefix && elem.getAttribute('id').indexOf(_this.options.regionPrefix)===0)){
                    var region = new Region(elem, _this);
                    _this.regions.push(region);
                }
            }
            // if($(this).css('stroke-width')){
            //     $(this).data('stroke-width', $(this).css('stroke-width').replace('px',''));
            // }
        });
        // _this.regions.sort(function(a,b){
        //     return a.id == b.id ? 0 : +(a.id > b.id) || -1;
        // });
        // _this.regions.forEach(function(region, index){
        //     _this.regionsDict[region.id] = index;
        // });
    }
    /**
     * Reloads Regions data
     */
    reloadRegionsFull (){

        var _this = this;

        var statuses = _this.regionsRepository.getSchema().getFieldByType('status');

        _this.regions.forEach(function(region){
            let _region: CustomObject;
            _region = <CustomObject>_this.regionsRepository.getLoaded().findById(region.id);

            if(_region){
                region.setData(_region);
                if(statuses && _region.status !== undefined && _region.status!==null){
                    region.setStatus(_region.status);
                }
            } else {
                if(_this.options.filters.filteredRegionsStatus || _this.options.filters.filteredRegionsStatus === 0){
                    region.setStatus(_this.options.filters.filteredRegionsStatus);
                }
            }
        });

        /*
_this.regionsRepository.getLoaded().forEach(function(object){
    var region = _this.getRegion(object.id);
    if(region){
        region.data = object;
        if(statuses && object.status !== undefined && object.status!==null){
            region.setStatus(object.status);
            // _this.setRegionStatus(region, object.status);
        }
    }
});
 */

        _this.loadDirectory();
        _this.setChoropleth();
        _this.setLayersControl();
        _this.setGroups();
        if(_this.options.labelsRegions.on){
            _this.setLabelsRegions();
        }
    }

    /**
     * Fix "fit markers" view world screen offset
     * @private
     */
    fixMarkersWorldScreen (){
        var _this = this;

        if(_this.googleMaps.map) setTimeout(function(){
            var markers = {left: 0, right: 0};
            if(_this.markers.length > 1){
                _this.markers.forEach(function(m){
                    if(m.node.offset().left < ($(_this.containers.map).offset().left + $(_this.containers.map).width() / 2)){
                        markers.left++;
                    }else{
                        markers.right++;
                    }
                });

                if(markers.left === 0 || markers.right === 0){
                    var k = markers.left === 0 ? 1 : -1;
                    var ww = ((_this.svgDefault.viewBox.width / _this.mapLonDelta) * 360) * _this.getScale();
                    _this.googleMaps.map.panBy(k*ww,0);
                }
            }
        }, 400);
    }

    /**
     * Updates map options from old version of MapSVG
     * @param options
     * @private
     */
    updateOutdatedOptions(options){

        var _this = this;

        // Fix Directory options
        if(options.menu && (options.menu.position || options.menu.customContainer)){
            if(options.menu.customContainer){
                options.menu.location = 'custom';
            } else {
                options.menu.position = options.menu.position === 'left' ? 'left' : 'right';
                options.menu.location = options.menu.position ==='left' ? 'leftSidebar' : 'rightSidebar';
                if(!options.containers || !options.containers[options.menu.location]){
                    options.containers = options.containers || {};
                    options.containers[options.menu.location] = {on: false, width: '200px'};
                }
                options.containers[options.menu.location].width = options.menu.width;
                if(MapSVG.parseBoolean(options.menu.on)){
                    options.containers[options.menu.location].on = true;
                }
            }
            delete options.menu.position;
            delete options.menu.width;
            delete options.menu.customContainer;
        }
        // Fix Details View options
        if(options.detailsView && (options.detailsView.location === 'mapContainer' || options.detailsView.location === 'near' || options.detailsView.location === 'top')){
            options.detailsView.location = 'map';
        }
        // Transfer zoom options to controls options
        if(!options.controls){
            options.controls = {};
            options.controls.zoom = options.zoom && options.zoom.on && (!options.zoom.buttons || options.zoom.buttons.location!=='hide');
            options.controls.location = options.zoom && options.zoom.buttons && options.zoom.buttons.location!=='hide' ? options.zoom.buttons.location : 'right';
        }
        // Transfer zoom options to controls options
        if(options.colors && !options.colors.markers){
            options.colors.markers = {
                base:      {opacity:100, saturation: 100},
                hovered:   {opacity:100, saturation: 100},
                unhovered: {opacity:100,  saturation: 100},
                active:    {opacity:100, saturation: 100},
                inactive:  {opacity:100,  saturation: 100}
            };
        }
        if (options.tooltipsMode){
            options.tooltips.mode = options.tooltipsMode;
            delete options.tooltipsMode;
        }
        if (options.popover){
            options.popovers = options.popover;
            delete options.popover;
        }

    }

    /**
     * Initialization. Map rendering happens here. Gets called on map creation.
     * @param {MapOptionsInterface} options - Map options
     * @param {HTMLElement} elem
     * @returns {*}
     * @private
     */
    init(){

        var _this = this;

        if(this.options.source === '') {
            throw new Error('MapSVG: please provide SVG file source.');
            return false;
        }

        // Extensions:

        // 1. Create Element.remove() function if not exists
        if (!('remove' in Element.prototype)) {
            // @ts-ignore
            Element.prototype.remove = function() {
                if (this.parentNode) {
                    this.parentNode.removeChild(this);
                }
            };
        }

        // 2. Hypot
        // @ts-ignore
        Math.hypot = Math.hypot || function() {
            var y = 0;
            var length = arguments.length;

            for (var i = 0; i < length; i++) {
                if (arguments[i] === Infinity || arguments[i] === -Infinity) {
                    return Infinity;
                }
                y += arguments[i] * arguments[i];
            }
            return Math.sqrt(y);
        };

        // 2. SVG getTransformToElement
        // @ts-ignore
        SVGElement.prototype.getTransformToElement = SVGElement.prototype.getTransformToElement || function(toElement) {
            return toElement.getScreenCTM().inverse().multiply(this.getScreenCTM());
        };
        
        this.setEvents(this.options.events);

        this.events.trigger('beforeLoad');

        this.setCss();

        // Set background
        this.containers.map.classList.add('mapsvg', 'no-transitions');
        if(this.options.colors && this.options.colors.background){
            this.containers.map.style.background = this.options.colors.background;
        }

        // _this.disableMarkersAnimation();

        this.setContainers(_this.options.containers);
        this.setColors();

        // _this.$ratio = $('<div class="mapsvg-ratio"></div>');
        // _this.$ratio.insertBefore($(_this.containers.map));
        // _this.$ratio.append($(_this.containers.map));

        this.containers.loading = document.createElement('div');
        this.containers.loading.className = 'mapsvg-loading';
        this.containers.loading.innerHTML = this.options.loadingText;

        this.containers.map.appendChild(this.containers.loading);

        this.addLayer('markers');
        this.addLayer('popovers');

        $(_this.containers.loading).css({
            'margin-left' () {
                return -($(this).outerWidth(false) / 2)+'px';
            },
            'margin-top' () {
                return -($(this).outerHeight(false) / 2)+'px';
            }
        });
        if(_this.options.googleMaps.on){
            $(_this.containers.map).addClass('mapsvg-google-map-loading');
        }

        // Load extension (common things)
        // @ts-ignore
        if(_this.options.extension && $().mapSvg.extensions && $().mapSvg.extensions[_this.options.extension]){
            // @ts-ignore
            var ext = $().mapSvg.extensions[_this.options.extension];
            ext && ext.common(_this);
        }

        // Determine if the map needs to be saved after the init
        let saveNeeded = false;

        // GET the map by ajax request
        $.ajax({url: _this.options.source+'?v='+_this.svgFileLastChanged}).fail(function(resp){
            if(resp.status == 404){
                var msg = 'MapSVG: file not found - '+_this.options.source+'\n\nIf you moved MapSVG from another server please read the following docs page: https://mapsvg.com/docs/installation/moving';
                if(_this.editMode) {
                    msg += '\n\nIf you know the correct path for the SVG file, please write it and press OK:';
                    let oldSvgPath =  _this.options.source;
                    let userSvgPath = prompt(msg, oldSvgPath);
                    if (userSvgPath !== null){
                        $.ajax({url: userSvgPath+'?v='+_this.svgFileLastChanged})
                            .fail(function () {
                                location.reload();
                            })
                            .done(function (xmlData) {
                                saveNeeded = true;
                                _this.options.source = userSvgPath;
                                mapRender(xmlData);
                            });
                    }
                    else {
                        location.reload();
                    }
                } else {
                    console.error(msg);
                }
            } else {
                var msg = 'MapSVG: can\'t load SVG file for unknown reason. Please contact support: https://mapsvg.ticksy.com';
                if(_this.editMode) {
                    alert(msg);
                } else {
                    console.error(msg);
                }
            }
        }).done(function(xmlData){
            mapRender(xmlData);
        });

        function mapRender(xmlData) {
            // Default width/height/viewBox from SVG
            var svgTag               = $(xmlData).find('svg');
            _this.containers.svg     = svgTag[0];

            if(svgTag.attr('width') && svgTag.attr('height')){
                _this.svgDefault.width   = parseFloat(svgTag.attr('width').replace(/px/g,''));
                _this.svgDefault.height  = parseFloat(svgTag.attr('height').replace(/px/g,''));
                _this.svgDefault.viewBox = svgTag.attr('viewBox') ? new ViewBox(svgTag.attr('viewBox').split(' ')) : new ViewBox(0,0, _this.svgDefault.width, _this.svgDefault.height);
            }else if(svgTag.attr('viewBox')){
                _this.svgDefault.viewBox = new ViewBox(svgTag.attr('viewBox').split(' '));
                _this.svgDefault.width   = _this.svgDefault.viewBox.width;
                _this.svgDefault.height  = _this.svgDefault.viewBox.height;
            }else{
                var msg = 'MapSVG: width/height and viewBox are missing in the SVG file. Can\'t parse the file because of that.';
                if(_this.editMode){
                    alert(msg);
                } else {
                    console.error(msg);
                }
                return false;
            }
            // Get geo-coordinates view  box from SVG file
            var geo = svgTag.attr("mapsvg:geoViewBox") || svgTag.attr("mapsvg:geoviewbox");
            if (geo) {
                let geoParts = geo.split(" ").map(p => parseFloat(p));
                if (geoParts.length == 4){
                    _this.mapIsGeo = true;
                    _this.geoCoordinates = true;

                    let sw = new GeoPoint(geoParts[3], geoParts[0]);
                    let ne = new GeoPoint(geoParts[1], geoParts[2]);
                    _this.geoViewBox = new GeoViewBox(sw, ne);
                    _this.mapLonDelta = _this.geoViewBox.ne.lng - _this.geoViewBox.sw.lng;
                    _this.mapLatBottomDegree = _this.geoViewBox.sw.lat * 3.14159 / 180;

                }

            }

            if(_this.options.viewBox && _this.options.viewBox.length==4){
                _this._viewBox = new ViewBox(_this.options.viewBox);
            } else {
                _this._viewBox = new ViewBox(_this.svgDefault.viewBox);
            }

            svgTag.attr('preserveAspectRatio','xMidYMid meet');
            svgTag.removeAttr('width');
            svgTag.removeAttr('height');

            //// Adding moving sticky draggable image on background
            //if(_this.options.scrollBackground)
            //    _this.background = _this.R.rect(_options.filtersSchema = _this.filtersSchemathis.svgDefault.viewBox.x,_this.svgDefault.viewBox.y,_this.svgDefault.viewBox.width,_this.svgDefault.viewBox.height).attr({fill: _this.options.colors.background});

            _this.reloadRegions();

            $(_this.containers.scrollpane).append(svgTag);


            // Set size
            _this.setSize(_this.options.width, _this.options.height, _this.options.responsive);


            if(_this.options.disableAll){
                _this.setDisableAll(true);
            }



            // Set viewBox
            _this.setViewBox(_this._viewBox);
            _this.setResponsive(_this.options.responsive);


            // var markers = _this.options.markers || _this.options.marks || [];
            // _this.setMarkers(markers);

            _this.setScroll(_this.options.scroll, true);

            _this.setZoom(_this.options.zoom);

            _this.setControls(_this.options.controls);
            _this.setGoogleMaps();

            _this.setTooltips(_this.options.tooltips);
            _this.setPopovers(_this.options.popovers);

            if(_this.options.cursor)
                _this.setCursor(_this.options.cursor);

            _this.setTemplates(_this.options.templates);


            // Load extension (frontend things)
            // @ts-ignore
            if(!_this.options.backend && _this.options.extension &&  $().mapSvg.extensions &&  $().mapSvg.extensions[_this.options.extension]){
                //@ts-ignore
                var ext = $().mapSvg.extensions[_this.options.extension];
                ext && ext.frontend(_this);
            }

            _this.filtersSchema = new Schema({fields: _this.options.filtersSchema});

            // Load data from Database and finish loading
            // _this.objectsRepository = new MapSVG.DatabaseService({
            //     map_id    : _this.id,
            //     perpage   : _this.options.database.pagination.on ? _this.options.database.pagination.perpage : 0,
            //     sortBy    : _this.options.menu.source == 'database' ? _this.options.menu.sortBy : 'id',
            //     sortDir   : _this.options.menu.source == 'database' ?_this.options.menu.sortDirection : 'desc',
            //     table     : 'database'
            // }, _this);
            // _this.events['databaseLoaded'] && _this.objectsRepository.events.on('dataLoaded', _this.events['databaseLoaded']);

            // _this.firstDataLoad = true;
            _this.objectsRepository.events.on('loaded', function(){
                _this.fitOnDataLoadDone = false;
                _this.addLocations();
                _this.fixMarkersWorldScreen();
                // _this.addDataObjectsAsMarkers();
                _this.attachDataToRegions();
                _this.loadDirectory();
                if(_this.options.labelsMarkers.on){
                    _this.setLabelsMarkers();
                }
                // Check if there's a call to "{{objects}}" inside of the labelRegion template
                // and if it's found then reload Region Labels
                if(_this.options.templates.labelRegion.indexOf('{{objects') !== -1){
                    _this.setLabelsRegions();
                }
                if(_this.options.filters.on && _this.options.filters.source === 'database' && _this.controllers.filters && _this.controllers.filters.hideFilters){
                    _this.controllers.filters.setFiltersCounter();
                }
                _this.events.trigger('dataLoaded');

                _this.updateFiltersState();
                _this.setChoropleth();
            });
            _this.objectsRepository.events.on('schemaChanged', function () {
                _this.objectsRepository.reload();
            });
            _this.objectsRepository.events.on('updated', function(obj){
                _this.attachDataToRegions(obj);
                _this.reloadRegionsFull();
            });
            _this.objectsRepository.events.on('created', function(obj){
                _this.attachDataToRegions(obj);
                _this.reloadRegionsFull();
            });
            _this.objectsRepository.events.on('deleted', function(id){
                _this.attachDataToRegions();
                _this.reloadRegionsFull();
            });

            _this.regionsRepository.events.on('loaded', function(){
                _this.reloadRegionsFull();
                if(_this.options.filters.on && _this.options.filters.source === 'regions' && _this.controllers.filters && _this.controllers.filters.hideFilters){
                    _this.controllers.filters.setFiltersCounter();
                }
                _this.events.trigger('regionsLoaded');
            });
            _this.regionsRepository.events.on('updated', function(regionData){
                _this.reloadRegionsFull();
            });
            _this.regionsRepository.events.on('created', function(regionData){
                _this.reloadRegionsFull();
            });
            _this.regionsRepository.events.on('deleted', function(regionData){
                _this.reloadRegionsFull();
            });


            _this.setMenu();
            _this.setFilters();

            if(_this.options.menu.filterout.field){
                var f = {};
                f[_this.options.menu.filterout.field] = _this.options.menu.filterout.val;
                if(_this.options.menu.source == 'regions'){
                    // _this.regionsRepository.query.setFilterOut(f);
                }else{
                    _this.objectsRepository.query.setFilterOut(f);
                }
            }

            _this.setEventHandlers();

            if(!_this.id){
                _this.final();
                return;
            }

            if(!_this.options.data_regions || !_this.options.data_objects){
                _this.regionsRepository.find().done(function(regions){
                    if(_this.options.database.loadOnStart || _this.editMode){
                        _this.objectsRepository.find().done(function (data) {
                            _this.final();
                        });
                    } else {
                        _this.final();
                    }
                });
            } else {
                _this.regionsRepository.loadDataFromResponse(_this.options.data_regions);
                if(_this.editMode || _this.options.database.loadOnStart){
                    _this.objectsRepository.loadDataFromResponse(_this.options.data_objects);
                }
                delete _this.options.data_regions;
                delete _this.options.data_objects;
            }

            _this.final();

            if (saveNeeded === true){
                let mapsRepo = new MapsRepository();
                mapsRepo.update(_this);
            }
        } // end of SVG LOAD AJAX

        return _this;

    }
    /**
     * Final stage of initialization.
     * Initialization is split into 2 steps because the 1st step contains async ajax request.
     * When the ajax requires is done, the final initialization step is called.
     * @private
     */
    final(){

        var _this = this;

        if(_this.options.googleMaps.on && !_this.googleMaps.map){
            _this.events.on('googleMapsLoaded',function(){
                _this.final();
            });
            return;
        }

        // Select region from URL
        let match = RegExp('[?&]mapsvg_select=([^&]*)').exec(window.location.search);
        if(match){
            var select = decodeURIComponent(match[1].replace(/\+/g, ' '));
            _this.selectRegion(select);
        }
        if(window.location.hash){
            var query = window.location.hash.replace('#/m/','');
            var region = _this.getRegion(query);
            if(region && _this.options.actions.map.afterLoad.selectRegion){
                _this.regionClickHandler(null, region);
                // mapsvg.selectRegion(id);
                // check actions, do them
                // mapsvg.loadDetailsView(region);
                // if menu is on, select menu items
                // mapsvg.getData().controllers.directory.selectItems(id);
            } else {
                // pass page number to #! like this: #!{query:{},
            }
        }

        setTimeout(function(){
            _this.updateSize();
            setTimeout(function() {
                $(_this.containers.map).removeClass('no-transitions');
            },200);
        },100);


        _this.events.trigger('afterLoad');

        $(_this.containers.loading).hide();
        MapSVG.addInstance(_this);
    }

    createForm(options){
        return new FormBuilder(options);
    }
    getApiUrl(path): string {
        var server = new Server();
        return server.getUrl(path);
    }
}

export {
    MapSVGMap as map,
    MapSVGMap as MapSVGMap,
    MapsRepository as mapsRepository,
    MapsV2Repository as mapsV2Repository,
    Repository as repository,
    SchemaRepository as schemaRepository,
    MapSVG as globals,
    Marker as marker,
    Location as location,
    Server  as server,
    ArrayIndexed as arrayIndexed,
    Schema as schema,
    ScreenPoint as screenPoint,
    SVGPoint as svgPoint,
    GeoPoint as geoPoint
};